<template>
    <div class="basket">
        <div class="basket-headline">
            <h2 v-if="tourHeadline.startDate">
                {{ tourPlaceInfo}}
                <span class="tour-name">{{ tourHeadline.name }}</span>
                <span> – {{ tourDateInfo }}</span>
            </h2>
            <bread-crumbs class="mt-6"
                          :items="breadCrumbs"
                          @change="changeBreadCrumbs($event)" />
        </div>
        <div v-show="!GDSReady"
             :class="['basket-content-wrap', {'small': windowWidth <= 1400}]">
            <div class="basket-content">
                <!--Блок проживания-->
                <div ref="residence">
                    <residence v-if="showResidence && residence.length"
                               :residence="residence"
                               :show="residenceShow"
                               :brutto="getBrutto"
                               :outHotelCalculateData="outHotelCalculateData"
                               :bookingAdditionalInfo="bookingAdditionalInfo"
                               :tourRate="tourRate"
                               :columnCount="residenceColumnCount"
                               :MetapolicyExtraInfo="MetapolicyExtraInfo"
                               @updateColumns="updateColumns($event)"
                               @roundFoodPrice="roundFoodPrice($event)"
                               @foodSlideLeft="foodSlideLeft($event)"
                               @foodSlideRight="foodSlideRight($event)"
                               @setFood="setFood(...$event)"
                               @rightModalHotelInfo="rightModalHotelInfo(...$event)"
                               @alertShow="alertShow(...$event)"
                               @toggle="residenceShow = $event" />
                </div>

                <!--Блок авиаперелет-->
                <div ref="flight">
                    <flight :show="flightShow"
                            :tour="tour"
                            :flight="flight"
                            :flightData="flightData"
                            :tourCardData="tourCardData"
                            :showFlightEditBtn="showFlightEditBtn"
                            :flightChanged="flightChanged"
                            :toFlightMounted="toFlightMounted"
                            :universalParametrs="universalParametrs"
                            :tourists="[adultCount, childCount]"
                            @showDetails="showDetails($event)"
                            @rightModalAviaFlight="rightModalAviaFlight($event)"
                            @changeFlightClass="changeFlightClass(...$event)"
                            @changeFlight="changeFlight($event)"
                            @toFlight="toFlight()"
                            @toggle="flightShow = $event"
                            @reset="resetFlight()" />
                </div>

                <!--Блок доплат к а/п-->
                <div ref="flightSurcharge">
                    <flight-surcharge :show="flightSurchargeShow"
                                      :flightSurcharge="flightSurcharge"
                                      :tourCardData="tourCardData"
                                      @checkedFlightSurcharge="checkedFlightSurcharge(...$event)"
                                      @toggle="flightSurchargeShow = $event" />
                </div>

                <!--Блок автобусных переездов-->
                <div ref="bus">
                    <bus :show="busShow"
                         :busTransfer="busTransfer"
                         :busData="busData"
                         :tourCardData="tourCardData"
                         :tourists="[adultCount, childCount]"
                         @rightModalBusInfo="rightModalBusInfo($event)"
                         @changeBus="changeBus($event)"
                         @changeBusType="changeBusType(...$event)"
                         @toggle="busShow = $event" />
                </div>

                <!--Блок ж/д переездов-->
                <div ref="railway">
                    <railway :show="railwayShow"
                             :railwayTransfer="railwayTransfer"
                             :railwayData="railwayData"
                             :tourCardData="tourCardData"
                             :tourists="[adultCount, childCount]"
                             @rightModalRailwayInfo="rightModalRailwayInfo($event)"
                             @changeRailway="changeRailway($event)"
                             @changeRailwayType="changeRailwayType(...$event)"
                             @toggle="railwayShow = $event" />
                </div>

                <!--Блок трансферов-->
                <div ref="transfer">
                    <transfer :show="transferShow"
                              :transfer="transfer"
                              @rightModalTransferInfo="rightModalTransferInfo($event)"
                              @changeTransfer="changeTransfer(...$event)"
                              @checkedTransfer="checkedTransfer(...$event)"
                              @toggle="transferShow = $event" />
                </div>

                <!--Блок экскурсии-->
                <div ref="excursion">
                    <excursion :show="excursionShow"
                               :excursion="excursion"
                               @changeExcursion="changeExcursion(...$event)"
                               @changeExcursionValue="changeExcursionValue(...$event)"
                               @changeExcursionValue2="changeExcursionValue2(...$event)"
                               @checkedExcursion="checkedExcursion(...$event)"
                               @toggle="excursionShow = $event" />
                </div>

                <!--Блок доп. услуг-->
                <div ref="additionalServices">
                    <additional-services :show="additionalServicesShow"
                                         :showAdditionalServicesBlock="showAdditionalServicesBlock"
                                         :additionalServices="additionalServices"
                                         @changeAdditionalServices="changeAdditionalServices(...$event)"
                                         @changeAddintionalDetail="changeAddintionalDetail(...$event)"
                                         @changeAddintionalDetail2="changeAddintionalDetail2(...$event)"
                                         @checkedAdditionalService="checkedAdditionalService(...$event)"
                                         @toggle="additionalServicesShow = $event" />
                </div>

                <div ref="trevelerData">
                    <traveler :show="trevelerDataShow"
                              :treveler-form="trevelerForm"
                              :treveler-info="trevelerInfo"
                              :tour="tour"
                              :tour-rate="tourRate"
                              :visa-value="visaValue"
                              :visa-items="visaItems"
                              :insurance-value="insuranceValue"
                              :insurance-items="insuranceItems"
                              :treveler-gender="trevelerGender"
                              :citizenship-list="citizenshipList"
                              @getListByCode="getListByCode($event)"
                              @getLoadItemsByCode="getLoadItemsByCode($event)"
                              @loadMoreItemsByCode="loadMoreItemsByCode($event)"
                              @setListByCode="setListByCode($event)"
                              @changeHotelService="changeHotelService(...$event)"
                              @changeTrevelerVisa="changeTrevelerVisa(...$event)"
                              @changeTrevelerService="changeTrevelerService(...$event)"
                              @translit="translit(...$event)"
                              @trevelerValidation="trevelerValidation(...$event)"
                              @toggle="trevelerDataShow = $event" />
                </div>

                <div ref="dogovorComment">
                    <dogovor-comment :show="dogovorCommentShow"
                                     @toggle="dogovorCommentShow = $event"
                                     @input="dogovorComment = $event" />
                </div>

                <div ref="buyerDetails" v-show="getWindowSettings.showBuyerDetails && isAuthenticated && userInfo.UserType === 0">
                    <buyerDetails :citizenshipList="citizenshipList" 
                                  :treveler-info="trevelerInfo" 
                                  @buyerData="customerData = $event"
                                  @get-countries="setListByCode($event)" />
                </div>

                <bottom-buy-card v-show="windowWidth <= 1400"
                                 :card-data="tourCardData"
                                 :tour="tour"
                                 :residence="residence"
                                 :tour-headline="tourHeadline"
                                 :card-loader-status="cardLoaderStatus"
                                 :tour-booking="tourBookingHTML"
                                 :has-tour-image="!!tourImages.length"
                                 :offer-link="offerAgreement"
                                 :terms-tariffs="termsTariffs"
                                 :submitting-agree-privacy-policy="submittingAgreePrivacyPolicy"
                                 @buyTour="buyTour()"
                                 @rightModalBooking="rightModalBooking()" />
            </div>
            <!--Карточка покупки(справа)-->
            <buy-card :show="cardShow"
                      :openCard="openCard"
                      :windowWidth="windowWidth"
                      :adultCount="adultCount"
                      :childCount="childCount"
                      :tourCardData="tourCardData"
                      :tour="tour"
                      :residence="residence"
                      :tour-headline="tourHeadline"
                      :branches="branches"
                      :managers="managers"
                      :userInfo="userInfo"
                      :showNationalPrice="showNationalPrice"
                      :hoodedServices="hoodedServices"
                      :trevelerForm="trevelerForm"
                      :isAuthenticated="isAuthenticated"
                      :showComission="showComission"
                      :cardLoaderStatus="cardLoaderStatus"
                      :touristValidStatus="touristValidStatus"
                      :tourBookingHTML="tourBookingHTML"
                      :has-tour-image="!!tourImages.length"
                      :offer-link="offerAgreement"
                      :terms-tariffs="termsTariffs"
                      :submitting-agree-privacy-policy="submittingAgreePrivacyPolicy"
                      :iAgreeToReceiveVisible="settings.IAgreeToReceiveMessages"
                      :out-hotel-calculate-data="outHotelCalculateData"
                      @buyTour="buyTour($event)"
                      @changeBranch="changeBranch($event)"
                      @rightModalBooking="rightModalBooking()"
                      @toggleCard="openCard = !openCard"
                      @toggleComission="showComission = !showComission"
                      @changeClientAgree="clientAgree = $event"
                      @alertShow="alertShow(...$event)"
                      @scrollToBlock="scrollToBlock($event)"
                      @applyPromoOrDiscount="applyPromoOrDiscount($event)" />
        </div>
        <avia-flight v-if="routeFlight"
                     v-show="GDSReady"
                     :tour="tour"
                     :openOfMounted="toFlightMounted"
                     :selected-flight=" flight[flightData.selected]"
                     :tour-short-info="tourHeadline"
                     :flight-changed="flightChanged"
                     @NoTicketsError="showModalLoadAnotherAirTAriff"
                     @changeFlight="showModalChangeFlight($event)"
                     :tariff-changed = "changedTariff" />

        <!--Модальное окно(появляется справа)-->
        <right-modal :show="showRightModal"
                     :class="{'booking': rigthModalType === 'tourBooking'}"
                     @toggle="showRightModal = $event">
            <div v-if="rigthModalType === 'tourBooking'" class="tour-booking">
                <h3 class="tour-booking-name mb-7">{{ selectedTourName }}</h3>

                <h5 class="tour-booking-headline">{{ localizeList.tourBookingConditions }}</h5>

                <large-slider v-if="tourImages.length"
                              class="mb-10 pb-4"
                              :images="tourImages"
                              :images-description="tourImagesDescription" />

                <p v-html="tourBookingHTML"></p>
            </div>

            <!--Иформация о отеле-->
            <div v-if="rigthModalType === 'hotelInfo'" class="tour-hotel-info">
                <div class="hotel-info-header mb-8">
                    <div class="hotel-info-header-block hotel-info-header-title">
                        <div class="hotel-name-wrap flex">
                            <h3 class="hotel-name">
                                <a v-if="hotelInfo.http" :href="hotelInfo.http" target="_blank">
                                    {{ hotelInfo.data.hotelName }}
                                    {{ typeof hotelInfo.data.hotelStars === "string" ? hotelInfo.data.hotelStars : "" }}
                                </a>
                                <span v-else>
                                    {{ hotelInfo.data.hotelName }}
                                    {{ typeof hotelInfo.data.hotelStars === "string" ? hotelInfo.data.hotelStars : "" }}
                                </span>
                            </h3>
                            <div v-if="typeof hotelInfo.data.hotelStars === 'number'" class="hotel-stars flex">
                                <div v-for="(item, key) in hotelInfo.data.hotelStars" :key="key">
                                    <svg width="14px" height="14px" fill="var(--yellow-color)">
                                        <use xlink:href="../../assets/images/sprite.svg#star"></use>
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div class="place align-center">
                            <svg class="mr-6" width="14px" height="14px" fill="var(--lighten-7-color)">
                                <use xlink:href="../../assets/images/sprite.svg#map-icon"></use>
                            </svg>
                            <p class="ligth-grey-text-small">
                                {{ hotelInfo.data.hotelCity }},
                                {{ hotelInfo.data.hotelCountry }}
                            </p>
                            <p class="ligth-grey-text-small hotel-time-info">
                                {{ getHotelTimeInfo() }}
                            </p>
                        </div>

                        <div v-show="getBrutto.length" class="mt-3 align-center">
                          <svg @click="alertShow(hotelInfo.key, outHotelCalculateData[hotelInfo.key].find(x => x.AdditionalInfo) ? 5000 : 0)"
                              class="mr-4 pointer"
                              width="18px" height="18px" fill="var(--primary-color)">
                              <use xlink:href="../../assets/images/sprite.svg#info"></use>
                          </svg>
                          <span v-html="getBrutto[hotelInfo.key]" class="standard-text-small"></span>
                      </div>
                    </div>

                    <div class="hotel-info-header-block hotel-info-header-price">
                      <div class="main-price">
                          <div class="hotel-price text-end">
                              {{ correctPrice(tourCardData.totalPrice) }}
                              {{ getCurrencyDisplayBySettings(tourCardData.tourCurrency) }}
                          </div>
                          <p v-show="showNationalPrice" class="grey-text text-end nowrap">
                              {{ correctPrice(tourCardData.nationalPrice) }}
                              {{ getCurrencyDisplayBySettings(tourCardData.nationalCurrency) }}
                          </p>
                      </div>

                      <div @click="changeHotelInfoNavbar(-1)"
                             :class="['blue-text-small pointer',{'text-focus': hotelInfo.activeItem === null}]">
                            {{ localizeList.variants }}
                      </div>
                    </div>

                    <pdf-generate-button v-if="hotelInfo" :hotel="hotelInfo" />
                </div>

                <!--Навигация по информации отеля-->
                <div class="hotel-info-navbar flex mb-8 align-center">
                    <div v-for="(item, key) in hotelInfo.nav"
                         :key="key"
                         @click="changeHotelInfoNavbar(key)"
                         :class="['nav-item', 'mr-8', {'active': hotelInfo.activeItem === key}]">
                        {{ item }}
                    </div>
                </div>
                <!--                @scroll="scrollHotelInfoContent($event)"-->
                <div ref="hotelInfoContent" class="hotel-info-content">

                    <!--Слидер скартинками отеля-->
                    <div class="hotel-info-slider">
                        <div class="present-slider mb-6">
                            <div ref="hotelInfoSlide" class="slide"></div>

                            <template v-if="showHotelSliderIcons()">
                                <div @click="hotelImageSlide('left')" class="slider-left-btn pointer">
                                    <svg width="20px" height="28px" fill="var(--lighten-7-color)">
                                        <use xlink:href="../../assets/images/sprite.svg#angle"></use>
                                    </svg>
                                </div>
                                <div @click="hotelImageSlide('right')" class="slider-right-btn pointer">
                                    <svg width="20px" height="28px" fill="var(--lighten-7-color)">
                                        <use xlink:href="../../assets/images/sprite.svg#angle"></use>
                                    </svg>
                                </div>
                            </template>
                        </div>

                        <div v-show="hotelInfo.imagesTextDescription[hotelInfo.sliderPosition]"
                             :title="hotelInfo.imagesTextDescription[hotelInfo.sliderPosition]"
                             class="mt-4 mb-4 standard-500-text ellipsis"
                             style="height: 18px;">
                            {{ hotelInfo.imagesTextDescription[hotelInfo.sliderPosition] }}
                        </div>
                        <div v-show="!hotelInfo.imagesTextDescription[hotelInfo.sliderPosition]" class="mt-4 mb-4"
                             style="height: 18px;"></div>

                        <!--Вторичный слидер картинок отеля-->
                        <div ref="secondSlider"
                             @mousedown="startDragSecondSlider($event)"
                             @mousemove="doDragSecondSlider($event)"
                             class="second-slider">
                            <div v-for="(item, key) in hotelInfo.images"
                                 :key="key"
                                 @click="hotelImageSlide(key)"
                                 :style="{backgroundImage: `url('${item}')`}"
                                 :class="['second-slide',{'active': hotelInfo.sliderPosition === key}]">
                            </div>
                        </div>
                        3333333
                        <div class="hotel-features">
                            <div v-for="(item, key) in hotelInfo.data.hotelFeatures"
                                 :key="key"
                                 class="hotel-features-item align-center">
                                <img width="20px" height="20px" :src="item.src"
                                     class="hotel-type-icon mr-8" />
                                <p class="dark-small-text">{{ item.text }}</p>
                            </div>
                            {{ hotelInfo.data.hotelFeatures }}
                        </div>
                    </div>
                    <div v-for="(item, key) in hotelInfo.moreInfo"
                         :key="key"
                         ref="hotelInfoItem"
                         class="hotel-info-content-item">
                        <h4 :class="['dark-big-text',{'active': hotelInfo.activeItem === key + 1}]">
                            {{ item.title }}
                        </h4>
                        <div v-if="item.isContact">
                            <template v-if="!settings.DoNotShowHotelDetails">
                                <p v-if="item.address">
                                    {{ localizeList.addressUpper }}: {{ item.address }}
                                </p>
                                <p v-if="item.phone">
                                    {{ localizeList.phoneNumberUpper }}: {{ item.phone }}
                                </p>
                                <p v-if="item.email">
                                    Почта: {{ item.email }}
                                </p>
                            </template>
                            <template v-else>
                                <p>
                                    {{ localizeList.addressUpper }}:
                                    {{ hotelInfo.data.hotelCity }},
                                    {{ hotelInfo.data.hotelCountry }}
                                </p>
                            </template>
                            <div v-if="hotelInfo.http" class="mt-4 mb-4">
                                <a :href="hotelInfo.http" class="blue-text"
                                   target="_blank">{{ localizeList.addHotelInformation }}</a>
                            </div>
                        </div>
                        <div v-else v-html="item.value" class="word-break"></div>
                    </div>
                    <div v-if="hotelInfo.data.coordinates && !isNaN(hotelInfo.data.coordinates[0])"
                          class="hotel-info-map-wrap mt-4"
                          style="height: 400px">
                        <tour-map @buyTour="buyTourMinPriceAndHotelSchem($event)"
                                  show-only-selected
                                  :rate="rate"
                                  :number="2"
                                  :focused="focusedMapItemInHotelInfo"
                                  :focusedInListView="focusedMapHotelInListView"
                                  :mapItems="getSelectedMapItem()" />
                    </div>
                    <div ref="hotelVariants" class="hotel-info-content-item">
                        <h4 :class="['dark-big-text',{'active': hotelInfo.activeItem === -1}]">
                            {{ localizeList.accommodationOptions }}
                        </h4>
                        <div v-for="(item2, key2) in buyList[hotelInfo.key]"
                             :key="key2"
                             class="tour-program-item"
                             :class="{ 'tour-program-qui-quo-item': getWindowSettings.showQuiQuoService }">
                            <div class="align-center">
                                <icon :name="getQuotaName(item2.quotaStatus)"
                                      class="mr-8"
                                      width="16px" height="16px" fill="var(--white-color)" />
                                <p class="standard-text-small">
                                    {{ item2.accomodationType + " / " + item2.roomCategory + " / " + item2.adult + " / " }}
                                </p>
                            </div>
                            <div class="align-center justify-between">
                                <p class="grey-text-small">
                                    {{
                        item2.pansion +
                        (item2.pansionAdditionalInfo != null ? " / " + item2.pansionAdditionalInfo : "")
                                    }}
                                    <span v-if="item2.hotelData.CriticalInfo"> / </span>
                                    <span v-if="item2.hotelData.CriticalInfo &&  item2.hotelData.CriticalInfo!='cancelWithNoPenalty'" class="red-text">{{ localizeList[item2.hotelData.CriticalInfo] }}</span>
                                </p>
                                <radio-btn :value="checkIsActiveModal(key2)"
                                           :class="{'hover': focusHotelVariantBtn === key2}"
                                           @change="changeFoodInModal(key2)">
                                    <span class="include" v-if="item2.selected">
                                        {{ localizeList.included }}
                                    </span>
                                    <span v-else>
                                        {{ getPlus(item2.viewCost) }} {{
                      item2.viewCost
                                        }} {{ getCurrencyDisplayBySettings(tourCardData.tourCurrency) }}
                                    </span>
                                </radio-btn>
                            </div>
                            <div v-if="getWindowSettings.showQuiQuoService" class="qui-quo-actions" @click.stop>
                                  <div class="qq-btn-place qui-quo-place" :data-value="getQuiQuoJSON(item2)">
                                  </div>
                            </div>
                        </div>
                        <div v-if="!buyList.length">
                            <p class="title">{{ localizeList.searchResultsAreExpired }}</p>
                        </div>
                        <div v-if="buyList.length" class="justify-end">
                            <base-button @click.native="changeFoodOfModal()"
                                         :background="focusHotelDoneBtn ? 'rgb(44 134 198)' : 'var(--primary-color)'"
                                         class="applay-btn">
                                {{ localizeList.applyUpper }}
                            </base-button>
                        </div>
                    </div>

                </div>
            </div>

            <!--Информация по авиа перелетам-->
            <avia-flight-info v-else-if="rigthModalType === 'aviaFlight'"
                              showFlightTypeIcon
                              :is-g-d-s="aviaFlightInfo.isGDS"
                              :avia-flight-selected-tariffs-name="aviaFlightInfo.tariffsName"
                              :avia-flight-selected-quota-status="aviaFlightInfo.quotaStatus"
                              :avia-flight-info="aviaFlightInfo" />

            <!--Информация по транспорту-->
            <transport-info v-else-if="rigthModalType === 'bus' || rigthModalType === 'railway' || rigthModalType === 'transfer'"
                            :type="rigthModalType"
                            :transport-info="transportInfo" />

        </right-modal>

        <base-alert background="var(--orange-color)">
            <template v-if="alertType === 'out-hotel-update'">
                <div @mouseover="alertShow(-1, 999999999, true)"
                     @mouseleave="alertShow(-1, 0, true)" class="alert-wrap relative">
                    <p class="standard-500-text">{{ taxInfoText }}</p>
                </div>
            </template>
            <template v-if="alertType === 'out-hotel'">
                <div @mouseover="alertShow(outHotelKey, 999999999)"
                     @mouseleave="alertShow(outHotelKey, 0)" class="alert-wrap relative">
                    <template v-if="outHotelCalculateData[outHotelKey]">
                        <p v-for="(item, key) in outHotelCalculateData[outHotelKey]"
                           :key="key"
                           class="standard-500-text">{{ item.AdditionalInfo }}</p>
                    </template>
                </div>
            </template>
            <template v-else-if="alertType === 'validation'">
                <div class="tourist-validation-alert">
                    <p class="standard-500-text">{{ localizeList.touristsDataValidNotifyText.slice(0, -1) }}</p>
                    <template  v-if="!hasAdultTourist && adultTouristsRequired">
                      <br />
                      <p class="standard-500-text">{{ localizeList.touristsAgeDataValidNotifyText.slice(0, -1) }}</p>
                    </template>
                </div>
            </template>
        </base-alert>
        <div v-if="isNoTour" class="old-tour-error error-wrap">
            <div class="server-off">
                <h3 class="error-text">
                    {{ localizeList.dateIsNoTour }}
                </h3>
                <span @click="toSearch()" class="to-search">{{ localizeList.searchUpper }}</span>
            </div>
        </div>
        <div v-if="oldTour" class="old-tour-error error-wrap">
            <div class="server-off">
                <h3 class="error-text">
                    {{ localizeList.dataIsExpired }}
                </h3>
                <span @click="toSearch()" class="to-search">{{ localizeList.searchUpper }}</span>
            </div>
        </div>
        <load-another-air-tariff 
          @closeModal = "showAnotherAirTariffModal=false"  
          :showP="showAnotherAirTariffModal"
          :tariffP="stringValueTariffForModal"
          :type="modalType"
          :flightData="flightDataForModal"
          @eventModal="eventModalHandler($event)"
          @searchByChangedTariff="searchByChangedTariffAviaFlight">
        </load-another-air-tariff>
        
    </div>
</template>

<script>
import {bus} from '../../main'
import moment from 'moment'
import Vue from 'vue'

import * as typesGlobal from "@/stores/types";
import * as typesBasket from "@/stores/modules/basket/types";
import * as mTypesCommon from "@/stores/modules/common/mutation_types";
import * as typesTour from "@/stores/modules/tour/types";
import * as GTM from "@/plugins/GTM.js";

import aviaFlight from "./aviaFlightOld3";
import aviaFlightInfo from "../tour/serviceInfo/aviaFlightInfo";
import residence from "./blocks/residence";
import flight from "./blocks/flight";
import tourMap from "../tour/tourMap";
import FlightSurcharge from "./blocks/flightSurcharge";
import Bus from "./blocks/bus";
import Transfer from "./blocks/transfer";
import Excursion from "./blocks/excursion";
import AdditionalServices from "./blocks/additionalServices";
import BuyCard from "./blocks/buyCard";
import transportInfo from "../tour/serviceInfo/transportInfo";
import breadCrumbs from "../baseComponents/breadCrumbs";
import bottomBuyCard from "./blocks/bottomBuyCard";
import Railway from "./blocks/railway";

import {fullCopy, getLocalTimeLimit} from "../../plugins/methods";
import LargeSlider from "../tour/tourResult/LargeSlider";
import Traveler from "./blocks/traveler";
import DogovorComment from "@/views/basket/blocks/dogovorComment";
import loadAnotherAirTariff from "./loadAnotherAirTariff";
import buyerDetails from './blocks/buyerDetails/buyerDetails.vue'

export default {
  name: "basket",
  components: {
    DogovorComment,
    Traveler,
    transportInfo,
    Railway,
    LargeSlider,
    bottomBuyCard,
    breadCrumbs,
    BuyCard,
    AdditionalServices,
    Excursion,
    Transfer,
    Bus,
    FlightSurcharge,
    flight,
    residence,
    aviaFlightInfo,
    aviaFlight,
    tourMap,
    "load-another-air-tariff" : loadAnotherAirTariff,
    buyerDetails
  },
  data() {
    return {
      API_ORIGIN: this.$store.getters['getApiOrigin'],
      PATH: this.$store.getters['getPath'],
      tour: null,
      termsTariffs: '',
      submittingAgreePrivacyPolicy: '',
      breadCrumbs: [],
      readyForCalculate: false,
      dogovorComment: "",
      tourCardData: {
        totalPrice: "",
        nationalPrice: "",
        price: null,
        currency: "",
        nationalCode: "",
        serviceTourists: [],
        requiredServices: [],
        additionalServices: [],
        totalDiscount: 0,
        nationalTotalDiscount: 0,
        tourCurrency: {},
        nationalCurrency: {},
        beginDate: "",
        endDate: "",
        tourName: "",
        initialized: false
      },
      BookingHash:"",
      showAnotherAirTariffModal:false,
      stringValueTariffForModal:"economy",
      changedTariff:null,
      managers: {
        selected: 0,
        list: []
      },
      branches: {
        selected: 0,
        list: []
      },
      tourRate: "$",
      residenceShow: true,
      flightShow: true,
      flightSurchargeShow: true,
      busShow: true,
      railwayShow: true,
      transferShow: true,
      excursionShow: true,
      additionalServicesShow: true,
      trevelerDataShow: true,
      dogovorCommentShow: true,
      cardShow: false,
      openCard: false,
      selectedHotel: 0,
      partnerId: null,
      residence: [],
      residenceColumnCount: 3,
      flight: [],
      flightCash: [],
      universalParametrs: {
        tariffName: '',
        items: [],
        loader: false
      },
      flightSurcharge: [],
      busTransfer: [],
      railwayTransfer: [],
      transfer: [],
      excursion: [],
      additionalServices: [],
      showRightModal: false,
      rigthModalType: null,
      tourHeadline: {
        from: "",
        to: "",
        name: "",
        startDate: null,
        duration: null
      },
      isNoTour: false,
      hotelInfo: {
        http: null,
        nav: [],
        activeItem: 0,
        data: {},
        key: null,
        images: [],
        sliderPosition: 0,
        moreInfo: [],
        imagesTextDescription: []
      },
      focusHotelVariantBtn: null,
      focusHotelDoneBtn: false,
      aviaFlightInfo: {
        data: null,
        isGDS: false,
        services: [],
        class: [],
        tariffsName: [],
        quotaStatus: [],
      },
      transportInfo: [],
      buyList: [],
      test: 0,
      flightData: {
        selected: 0,
        placeFrom: "",
        placeTo: "",
      },
      busData: {
        selected: 0,
        placeFrom: "",
        placeTo: "",
      },
      railwayData: {
        selected: 0,
        placeFrom: "",
        placeTo: "",
      },
      trevelerForm: [],
      citizenshipList: [],
      citizinshipPage: 1,
      loadCitizenshipItems: true,
      trevelerInfo: [],
      trevelerGender: [],
      selectedTourName: "",
      tourBookingHTML: "",
      adultCount: null,
      childCount: null,
      isAuthenticated: false,
      cardLoaderStatus: false,
      services: [],
      tourists: [],
      routeFlight: false,
      GDSReady: false,
      showFlightEditBtn: false,
      oldTour: false,
      toFlightMounted: false,
      flightReady: false,
      flightChanged: false,
      visaValue: [],
      visaItems: [],
      insuranceValue: [],
      insuranceItems: [],
      hotelServices: [],
      outHotelCalculateData: [],
      bookingAdditionalInfo: [],
      outHotelKey: 0,
      showComission: false,
      windowWidth: window.innerWidth,
      userInfo: {},
      clientAgree: false,
      focusedMapItemInHotelInfo: null,
      notRouteServices: [],
      hoodedServices: [],
      buyTourFromRegistrationModal: false,
      buyTourFromRegistrationModalNoAuth: false,
      alertType: "",
      tourImages: [],
      tourImagesDescription: [],
      touristSettings: [],
      servicesSvKeyIdCategory: [],
      GTMProducts: [],
      firstTimeShowTax: true,
      hasAdultTourist: false,
      focusedMapHotelInListView: null,
      MetapolicyExtraInfo: {},
      modalType: 1,
      flightDataForModal: [],
      cashDiffDaysForAdditionalServices: 0,
      customerData: {},
      calculatedCountry: null,
      oldAges: [],
      originalsFlightsIndex: [0, 0],
      promocodeId: "",
      discountCardId: ""
    }
  },
  computed: {
    hasRemoteHotel() {
      return this.services.some(service => {
        return service.Service.ServiceType === 3 && !!service.Service.RemoteId
      })
    },
    adultTouristsRequired(){
      return window.settings.adultTouristsRequired
    },
    settings() {
      return this.$store.getters['getSettings'];
    },
    taxInfoText() {
      return this.firstTimeShowTax ? this.localizeList.taxInfo : this.localizeList.taxInfoUpdate
    },
    showResidence() {
      return this.residence.length === this.residence.filter(x => x).length
    },
    tourPlaceInfo() {
      return `${this.tourHeadline.from} ${this.tourHeadline.from ? "–" : ""} ${this.tourHeadline.to} ${this.tourHeadline.to ? "|" : ""}`
    },
    tourDateInfo() {
      return `${this.getDateByFormat(this.tourHeadline.startDate, 'DD MMM')} | ${this.tourHeadline.duration} ${this.localizeList.days}`
    },
    offerAgreement() {
      return window.settings.offerAgreement
    },
    showNationalPrice() {
      return parseInt(this.tourCardData.nationalPrice) !== this.tourCardData.totalPrice
    },
    showAdditionalServicesBlock() {
      let res = false;
      this.additionalServices.forEach(x => {
        if (x.isShow) res = true
      });
      return res
    },
    rate() {
      return this.$store.getters['getAllCurrency'].find(x => x.Code === this.tourRate)
    },
    mapItems() {
      return this.$store.getters['basket/getMapItems'].map((x) => {
        const hotel = x.Services.find(x2 => x2.SvKey === 3);
        if (hotel && hotel.Latitude && hotel.Longitude) {
          x.coordinates = [
            parseFloat(hotel.Latitude),
            parseFloat(hotel.Longitude)
          ];
        }

        return x
      });
    },
    getSettings() {
      return this.$store.getters['getSettings'];
    },
    getWindowSettings(){
      return window.settings
    },
    getBrutto() {
      let res = [];
      if (this.outHotelCalculateData.length) {
        this.outHotelCalculateData.forEach(x => {
          let text = "";
          x.forEach(x2 => {
            if (x2.Amount > 0) {
              text += this.localizeList.cancellationPolicyInfo
                  .replace("{0}", this.correctPrice(x2.Amount))
                  .replace("{1}", x2.Currency)
                  .replace("{2}", this.correctDate(x2.Date));
            } else if (x2.NmbrOfNights > 0) {
                text += this.localizeList.cancellationPolicyWithNights
                    .replace("{0}", this.correctPrice(x2.NmbrOfNights))
                    .replace("{1}", this.correctDate(x2.Date));
            }
            else {
              text += this.localizeList.cancellationPolicyWithoutPenaltyInfo
                  .replace("{0}", this.correctDate(x2.Date));
            }
          });

          if (text)
            res.push(text);
        });
      }

      return res
    },
    getCurrency() {
      let res = null;
      if (this.$store.getters['getAllCurrency']) {
        res = this.$store.getters['getAllCurrency']
      }
      return res
    },
    touristValidStatus() {
      let valid = true;
      this.trevelerInfo.forEach(x => {
        x.forEach(x2 => {
          if (x2.length) {
            x2.forEach(x3 => {
              if (x3.required && (!x3.isValid || x3.value === "")) {
                valid = false
              }
            })
          } else {
            if (x2.required && (!x2.isValid || x2.value === "")) {
              valid = false
            }
          }
        })
      });
      return valid
    }
  },
  created() {
    bus.$on('buyTour', () => {
      this.buyTourFromRegistrationModal = true;
    });
    bus.$on('buyTourNoRegistration', () => {
      this.buyTourFromRegistrationModalNoAuth = true;
    });
    bus.$on('basket-get-main-tourist-info', cb => {
      const index = this.trevelerForm.map(x => x.isMain).indexOf(true);
      cb(this.trevelerInfo[index])
    });
    bus.$on("change-flight", val => {
      let directionIndex = 0;
      let someLocalFlight = false;
      let flight = val.data.flights
          .map(x => {
            return x.flightsPlains
                .map(x2 => {
                  someLocalFlight = !x.remoteFlightId || someLocalFlight;
                  x2.remoteFlightId = x.remoteFlightId;
                  return x2
                })
          })
          .map((x, i) => {
            x = x.map(x2 => {
              const timeFrom = x2.DepartureTime.slice(0, 5);
              const timeTo = x2.ArrivalTime.slice(0, 5);
              const timeDuration = this.correctTime(x);
              let flightType = x2.FlightSetting.ServiceId;
              if (!someLocalFlight) {
                flightType = val.direction[directionIndex];
                directionIndex++;
              }
              let allRate = this.$store.getters['getAllCurrency'];
              let rate = allRate.find(x3 => x3.Code === this.tourRate);

              let flightClass = x2.FlightDetails.map(x3 => {
                let res = {
                  label: x3.Tariff.Name,
                  secondLabel: x3.Cost > 0 ?
                      `+${this.correctPrice(x3.Cost, true)} ${this.getCurrencyDisplayBySettings(rate)}` :
                      `${this.correctPrice(x3.Cost, true)} ${this.getCurrencyDisplayBySettings(rate)}`,
                  value: x3.Cost,
                  allData: x3
                }
                return res
              })
              flightClass[0].secondLabel = "";

              const construct = {
                isGDS: true,
                parent: val.parent,
                day: x2.Day,
                timeFrom,
                timeTo,
                timeDuration,
                airportFrom: x2.DepartureAirport.Key,
                airportTo: x2.ArrivalAirport.Key,
                airline: x2.Airline.Value,
                flightClassSelected: flightClass[0],
                flightClassSelectedValue: flightClass[0].value,
                flightClass,
                flightType,
                remoteFlightId: x2.remoteFlightId,
                allData: x2,
                timeLimit: val.timeLimit,
                direction: val.direction,
                fligthTime: val.fligthTime,
                carryOnAndBaggage: val.carryOnAndBaggage[i],
              };
              return construct
            })
            return x
          }).flat(1)

      const fligthTime = [...flight[0].fligthTime];
      flight = flight
          .map((x, i) => {
            x.fligthTime = fligthTime[i]
            return x
          })
          .sort((a, b) => {
            return a.allData.BeginDateTime > b.allData.BeginDateTime
                ? 1 : (a.allData.BeginDateTime < b.allData.BeginDateTime ? -1 : 0)
          })

      if (!this.flightCash.length)
        this.flightCash = [...this.flight];

      this.flight = this.flight.map((x, i) => {
        if (i === this.flightData.selected) {
          x = [...flight]
        }
        return x
      });

      this.flight = [this.flight[0].map((x) => {
        const Index = x.flightType === 1 ? this.originalsFlightsIndex[0] : this.originalsFlightsIndex[1];
        const allData = { ...x.allData, Index }
        return { ...x, allData }
      })];

      // Начало пересчета корзины в зависисмоти от рейса
      const arrivalAirportOneDirectionDate = moment(val?.dataModal?.arrivalAirportOneDirectionDate).format('YYYY-MM-DD');
      const hotels = this.tour.Services.filter(x => x.SvKey === 3);
      const beginDateTime = moment(hotels[0].BeginDateTime).format('YYYY-MM-DD');
      const beginDateDay = moment(beginDateTime).startOf('day');
      const departureDateDay = moment(arrivalAirportOneDirectionDate).startOf('day');
      const differenceInDays = Math.abs(departureDateDay.diff(beginDateDay, 'days'));
      const recalculatedServicesKeys = this.getWindowSettings.recalculatedServicesKeys ? this.getWindowSettings.recalculatedServicesKeys : [];

      if (val?.dataModal?.answer === 'yes' && val?.dataModal?.mode === "decrease") {
        let helper = false;
        this.tour.Services.map(x => {
          if (x.SvKey === 3) {
            x.Day = x.Day + differenceInDays
            x.DurationInNight = x.DurationInNight - differenceInDays
            x.BeginDateTime = arrivalAirportOneDirectionDate;
          } else if (x.SvKey === 2) {
            if (!helper) {
              if(x.BeginDateTime !== arrivalAirportOneDirectionDate) x.Day = x.Day + differenceInDays
              x.BeginDateTime = arrivalAirportOneDirectionDate
              x.EndDateTime = arrivalAirportOneDirectionDate
              helper = true
            }
          }
          return x
        });

        this.excursion = this.excursion.map((x, i) => {
          if (i === 0) {
            if (x.items[0].BeginDateTime !== arrivalAirportOneDirectionDate) x.items[0].allData.Day = x.items[0].allData.Day + differenceInDays
            x.items[0].allData.BeginDateTime = arrivalAirportOneDirectionDate
          }
          return x
         })

        this.insuranceItems = this.insuranceItems.map(x => {
          x.map(x2 => {
            x2.map(x3 => {
              const insuranceBeginDate = moment(x3?.serviceAllData?.BeginDateTime).format('YYYY-MM-DD');
              if (moment(insuranceBeginDate).isSame(arrivalAirportOneDirectionDate) || !recalculatedServicesKeys.some(el => el === x3?.serviceAllData?.SvKey)) return x3
              if (x3.serviceAllData) {
                x3.serviceAllData.Day = x3.serviceAllData.Day + differenceInDays
                x3.serviceAllData.DurationInNight = x.DurationInNight - differenceInDays
                x3.serviceAllData.BeginDateTime = arrivalAirportOneDirectionDate
              }
              return x3
            })
            return x2
          })
          return x
        })

        this.transfer = [this.transfer[0].map((x, i) => {
          if (i === 0 && x.allData.BeginDateTime !== arrivalAirportOneDirectionDate) {
            x.allData.BeginDateTime = arrivalAirportOneDirectionDate
            x.allData.EndDateTime = arrivalAirportOneDirectionDate
            x.day = x.day + differenceInDays
          }
          return x
        })]

        this.additionalServices = this.additionalServices.map(x => {
          if (!recalculatedServicesKeys.some(x2 => x2 === x.svKey) 
              || moment(arrivalAirportOneDirectionDate).isBefore(moment(x.items[0].itemSelected.allData.BeginDateTime))) {
            return x
          } else {
            if (x.items[0].itemSelected.allData.BeginDateTime !== arrivalAirportOneDirectionDate) x.items[0].itemSelected.allData.Day = x.items[0].itemSelected.allData.Day + differenceInDays
            x.items[0].itemSelected.allData.BeginDateTime = arrivalAirportOneDirectionDate
            return x
          }
        })

        this.cashDiffDaysForAdditionalServices = differenceInDays;
        this.setServicesForCalculate();
      } else if (val?.dataModal?.answer === 'no' && val?.dataModal?.mode === "decrease") {
        let helper = false;
        this.tour.Services.map(x => {
          if (x.SvKey === 2) {
            if (!helper) {
              if (x.BeginDateTime !== arrivalAirportOneDirectionDate) x.Day = x.Day + differenceInDays
              x.BeginDateTime = arrivalAirportOneDirectionDate
              x.EndDateTime = arrivalAirportOneDirectionDate
              helper = true
            }
          }
          return x
        });

        this.excursion = this.excursion.map((x, i) => {
          if (i === 0) {
            if (x.items[0].BeginDateTime !== arrivalAirportOneDirectionDate) x.items[0].allData.Day = x.items[0].allData.Day + differenceInDays
            x.items[0].allData.BeginDateTime = arrivalAirportOneDirectionDate ? arrivalAirportOneDirectionDate : x.items[0].allData.BeginDateTime
          }
          return x
         })

        this.insuranceItems = this.insuranceItems.map(x => {
          x.map(x2 => {
            x2.map(x3 => {
              const insuranceBeginDate = moment(x3?.serviceAllData?.BeginDateTime).format('YYYY-MM-DD');
              if (moment(insuranceBeginDate).isSame(arrivalAirportOneDirectionDate) || !recalculatedServicesKeys.some(el => el === x3?.serviceAllData?.SvKey)) return x3
              if (x3.serviceAllData) {
                x3.serviceAllData.Day = x3.serviceAllData.Day + differenceInDays
                x3.serviceAllData.DurationInNight = x.DurationInNight - differenceInDays
                x3.serviceAllData.BeginDateTime = arrivalAirportOneDirectionDate ? arrivalAirportOneDirectionDate : x.BeginDateTime
              }
              return x3
            })
            return x2
          })
          return x
        })

        this.transfer = [this.transfer[0].map((x, i) => {
          if (i === 0 && x.allData.BeginDateTime !== arrivalAirportOneDirectionDate) {
            x.allData.BeginDateTime = arrivalAirportOneDirectionDate ? arrivalAirportOneDirectionDate : x.allData.BeginDateTime
            x.allData.EndDateTime = arrivalAirportOneDirectionDate
            x.day = x.day + differenceInDays
          }
          return x
        })]

        this.additionalServices = this.additionalServices.map(x => {
          if (!recalculatedServicesKeys.some(x2 => x2 === x.svKey) 
              || moment(arrivalAirportOneDirectionDate).isBefore(moment(x.items[0].itemSelected.allData.BeginDateTime))) {
            return x
          } else {
            if (x.items[0].itemSelected.allData.BeginDateTime !== arrivalAirportOneDirectionDate) x.items[0].itemSelected.allData.Day = x.items[0].itemSelected.allData.Day + differenceInDays
            x.items[0].itemSelected.allData.BeginDateTime = arrivalAirportOneDirectionDate
            return x
          }
        })

        this.cashDiffDaysForAdditionalServices = differenceInDays;
        this.setServicesForCalculate();
      } else if (val?.dataModal?.answer === 'yes' && val?.dataModal?.mode === "increase") {
        let helper = false;
        this.tour.Services.map(x => {
          if (x.SvKey === 3) {
            x.Day = x.Day - differenceInDays
            x.DurationInNight = x.DurationInNight + differenceInDays
            x.BeginDateTime = arrivalAirportOneDirectionDate;
          } else if (x.SvKey === 2) {
            if (!helper) {
              x.Day = x.Day - differenceInDays > 1 ? x.Day - differenceInDays : 1
              x.BeginDateTime = arrivalAirportOneDirectionDate
              x.EndDateTime = arrivalAirportOneDirectionDate
              helper = true
            }
          }
          return x
        });

        this.excursion = this.excursion.map((x, i) => {
          if (i === 0) {
            if (x.items[0].BeginDateTime !== arrivalAirportOneDirectionDate) x.items[0].allData.Day = x.items[0].allData.Day - differenceInDays > 1 ? x.items[0].allData.Day - differenceInDays : 1
            x.items[0].allData.BeginDateTime = arrivalAirportOneDirectionDate
          }
          return x
        })

        this.insuranceItems = this.insuranceItems.map(x => {
          x.map(x2 => {
            x2.map(x3 => {
              const insuranceBeginDate = moment(x3?.serviceAllData?.BeginDateTime).format('YYYY-MM-DD');
              if (moment(insuranceBeginDate).isSame(arrivalAirportOneDirectionDate) || !recalculatedServicesKeys.some(el => el === x3?.serviceAllData?.SvKey)) return x3
              if (x3.serviceAllData) {
                x3.serviceAllData.Day = x3.serviceAllData.Day - differenceInDays > 1 ? x3.serviceAllData.Day - differenceInDays : 1
                x3.serviceAllData.DurationInNight = x.DurationInNight + differenceInDays
                x3.serviceAllData.BeginDateTime = arrivalAirportOneDirectionDate
              }
              return x3
            })
            return x2
          })
          return x
        })

        this.transfer = [this.transfer[0].map((x, i) => {
          if (i === 0 && x.allData.BeginDateTime !== arrivalAirportOneDirectionDate) {
            x.allData.BeginDateTime = arrivalAirportOneDirectionDate
            x.allData.EndDateTime = arrivalAirportOneDirectionDate
            x.day = x.day - differenceInDays
          }
          return x
        })]

        this.additionalServices = this.additionalServices.map(x => {
          const arrivalDateTimePlusDiff = moment(arrivalAirportOneDirectionDate).add(differenceInDays, 'days').format('YYYY-MM-DD');
          const formatBeginDateTime = moment(x.items[0].itemSelected.allData.BeginDateTime).format('YYYY-MM-DD');
          if (!recalculatedServicesKeys.some(x2 => x2 === x.svKey) 
              || moment(formatBeginDateTime).isAfter(arrivalDateTimePlusDiff)) {
            return x
          } else {
            x.items[0].itemSelected.allData.BeginDateTime = arrivalAirportOneDirectionDate
            x.items[0].itemSelected.allData.Day = x.items[0].itemSelected.Day - differenceInDays > 1 ? x.items[0].itemSelected.Day - differenceInDays : 1
            return x
          }
        })

        this.cashDiffDaysForAdditionalServices = differenceInDays;
        this.setServicesForCalculate();
      } else if (val?.dataModal?.answer === 'no' && val?.dataModal?.mode === "increase") {
        let helper = false;
        this.tour.Services.map(x => {
          if (x.SvKey === 2) {
            if (!helper && x.BeginDateTime !== arrivalAirportOneDirectionDate) {
              x.Day = x.Day - differenceInDays
              x.BeginDateTime = arrivalAirportOneDirectionDate
              x.EndDateTime = arrivalAirportOneDirectionDate
              helper = true
            }
          }
          return x
        });

        this.excursion = this.excursion.map((x, i) => {
          if (i === 0) {
            if (x.items[0].BeginDateTime !== arrivalAirportOneDirectionDate) x.items[0].allData.Day = x.items[0].allData.Day - differenceInDays > 1 ? x.items[0].allData.Day - differenceInDays : 1
            x.items[0].allData.BeginDateTime = arrivalAirportOneDirectionDate
          }
          return x
        })

        this.insuranceItems = this.insuranceItems.map(x => {
          x.map(x2 => {
            x2.map(x3 => {
              const insuranceBeginDate = moment(x3?.serviceAllData?.BeginDateTime).format('YYYY-MM-DD');
              if (moment(insuranceBeginDate).isSame(arrivalAirportOneDirectionDate) || !recalculatedServicesKeys.some(el => el === x3?.serviceAllData?.SvKey)) return x3
              if (x3.serviceAllData) {
                x3.serviceAllData.Day = x3.serviceAllData.Day - differenceInDays > 1 ? x3.serviceAllData.Day - differenceInDays : 1
                x3.serviceAllData.DurationInNight = x.DurationInNight + differenceInDays
                x3.serviceAllData.BeginDateTime = arrivalAirportOneDirectionDate
              }
              return x3
            })
            return x2
          })
          return x
        })

        this.transfer = [this.transfer[0].map((x, i) => {
          if (i === 0 && x.allData.BeginDateTime !== arrivalAirportOneDirectionDate) {
            x.allData.BeginDateTime = arrivalAirportOneDirectionDate
            x.allData.EndDateTime = arrivalAirportOneDirectionDate
            x.day = x.day - differenceInDays
          }
          return x
        })]

        this.additionalServices = this.additionalServices.map(x => {
          const arrivalDateTimePlusDiff = moment(arrivalAirportOneDirectionDate).add(differenceInDays, 'days').format('YYYY-MM-DD');
          const formatBeginDateTime = moment(x.items[0].itemSelected.allData.BeginDateTime).format('YYYY-MM-DD');
          if (!recalculatedServicesKeys.some(x2 => x2 === x.svKey) 
              || moment(formatBeginDateTime).isAfter(arrivalDateTimePlusDiff)) {
            return x
          } else {
            x.items[0].itemSelected.allData.BeginDateTime = arrivalAirportOneDirectionDate
            x.items[0].itemSelected.allData.Day = x.items[0].itemSelected.Day - differenceInDays > 1 ? x.items[0].itemSelected.Day - differenceInDays : 1
            return x
          }
        })

        this.cashDiffDaysForAdditionalServices = differenceInDays;
        this.setServicesForCalculate();
      } else if (differenceInDays === 0 && !val?.dataModa?.answer) {
        let helper = false;
        this.tour.Services.map(x => {
          if (x.SvKey === 2) {
            if (!helper) {
              x.Day = hotels[0].Day;
              x.BeginDateTime = arrivalAirportOneDirectionDate
              x.EndDateTime = arrivalAirportOneDirectionDate
              helper = true
            }
          }
          return x
        });

        this.excursion = this.excursion.map((x, i) => {
          if (i === 0) {
            if (x.items[0].BeginDateTime !== arrivalAirportOneDirectionDate) x.items[0].allData.Day = hotels[0].Day
            x.items[0].allData.BeginDateTime = arrivalAirportOneDirectionDate
          }
          return x
        })

        this.insuranceItems = this.insuranceItems.map(x => {
          x.map(x2 => {
            x2.map(x3 => {
              const insuranceBeginDate = moment(x3?.serviceAllData?.BeginDateTime).format('YYYY-MM-DD');
              if (moment(insuranceBeginDate).isSame(arrivalAirportOneDirectionDate) || !recalculatedServicesKeys.some(el => el === x3?.serviceAllData?.SvKey)) return x3
              if (x3.serviceAllData) {
                x3.serviceAllData.DurationInNight = x3.serviceAllData.DurationInNight - (hotels[0].Day - x3.serviceAllData.Day)
                x3.serviceAllData.Day = hotels[0].Day
                x3.serviceAllData.BeginDateTime = arrivalAirportOneDirectionDate
              }
              return x3
            })
            return x2
          })
          return x
        })

        this.transfer = [this.transfer[0].map((x, i) => {
          if (i === 0 && x.allData.BeginDateTime !== arrivalAirportOneDirectionDate) {
            x.allData.BeginDateTime = arrivalAirportOneDirectionDate
            x.allData.EndDateTime = arrivalAirportOneDirectionDate
            x.day = hotels[0].Day
          }
          return x
        })]

        this.additionalServices = this.additionalServices.map(x => {
          const beginDateService = moment(x.items[0].itemSelected.allData.BeginDateTime).format('YYYY-MM-DD');
          const beginServiceDay = x.items[0].itemSelected.allData.Day;
          let checkDaysDiffType;
          if (hotels[0].Day < beginServiceDay && this.cashDiffDaysForAdditionalServices > 0) {
            checkDaysDiffType = (hotels[0].Day + this.cashDiffDaysForAdditionalServices) === beginServiceDay 
          } else {
            checkDaysDiffType = (hotels[0].Day - this.cashDiffDaysForAdditionalServices) === beginServiceDay
          }
          if (!recalculatedServicesKeys.some(x2 => x2 === x.svKey) 
              || (moment(arrivalAirportOneDirectionDate).isBefore(moment(beginDateService)) && !checkDaysDiffType)) {
            return x
          } else {
            x.items[0].itemSelected.allData.BeginDateTime = arrivalAirportOneDirectionDate
            x.items[0].itemSelected.allData.Day = hotels[0].Day
            return x
          }
        })

        this.cashDiffDaysForAdditionalServices = 0;
        this.setServicesForCalculate();
      }
      // Конец пересчета корзины в зависисмоти от рейса

      const oldCost = this.tourCardData.calculatedServicesPrice;
      const oldName = this.getServiceNameBySvKey(1) || "Flight";
      this.calculateTour(true, true).then(() => {
        const newCost = this.tourCardData.calculatedServicesPrice;
        this.GTMChangeFlight(this.flightData.selected, newCost, oldName, 0, oldCost);

        this.flightChanged = true;
        bus.$emit("calculate-for-flight", {
          autoSelect: false,
          hasRealCourses: this.tourCardData.hasRealCourses
        });
      }).catch(() => {
        bus.$emit("calculate-for-flight", {autoSelect: true})
      }).finally(() => {
        if (val?.dataModal?.answer === 'yes') {
           const departureCityName = val.parent.allFlights.filter(x => x.direction === 1)[0].segments[0].depratureCity.mtItem.name;
           const arrivalCityName = val.parent.allFlights.filter(x => x.direction === 1).at(-1).segments[0].arrivalCity.mtItem.name;
           let alertText = this.localizeList.startDateOfYourStayHasChanged.replace("{0}", departureCityName).replace("{1}", arrivalCityName);
           alert(alertText)
        }
      })
    });
    bus.$on("isAuthenticated", val => {
      this.isAuthenticated = val;
      if (this.$route.path.includes("Basket")) {
        this.$nextTick(() => {
          this.setUserInfo();
          this.setTouristInfo()
              .then(() => {
                if (this.buyTourFromRegistrationModal) {
                  this.buyTour();
                  this.buyTourFromRegistrationModal = false;
                } else if (this.buyTourFromRegistrationModalNoAuth) {
                  this.buyTourNoRegistration();
                  this.buyTourFromRegistrationModalNoAuth = false;
                } else {
                  this.calculateTour();
                }
              })
        })
      }
    });
    bus.$on("localizeCode", code => {
      code = code === "ua" ? "uk" : code;
      moment.locale(code);
      if (this.$route.path.includes("Basket")) {
        this.firstTimeShowTax = true;
        this.getTour();
      }
    });
    bus.$on("basket-flight", res => {
      this.routeFlight = res;
      this.GDSReady = res;
      bus.$emit("show-learning-mode")
    });
    bus.$on("GDSReady", res => {
      this.GDSReady = res
    });

    const isBasket = window.location.href.includes('Basket');
    if (isBasket) {
      this.getCitizenship();
    }

    window.addEventListener("resize", this.windowResize);
    window.addEventListener("scroll", this.windowScroll);
    window.addEventListener("mouseup", this.stopDragSecondSlider);
    window.addEventListener("keydown", this.keydown);

    this.setUserInfo();
  },
  mounted() {
    this.cardLoaderStatus = true;

    this.isAuthenticated = this.$store.getters['tour/getIsAuthenticated'];
    let localCode = localStorage.getItem("localize") || document.getElementById('defaultLanguageCode').value;
    localCode = localCode === "ua" ? "uk" : localCode
    moment.locale(localCode);

    this.setBreadCrumbs();
    this.setLinks();
  },
  methods: {
    applyPromoOrDiscount(item) {
      if (item.type === "clear" && (this.promocodeId || this.discountCardId)) {
        this.promocodeId = "";
        this.discountCardId = "";
        this.calculateTour();
      } else if (item.type === 0) {
        this.promocodeId = item.value;
        this.discountCardId = "";
        this.calculateTour();
      } else if (item.type === 1) {
        this.discountCardId = item.value;
        this.promocodeId = "";
        this.calculateTour();
      }
    },
    eventModalHandler(data) {
      const [answer, dataFlight, dataModal] = data;
      dataFlight.dataModal = dataModal;
      dataFlight.dataModal.answer = answer;
      bus.$emit("page-load", true);
      bus.$emit("change-flight", dataFlight);
    },
    getQuiQuoJSON(){
      const getTourDataQuiQuo = window.settings.getTourDataQuiQuo;
      const hotel = this.buyList[this.hotelInfo.key].find(el => el.selected)
      const { adult, childs, childAges } = this.getAdultAndChildsFromHref()
      const [residence] = this.residence
      if(!this.tour || !residence) return;

      const serviceTour = this.tour.Services.find(el => el.SvKey === 3)
      const roomInfo = hotel.accomodationType + " / " + hotel.roomCategory + " / " + hotel.adult;

      const hotelUrl = serviceTour.Http;
      const tourUrl = this.tour.TourUrl;
      const tourName = this.tour.Name;

      const name = getTourDataQuiQuo ? tourName : serviceTour.Hotel.Value;
      const href = getTourDataQuiQuo ? tourUrl : hotelUrl

      const startDate = this.tour.StartDate.split('T')[0];
      const [year, month, day] = startDate.split('-') 
      const beginDate = `${day}.${month}.${year}`

      const imageUrl = this.residence[0]?.hotelImages[0];

      const QuiQuoObject = {
          checkinDt: beginDate,
          nights: String(this.tour.DurationInNight),
          hotelName: name,
          roomType: roomInfo,  
          boardType: hotel.pansion,
          price: this.tourCardData.totalPrice,
          currency: this.tourCardData.tourCurrency?.IsoCode || this.getCurrencyFromHref(),
          city_from: this.tourHeadline.from,
          occupancy: {
          adultsCount: parseInt(adult),
          childrenCount: childs || 0,
          childAges: childAges || 0,
          },
          region: residence.hotelCity,
          country: residence.hotelCountry,
          thumbnail: imageUrl || "",
          href
      }

      return JSON.stringify(QuiQuoObject)
    },
    getCurrencyFromHref(){
      let currency;
      location.href.split('&').forEach(x => {
        if (x.includes('currency')) {
          currency = x.split('=')[1]
        }
      });
      return currency
    },
    getAdultAndChildsFromHref(){
      let adult = null;
      let childs = null;
      let childAges = null;

      location.href.split('&').forEach(x => {
        if (x.includes('adultCount')) {
          adult = x.split('=')[1]
        }
        if (x.includes('childAges')) {
          childAges = x.split('=')[1]
        }
        if (x.includes('childAges')) {
          childs = x.split('=')[1].split(',').length
        }
      });

      return {
        adult,
        childs,
        childAges
      }
    },
    searchByChangedTariffAviaFlight(data){
      this.routeFlight = true;
      this.GDSReady = true;
      this.changedTariff = data;     
      bus.$emit("changeTariffInFlightFilters", data);
    },
    showModalLoadAnotherAirTAriff(data) {
        this.showAnotherAirTariffModal = true;
        this.stringValueTariffForModal = data;
        this.modalType = 1
    },
    showModalChangeFlight(data) {
        this.showAnotherAirTariffModal = true;
        this.flightDataForModal = data;
        this.modalType = 2;
    },
    getHotelTimeInfo() {
      const checkInAt = this.localizeList.checkInAt;
      const checkOutBefore = this.localizeList.checkOutBefore;
      const checkInAtTime = this.hotelInfo.data.hotelImagesDescription.CheckoutTimeFrom;
      const checkOutBeforeTime = this.hotelInfo.data.hotelImagesDescription.CheckoutTimeTo;

      if (!checkInAtTime || !checkOutBeforeTime) return "";

      return `${checkInAt} ${checkInAtTime}, ${checkOutBefore} ${checkOutBeforeTime}.`
    },
    GTMSetFirstProduct() {
      const firstProduct = GTM.getFirstProduct();
      if (Object.keys(firstProduct).length) return;

      const href = window.location.href;
      let adultCount = href.split("&").find(x => x.includes("adultCount")).split("=")[1];
      adultCount = +adultCount;
      let childAges = href.split("&").find(x => x.includes("childAges"));
      childAges = childAges ? childAges.split("=")[1].split(",") : [];

      let urlCurrency = this.$route.fullPath.split('currency=')[1];
      urlCurrency = urlCurrency ? urlCurrency.split('&')[0] : urlCurrency;
      urlCurrency = urlCurrency ? urlCurrency.split('?')[0] : urlCurrency;
      GTM.toBasket({
        allData: this.tour,
        cost: this.tourCardData.calculatedServicesPrice
      }, 0, adultCount + childAges.length, urlCurrency, this.residence[0]?.food || [])
    },
    getSelectedMapItem() {
      if (!this.focusedMapItemInHotelInfo) {
        return this.mapItems
      }

      const item = this.mapItems.find(x => {
        if (
            x.coordinates?.[0] === this.focusedMapItemInHotelInfo.coordinates[0] &&
            x.coordinates?.[1] === this.focusedMapItemInHotelInfo.coordinates[1]
        ) {
          return x
        }
      });

      if (item) item.Cost = this.tourCardData.totalPrice

      return [item]
    },
    getTourImages() {
      const key = this.tour.Key;

      let date = new Date().getTime();
      Vue.Api.Get(this.$store.getters['getApiUrl'] + `TourImages?tourKeys=${key ? key : 639}&_=` + date)
          .then(res => {
            let imagesData = res.data.Images;
            let images = [];
            let imagesDescription = [];
            let path = this.$store.getters['getPath'];
            imagesData.forEach(x => {
              imagesDescription.push(x.Description);
              images.push(`${this.$store.getters['getApiOrigin']}${path}/Image/GetImage?code=${x.TourKey ? x.TourKey : 639}&type=small160x90&name=${x.Name}&imageType=tours`)
            });
            this.tourImages = images;
            this.tourImagesDescription = imagesDescription;
          });
    },
    windowScroll() {
      // const isBasket = window.location.href.includes('Basket');
      // if (!isBasket) return;

      // const cardWrap = document.querySelector(".basket-nav-card-wrap");
      // const card = document.querySelector(".basket-nav-card");
      // if (!card) return;

      // const cardHeight = card.clientHeight;
      // const basketContent = document.querySelector(".basket-content");
      // const basketContentBottom = basketContent.clientHeight + basketContent.offsetTop;
      // const windowTop = window.scrollY;
      // const windowBottom = window.scrollY + window.innerHeight;
      // const trevelerBlockBottom = this.$refs.trevelerData?.offsetTop + this.$refs.trevelerData?.offsetHeight;
      // const residenceTop = this.$refs.residence.offsetTop;

      // if (
      //     windowBottom > cardHeight + 180 &&
      //     window.innerWidth > 1400 &&
      //     cardHeight < trevelerBlockBottom 
      // ) {
      //   card.style.position = "fixed";
      //   card.style.bottom = "unset";
      //   card.style.top = "unset";
      //   card.style.left = cardWrap.offsetLeft + "px";

      //   if (windowBottom > basketContentBottom) {
      //     card.style.bottom = `${windowBottom - basketContentBottom + 12}px`;
      //   }

      // } else if (
      //     windowTop + 20 > residenceTop &&
      //     window.innerWidth > 1400 &&
      //     cardHeight < trevelerBlockBottom &&
      //     cardHeight < window.innerHeight
      // ) {
      //   card.style.position = "fixed";
      //   card.style.top = "20px";
      //   card.style.left = cardWrap.offsetLeft + "px";
      // } else {
      //   card.style.position = "relative";
      //   card.style.bottom = "unset";
      //   card.style.top = "unset";
      //   card.style.left = "unset";
      // }
    },
    setLinks() {
      this.termsTariffs = window.settings.termsTariffs;
      this.submittingAgreePrivacyPolicy = window.settings.submittingAgreePrivacyPolicy;
    },
    setBreadCrumbs() {
      const mainHref = '/';
      // URL будет парситься приоритетно из текущего адреса карточки корзины, а не из SS.
      const fromCurrent = '/' + window.location.href.split('?')[1];
      const searchHref = fromCurrent || sessionStorage.getItem('searchHref')?.split('#')?.[1] || '/';
      this.breadCrumbs = [
        {
          text: this.localizeList.main2,
          disabled: false,
          href: mainHref
        },
        {
          text: this.localizeList.searchResults,
          disabled: false,
          href: searchHref
        },
        {
          text: this.localizeList.selectedTour,
          disabled: true,
          href: null
        }
      ]
    },
    changeBreadCrumbs(e) {
      const isTicket = e.target.href.includes('Individuals/Avia');
      const isHotels = this.$route.fullPath.includes('Individuals/Hotels');

      if (e.key === 0 && !isTicket && !isHotels) {
        this.toSearch();
      } else if (e.key === 0 && !isTicket && isHotels) {
        this.toHotelsSearch();
      } else if (e.key === 0 || e.key === 1 && isTicket) {
        bus.$emit("mounted-ticket", true);
        this.$router.push(e.target.href)
      } else if (e.key === 1 && !isTicket && isHotels) {
        bus.$emit("page-load", false);
        this.$router.push(e.target.href.slice(1));
        bus.$emit("mounted-hotels-search");
      } else if (e.key === 1 && !isTicket) {
        bus.$emit("page-load", false);
        this.$router.push(e.target.href);
        bus.$emit("mounted-search", true);
      }
    },
    showHotelSliderIcons() {
      const length = this.hotelInfo.images.length;
      if (!length) return false;
      else if (length > 1) return true;
      else {
        return !this.hotelInfo.images[0].includes('null')
      }

    },
    getCurrencyDisplayBySettings(rate) {
      if (!rate) return "";
      return this.$store.getters['getCurrencyDisplayBySettings'](rate);
    },
    keydown(e) {
      if (this.showRightModal && this.rigthModalType === 'hotelInfo') {
        if (e.keyCode === 13) {
          e.preventDefault();

          if (this.focusHotelVariantBtn !== null) {
            const key = this.focusHotelVariantBtn;

            this.changeFoodInModal(key)
          }
          if (this.focusHotelDoneBtn) {
            this.changeFoodOfModal()
          }
        }
        if (e.keyCode === 9) {
          e.preventDefault();

          const variantLength = this.buyList[this.hotelInfo.key].length;
          const navLength = this.hotelInfo.nav.length;
          let index = this.hotelInfo.activeItem;
          if (index === -1) {
            if (this.focusHotelVariantBtn === null) {
              this.focusHotelVariantBtn = 0
            } else {
              this.focusHotelVariantBtn++;
            }

            if (this.focusHotelDoneBtn) {
              this.focusHotelVariantBtn = null;
              this.focusHotelDoneBtn = false;
              index++
            }
            if (this.focusHotelVariantBtn === variantLength) {
              this.focusHotelVariantBtn = null;
              if (!this.focusHotelDoneBtn) {
                this.focusHotelDoneBtn = true;
              }
            }
          } else {
            index++
          }
          if (navLength === index) index = -1;

          this.changeHotelInfoNavbar(index);
        }
      }
    },
    buyTourMinPriceAndHotelSchem(item) {
      const href = window.location.href.split("&");
      const currency = this.$store.getters['getAllCurrency'].find(x => x.Code === item.Rate).IsoCode
      const tourKey = item.Key;
      const dCity = item.CityDepature.Key;
      const aCountry = item.CountryId;
      let date = item.StartDate.split("T")[0].split("-").reverse();
      date[2] = date[2].slice(2);
      date = date.join(".");
      const duration = +item.DurationInNight + 1;

      let hotelScheme = "";
      item.MinCostServicesComposition.forEach((x) => {
        if (x.Value.ServiceType === 3) {
          const templateId = x.Key.TemplateId;
          const durationInNight = x.Value.DurationInNight;
          const code = x.Value.Code;
          const packetId = x.Value.PacketId;
          const partnerId = x.Value.PartnerId;
          const GDSProviderId = 0;
          const duration = item.Duration;
          hotelScheme += (hotelScheme.length ? "," : "") + `${templateId}_${durationInNight}_${code}_${packetId}_${partnerId}_${GDSProviderId}_${duration}_`;
        }
      });

      const adultCount = href.find(x => x.includes("adultCount")).split("=")[1];
      let childAges = href.find(x => x.includes("childAges"));
      childAges = childAges ? childAges.split("=")[1] : childAges;

      const aviaQuota = href.find(x => x.includes("aviaQuota"));
      const hotelQuota = href.find(x => x.includes("hotelQuota"));
      const busTransferQuota = href.find(x => x.includes("busTransferQuota"));
      const railwayTransferQuota = href.find(x => x.includes("trainTransferQuota"));

      let serviceDescriptions = item.MinCostServicesComposition.map(x => {
        let res = [];

        Object.values(x.Key).forEach(x2 => res.push(x2))
        res.push(x.Value.ServiceType)
        res.push(x.Value.Code)
        res.push(x.Value.SubCode1);
        res.push(x.Value.SubCode2)
        res.push(x.Value.CountryId)
        res.push(x.Value.CityId)
        res.push(x.Value.PacketId)
        res.push(x.Value.PartnerId)
        res.push(x.Value.Day)
        res.push(x.Value.DurationInNight)
        return res.join("_")
      })

      let newUrl = `Basket?departureCities=${dCity}` +
          `&destination=1_${aCountry}` +
          `&tour=${tourKey}` +
          `&date=${date}` +
          `&duration=${duration}` +
          `&hotelScheme=${hotelScheme}` +
          `&adultCount=${adultCount}` +
          (childAges ? `&childAges=${childAges}` : "") +
          `&${hotelQuota}&${aviaQuota}&${busTransferQuota}&${railwayTransferQuota}` +
          `&serviceDescriptions=${serviceDescriptions.join(",")}` +
          `&currency=${currency}`

      let beforeHash = window.location.href.split("#")[0];
      beforeHash = beforeHash + "#/" + newUrl
      window.open(beforeHash)
    },
    getMapItems() {
      const href = window.location.href;
      this.$store.dispatch('basket/A_GET_HOTELS_FOR_MAP', href)
    },
    getCitizenship(add = false) {
      if (!add) {
        this.citizinshipPage = 1
      } else {
        this.citizinshipPage++
      }
      const date = new Date().getTime();
      Vue.Api.Get(`${this.$store.getters['getApiUrl']}Citizenships?pageSize=200&pageNumber=${this.citizinshipPage}&term=&showAll=true&flightsPacketsIds=&_${date}`)
          .then(res => {
            if (add) {
              this.citizenshipList = [...this.citizenshipList, ...res.data];
            } else {
              this.citizenshipList = res.data;
            }
            if (this.citizenshipList.length % 200 === 0) {
              this.loadCitizenshipItems = true;
            }
          });
    },
    setUserInfo() {
      let userInfo = document.cookie
          .split(";")
          .find(x => x.includes("CommonApplicationAuthCookie_.masterweblight-auth"));
      if (!userInfo) return;

      userInfo = userInfo.split("CommonApplicationAuthCookie_.masterweblight-auth=")[1];
      this.userInfo = JSON.parse(userInfo);
    },
    setTouristInfo() {
      if (this.userInfo.UserType !== 1) return new Promise(resolve => resolve());

      return new Promise(resolve => {
        this.$store.dispatch('basket/A_GET_USER_ALL_INFO', this.userInfo.UserKey)
            .then(res => {
              const index = this.trevelerForm.map(x => x.isMain).indexOf(true);

              let lastNameIndex = this.trevelerInfo[index].map(x => x.code).indexOf("lastname");
              let firstNameIndex = this.trevelerInfo[index].map(x => x.code).indexOf("firstname");
              let lastNameRusIndex = this.trevelerInfo[index].map(x => x.code).indexOf("lastnamerus");
              let firstNameRusIndex = this.trevelerInfo[index].map(x => x.code).indexOf("firstnamerus");
              let phoneIndex = this.trevelerInfo[index].map(x => x.code).indexOf("phone");
              let emailIndex = this.trevelerInfo[index].map(x => x.code).indexOf("email");

              let surname = this.$store.getters['translit'](res.CL_NAMELAT, 5);
              if (lastNameIndex !== -1 && !this.trevelerInfo[index][lastNameIndex].value && surname) {
                this.trevelerInfo[index][lastNameIndex].value = surname
              }
              let name = this.$store.getters['translit'](res.CL_FNAMELAT, 5);
              if (firstNameIndex !== -1 && !this.trevelerInfo[index][firstNameIndex].value && name) {
                this.trevelerInfo[index][firstNameIndex].value = name
              }
              let surnamerus = res.CL_NAMERUS;
              if (lastNameRusIndex !== -1 && !this.trevelerInfo[index][lastNameRusIndex].value && surnamerus) {
                this.trevelerInfo[index][lastNameRusIndex].value = surnamerus
              }
              let namerus = res.CL_FNAMERUS;
              if (firstNameRusIndex !== -1 && !this.trevelerInfo[index][firstNameRusIndex].value && namerus) {
                this.trevelerInfo[index][firstNameRusIndex].value = namerus
              }
              let phone = res.CL_PHONE;
              if (phone[index] === " ") phone = phone.replace(" ", "+");
              if (phoneIndex !== -1 && !this.trevelerInfo[index][phoneIndex].value && phone) {
                this.trevelerInfo[index][phoneIndex].value = phone
              }
              let email = res.CL_Login;
              if (emailIndex !== -1 && !this.trevelerInfo[index][emailIndex].value && email) {
                this.trevelerInfo[index][emailIndex].value = email
              }
              resolve()
            })
      })
    },
    correctPrice(val, round = false) {
      if (round) {
        val = Math.round(val);
      }
      const isFloat = val % 1 !== 0;
      let res = new Intl.NumberFormat().format(val);

      if (res.includes(".") || !isFloat) {
        res = res.replace(/,/g, " ");
      } else {
        res = res.replace(/,/g, ".");
      }
      res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
      return res
    },
    windowResize(e) {
      this.windowWidth = e.target.innerWidth;
      this.windowScroll();
    },
    alertShow(key, time, update = false) {
      this.alertType = update ? 'out-hotel-update' : 'out-hotel';
      this.outHotelKey = key;
      this.$store.dispatch("A_SET_ALERT", time)
    },
    correctDate(date) {
      let correctDate = date.split("T")[0];
      return correctDate.split("-").reverse().join(".");
    },
    resetFlight() {
      let flightChanged = false;
      this.flight = this.flight.map((x, i) => {
        if (this.flightData.selected !== i) {
          if (x[0].isGDS) flightChanged = true;
          return x;
        }

        return this.flightCash[i]
      });
      this.flightChanged = flightChanged;
      const oldCost = this.tourCardData.calculatedServicesPrice;
      const oldName = this.getServiceNameBySvKey(1) || "Flight";
      this.calculateTour()
          .then(() => {
            const newCost = this.tourCardData.calculatedServicesPrice;
            this.GTMChangeFlight(this.flightData.selected, newCost, oldName, 0, oldCost);
          });
    },
    getDateByFormat(date, format) {
      return moment(date).format(format)
    },
    getPlus(numb) {
      return numb <= 0 ? "" : "+"
    },
    toSearch() {
      bus.$emit("page-load", false);
      this.$router.push("/");
      bus.$emit("mounted-search", true);
    },
    toHotelsSearch() {
      bus.$emit("page-load", false);
      this.$router.push("/Individuals/Hotels/");
      bus.$emit("mounted-hotels-search");
    },
    isDateMode(item) {
      return item.Code.includes("date")
    },
    hasHotelImages(key) {
      const date = new Date().getTime();
      let sendParams = `${this.$store.getters['getApiUrl']}HotelImages?hotelKeys=${key}&_=${date}`
      return new Promise((resolve, reject) => {
        Vue.Api.Get(sendParams)
            .then((res) => {
              if (res.data?.[0]?.ImagesCount)
                resolve(res.data[0].Name);
              else reject();
            })
      })
    },
    getHotelImages(key) {
      return new Promise((resolve) => {
        let path = this.$store.getters['getPath'];

        this.hasHotelImages(key)
            .then(() => {
              const date = new Date().getTime();
              let sendParams = `${this.$store.getters['getApiUrl']}HotelImages?HotelKey=${key}&_=${date}`

              Vue.Api.Get(sendParams)
                  .then(res2 => {
                    const imagesDescription = [];
                    const images = res2.data.Images.map(x => {
                      imagesDescription.push(x.Description);
                      return `${this.$store.getters['getApiOrigin']}${path}/Image/GetImage?code=${x.HotelKey}&type=small160x90&name=${x.Name}&imageType=hotels`
                    });
                    if (!images.length) {
                      images.push(`${this.$store.getters['getApiOrigin']}${path}/Image/GetImage?code=${key}&type=small160x90&name=null&imageType=hotels`)
                    }
                    resolve({
                      images,
                      imagesDescription,
                      description: res2.data
                    })
                  })
            })
            .catch(() => {
              const images = [];
              images.push(`${this.$store.getters['getApiOrigin']}${path}/Image/GetImage?code=${key}&type=small160x90&name=null&imageType=hotels`)
              resolve({
                images,
                imagesDescription: [],
                description: {}
              })
            })
      });
    },
    getStars(val) {
      if (!val) {
        return val
      }
      let res = 0;
      let stars = parseInt(val[0]);
      if (typeof stars === "number" && !isNaN(stars)) {
        res = stars
      } else {
        res = val
      }
      return res
    },
    getFeatures(types) {
      let path = this.$store.getters['getPath'];
      return types.map(x => {
        return {
          src: `${this.$store.getters['getApiOrigin']}${path}/GetImage/GetImage?type=hotelType&id=${x.Key}&width=20&height=20`,
          text: x.Value
        }
      })
    },
    constructHotels(hotels) {
      this.residence = [];
      hotels = hotels.sort((a, b) => {
        return a.Day - b.Day
      });

      let hotelsCount = hotels.length;
      hotels.forEach((x, i) => {
        const construct = {
          allData: x,
          hotelName: null,
          nightCount: null,
          hotelCity: null,
          hotelCountry: null,
          hotelStars: null,
          hotelFeatures: [],
          hotelImages: [],
          hotelImagesDescription: null,
          hotelImagesTextDescription: [],
          sliderPosition: 0,
          foodHeader: [],
          foodHeaderAll: [],
          foodItems: [],
          foodItemsAll: [],
          food: [],
          coordinates: [parseFloat(x.Latitude), parseFloat(x.Longitude)],
          http: x.Http || "",
          hasImages: x.HasImages
        };
        let href = window.location.href;
        let selectedRoom = href.split("&").find(x2 => x2.includes("serviceDescriptions")).split("=")[1];
        selectedRoom = selectedRoom.split(",");
        selectedRoom = selectedRoom.filter(x2 => x2.split("_")[3] == 3)[i].split("_");
        const hotelRoom = +selectedRoom[5];
        const pansionKey = +selectedRoom[6];
        const partnerId = +selectedRoom[10];
        const pansionAdditionalInfo = href.split("&").find(x2 => x2.includes("pansionAdditionalInfo"))?.split("=")[1] || "";
        const criticalInfo = href.split("&").find(x2 => x2.includes("criticalInfo"))?.split("=")[1] || "";
        this.partnerId = partnerId;
        selectedRoom = hotelRoom + "_" + pansionKey + "_" + partnerId;
        if (pansionAdditionalInfo) {
          selectedRoom += "_" + decodeURIComponent(pansionAdditionalInfo)
        } else {
          selectedRoom += "_" + pansionAdditionalInfo
        }
        if (criticalInfo) {
          selectedRoom += "_" + decodeURIComponent(criticalInfo)
        } else {
          selectedRoom += "_" + criticalInfo
        }
        selectedRoom = selectedRoom.replaceAll("percent", "%")

        construct.hotelName = x.Hotel.Value;
        construct.nightCount = x.DurationInNight;
        construct.hotelCity = x.City.Value;
        construct.hotelCountry = x.Country.Value;
        construct.hotelStars = this.getStars(x.Stars.Value);
        construct.hotelFeatures = this.getFeatures(x.HotelTypes);
        let foodIsSelected = false;
        let firstFoodParams = [];

        x.HotelDetails.filter(x2 => x2.PartnerId === partnerId).forEach((x2, i2) => {
          const roomAndPansionKey =
              x2.HotelRoom + "_" +
              x2.Pansion.Key + "_" +
              x2.PartnerId + "_" +
              (x2.PansionAdditionalInfo || '') + "_" +
              (x2.CriticalInfo || '') + "_" +
              i2;
          const hasPansion = construct.foodItemsAll.some(arr => {
            return arr.some(x => {
              return x.value?.includes(roomAndPansionKey)
            })
          });

          const checkDuplicatePansion = construct.foodItemsAll.some(arr => {
               return arr.some(x => {
                   return +x.value?.split("_")[1] === x2.Pansion.Key &&
                          +x.value?.split("_")[0] === x2.HotelRoom &&
                          +x.value?.split("_")[2] === x2.PansionAdditionalInfo;
              })
           });

          if (
              (x2.Pansion.Key === pansionKey &&
                  x2.HotelRoom === hotelRoom &&
                  x2.PartnerId !== partnerId) || hasPansion || checkDuplicatePansion
          ) return;

          let pansion = x2.Pansion.Value + (x2.PansionAdditionalInfo != null ? " / " + x2.PansionAdditionalInfo : "");
          if (!construct.foodHeaderAll.includes(pansion)) {
            construct.foodHeaderAll.push(pansion);
          }

          let headerIndex = construct.foodHeaderAll.indexOf(pansion);
          let foodItemText = x2.Room.Value + " " + x2.AccomodationType.Value + " " + x2.RoomCategory.Value;
          let foodItemIndex = -1;
          construct.foodItemsAll.forEach((x3, i3) => {
            if (x3[0].text === foodItemText) {
              foodItemIndex = i3
            }
          });

          if (foodItemIndex === -1) {
            construct.foodItemsAll.push([{
              text: foodItemText
            }]);
            let value =
                x2.HotelRoom + "_" +
                x2.Pansion.Key + "_" +
                x2.PartnerId + "_" +
                (x2.PansionAdditionalInfo || "") + "_" +
                (x2.CriticalInfo || "");
            value = value.replaceAll('+', ' ')
            construct.foodItemsAll[construct.foodItemsAll.length - 1][headerIndex + 1] = {
              text: x2.Cost,
              cost: x2.Cost,
              quota: x2.QuotaStatus,
              criticalInfo: x2.CriticalInfo,
              value: value
            }

            if (selectedRoom === value.replaceAll('+', ' ') && !foodIsSelected) {
              //Вибираем питание
              construct.food = [
                (construct.foodItemsAll.length - 1),
                (headerIndex + 1),
                selectedRoom,
                x2.Cost
              ];
              foodIsSelected = true
            }
            if (i2 === 0) {
              firstFoodParams = [
                (construct.foodItemsAll.length - 1),
                (headerIndex + 1),
                value,
                x2.Cost
              ];
            }
          } else {
            let value =
                x2.HotelRoom + "_" +
                x2.Pansion.Key + "_" +
                x2.PartnerId + "_" +
                (x2.PansionAdditionalInfo || "") + "_" +
                (x2.CriticalInfo || "");
            value = value.replaceAll('+', ' ')

            let helper = true;
            let count = 0;
            while (helper) {
              if (construct.foodItemsAll[foodItemIndex][headerIndex + 1]) {
                headerIndex = headerIndex + 1;
                count++;
              } else {
                if (count && !construct.foodHeaderAll.includes(x2.Pansion.Value)) {
                  construct.foodHeaderAll.push(x2.Pansion.Value);
                }
                helper = false;
              }
            }

            construct.foodItemsAll[foodItemIndex][headerIndex + 1] = {
              text: x2.Cost,
              cost: x2.Cost,
              quota: x2.QuotaStatus,
              criticalInfo: x2.CriticalInfo,
              value: value
            }

            if (selectedRoom === value.replaceAll('+', ' ') && !foodIsSelected) {
              //Вибираем питание
              construct.food = [
                foodItemIndex,
                (headerIndex + 1),
                selectedRoom,
                x2.Cost
              ];
              foodIsSelected = true
            }
            if (i2 === 0) {
              firstFoodParams = [
                (construct.foodItemsAll.length - 1),
                (headerIndex + 1),
                value,
                x2.Cost
              ];
            }
          }
        });

        //Вибираем питание
        if (!foodIsSelected) {
          construct.food = firstFoodParams
        }

        //Заполняем пустие цены
        // const helper = {};
        construct.foodItemsAll = construct.foodItemsAll.map(x => {
          for (let i = 0; i < x.length; i++) {
            if (!x[i]) {
              x[i] = {
                text: "-",
                isEmpty: true
              }
              // if (helper[i]) helper[i]++;
              // else helper[i] = 1
            }
          }

          const columnLength = construct.foodHeaderAll.length;
          const itemsLength = x.length - 1;

          if (itemsLength < columnLength) {
            for (let i = 0; i < columnLength - itemsLength; i++) {
              x.push({
                text: "-",
                isEmpty: true
              })

              // let helperIndex = x.length - 1;
              // if (helper[helperIndex]) helper[helperIndex]++;
              // else helper[helperIndex] = 1;
            }
          }
          return x
        });

        // //Удаляем те колонки в которих все значения пустые
        // construct.foodItemsAll = construct.foodItemsAll.map(x => {
        //   return x.filter((x2, i2) => {
        //     return construct.foodItemsAll.length !== helper[i2]
        //   })
        // });
        // construct.foodHeaderAll = construct.foodHeaderAll.filter((x, i) => {
        //   return construct.foodItemsAll.length !== helper[i+1]
        // });

        this.getHotelImages(x.Hotel.Key)
            .then((res) => {
              construct.hotelImages = res.images;
              construct.hotelImagesDescription = res.description;
              construct.hotelImagesTextDescription = res.imagesDescription;
              this.$set(this.residence, i, construct);

              hotelsCount--;
              if (hotelsCount) return;

              hotels.forEach((x, i) => {
                this.$nextTick(() => {
                  this.setFoodTableData(i);
                  this.calcFood(i);
                })
              })
            })
      });
    },
      setServicesForCalculate() {
      let servicesAllInfo = this.tour.Services;
      this.cardLoaderStatus = true;
      let services = [];

      if (this.residence.length) {
        let hotels = servicesAllInfo.filter(x => x.SvKey === 3);

        hotels.forEach((x) => {
            let selectedHotel = x.HotelDetails.find(x => {
                let hotelRoomCost = this.residence.map(x2 => {
                    return x2.food[2].split("_")[0] + "_" + x2.food[3] + "_" + x2.food[2].split("_")[2] + "_" + (x2.food[2].split("_")[3] || "");
                });

                let hotelPansionKey = this.residence.map(x2 => {
                    return +x2.food[2].split("_")[1]
                }); 

                let key = x.HotelRoom + "_" + x.Cost + "_" + x.PartnerId + "_" + (x.PansionAdditionalInfo || "").replaceAll("+", " ");

                if (hotelRoomCost.includes(key) && x.Pansion.Key === hotelPansionKey[0]) {
                    this.selectedHotel = hotelRoomCost.indexOf(key);
                    return x;
                }
          });
          if (!selectedHotel) selectedHotel = x.HotelDetails[0];
          let remoteId = null;

          if (x.RemoteId || selectedHotel.RemoteId) {
            remoteId = (x.RemoteId || "") + ":" + (selectedHotel.RemoteId || "");
          }
          this.servicesSvKeyIdCategory.push([x.SvKey, x.Id, "Hotel"]);
          const service = this.$store.getters['basket/getReservationService']({
            serviceType: x.SvKey,
            code: x.Hotel.Key,
            subcode1: selectedHotel.HotelRoom,
            subcode2: selectedHotel.Pansion.Key,
            packet: x.PacketId,
            partner: selectedHotel.PartnerId,
            day: x.Day,
            durationInNight: x.DurationInNight,
            cityId: x.City.Key,
            countryId: x.Country.Key,
            templateId: x.Id,
            cost: selectedHotel.Cost,
            isInvisible: x.IsHooded,
            isNotCalculated: x.IsNotCalculate,
            quotaStatus: selectedHotel.QuotaStatus,
            beginDateTime: x.BeginDateTime,
            index: x.Index,
            isRoute: true,
            byPax: selectedHotel.ByPax,
            endDateTime: x.EndDateTime,
            remoteId: remoteId,
            isRemovable: x.IsDeleted,
          });
            services.push(service);
        });
      }

      const selectedFlight = this.flight[this.flightData.selected];
      if (selectedFlight.length) {
        selectedFlight.forEach(x => {
          const flight = x.allData;
          const selectedFlight = x.flightClassSelected.allData;

          this.servicesSvKeyIdCategory.push([flight.SvKey, flight.Id, "Flight"]);
          const service = this.$store.getters['basket/getReservationService']({
            serviceType: flight.SvKey,
            code: flight.Flight.Key,
            subcode1: selectedFlight.Tariff.Key,
            subcode2: flight.DepartureCity.Key,
            packet: flight.PacketId,
            partner: selectedFlight.PartnerId,
            day: flight.Day,
            durationInNight: flight.DurationInNight,
            cityId: flight.ArrivalCity.Key,
            countryId: flight.ArrivalCountry.Key,
            templateId: flight.Id,
            cost: selectedFlight.Cost,
            isInvisible: flight.IsHooded,
            isNotCalculated: flight.IsNotCalculate,
            quotaStatus: selectedFlight.QuotaStatus,
            beginDateTime: flight.BeginDateTime,
            index: flight.Index,
            isRoute: true,
            byPax: selectedFlight.ByPax,
            endDateTime: flight.EndDateTime,
            remoteId: flight.FlightId,
            isRemovable: flight.IsDeleted
          });
          if (this.flightCash[this.flightData.selected]) {
            service.RemoteId = x.remoteFlightId;
          }
          services.push(service)
        });
      }

      if (this.flightSurcharge[0]) {

        this.flightSurcharge.forEach(x => {
          const flightSurcharge = x;
          const selectedFlightSurcharge = x.Details[0];

          this.servicesSvKeyIdCategory.push([flightSurcharge.SvKey, flightSurcharge.Id, "Flight Surcharge"]);
          const service = this.$store.getters['basket/getReservationService']({
            serviceType: flightSurcharge.SvKey,
            code: flightSurcharge.Code.Key,
            subcode1: selectedFlightSurcharge.SubCode1.Key,
            subcode2: selectedFlightSurcharge.SubCode2.Key,
            packet: flightSurcharge.PacketId,
            partner: selectedFlightSurcharge.PartnerId,
            day: flightSurcharge.Day,
            durationInNight: flightSurcharge.DurationInNight,
            cityId: flightSurcharge.City,
            countryId: flightSurcharge.Country.Key,
            cost: selectedFlightSurcharge.Cost,
            isInvisible: flightSurcharge.IsHooded,
            isNotCalculated: flightSurcharge.IsNotCalculate,
            quotaStatus: selectedFlightSurcharge.QuotaStatus.PlacesStatus,
            index: flightSurcharge.Index,
            isRoute: false,
            byPax: selectedFlightSurcharge.ByPax,
            endDateTime: "",
            isRemovable: flightSurcharge.IsDeleted,
          });
          if (x.isChecked) {
            services.push(service)
          }
        })
      }

      if (this.busTransfer[0] && this.busTransfer[0].length) {
        const busTransfer = this.busTransfer[this.busData.selected];

        busTransfer.forEach(x => {
          const busTransfer = x.allData;
          const selectedBusTransfer = x.busTypeSelected.allData;

          this.servicesSvKeyIdCategory.push([busTransfer.SvKey, busTransfer.Id, "Bus Transfer"]);
          const service = this.$store.getters['basket/getReservationService']({
            serviceType: busTransfer.SvKey,
            code: busTransfer.BusTransfer.Key,
            subcode1: busTransfer.CityFrom.Key,
            subcode2: selectedBusTransfer.Transport.Key,
            packet: busTransfer.PacketId,
            partner: selectedBusTransfer.PartnerId,
            day: busTransfer.Day,
            durationInNight: busTransfer.DurationInNight,
            cityId: busTransfer.CityTo.Key,
            countryId: busTransfer.CountryTo.Key,
            templateId: busTransfer.Id,
            cost: selectedBusTransfer.Cost,
            isInvisible: busTransfer.IsHooded,
            isNotCalculated: busTransfer.IsNotCalculate,
            quotaStatus: selectedBusTransfer.QuotaStatus,
            beginDateTime: busTransfer.BeginDateTime,
            index: busTransfer.Index,
            isRoute: true,
            byPax: selectedBusTransfer.ByPax,
            endDateTime: null,
            remoteId: null,
            isRemovable: busTransfer.IsDeleted,
          })
          services.push(service)
        })
      }

      if (this.railwayTransfer[0] && this.railwayTransfer[0].length) {
        const railwayTransfer = this.railwayTransfer[this.railwayData.selected];

        railwayTransfer.forEach(x => {
          const railwayTransfer = x.allData;
          const selectedRailwayTransfer = x.railwayTypeSelected.allData;

          this.servicesSvKeyIdCategory.push([railwayTransfer.SvKey, railwayTransfer.Id, "Railway Transfer"]);
          const service = this.$store.getters['basket/getReservationService']({
            serviceType: railwayTransfer.SvKey,
            code: railwayTransfer.RailwayTransfer.Key,
            subcode1: selectedRailwayTransfer.Transport.Key,
            subcode2: null,
            packet: railwayTransfer.PacketId,
            partner: selectedRailwayTransfer.PartnerId,
            day: railwayTransfer.Day,
            durationInNight: railwayTransfer.DurationInNight,
            cityId: railwayTransfer.CityTo.Key,
            countryId: railwayTransfer.CountryTo.Key,
            templateId: railwayTransfer.Id,
            cost: selectedRailwayTransfer.Cost,
            isInvisible: railwayTransfer.IsHooded,
            isNotCalculated: railwayTransfer.IsNotCalculate,
            quotaStatus: selectedRailwayTransfer.QuotaStatus,
            beginDateTime: railwayTransfer.BeginDateTime,
            index: railwayTransfer.Index,
            isRoute: true,
            byPax: selectedRailwayTransfer.ByPax,
            endDateTime: null,
            remoteId: null,
            isRemovable: railwayTransfer.IsDeleted,
          })
          services.push(service)
        })
      }

      if (this.transfer[0] && this.transfer[0].length) {
        const transfer = this.tour.Services.filter(x => x.SvKey === 2);

        transfer.forEach((x, i) => {
          if (!this.transfer[0][i].isChecked) {
            return
          }

          this.servicesSvKeyIdCategory.push([x.SvKey, x.Id, "Transfer"]);
          const selectedTransfer = this.transfer[0].find(x2 => x.Id === x2.transferSelected.id).transferSelected.allData;
          const service = this.$store.getters['basket/getReservationService']({
            serviceType: x.SvKey,
            code: x.Code.Key,
            subcode1: selectedTransfer.SubCode1.Key,
            subcode2: selectedTransfer.SubCode2.Key,
            packet: x.PacketId,
            partner: selectedTransfer.PartnerId,
            day: x.Day,
            durationInNight: x.DurationInNight,
            cityId: x.City.Key,
            countryId: x.Country.Key,
            cost: selectedTransfer.Cost,
            isInvisible: x.IsHooded,
            isNotCalculated: x.IsNotCalculate,
            quotaStatus: selectedTransfer.QuotaStatus.PlacesStatus,
            beginDateTime: x.BeginDateTime,
            index: x.Index,
            isRoute: true,
            byPax: selectedTransfer.ByPax,
            endDateTime: null,
            remoteId: null,
            isRemovable: x.IsDeleted,
          })
          services.push(service)
        })
      }

      if (this.excursion.length) {
        this.excursion.forEach((x, i) => {
          if (!x.isChecked) {
            return
          }
          const excursion = x.selectedItem2;
          const selectedExcursion = this.excursion[i].excursionSelected.allData;

          this.servicesSvKeyIdCategory.push([excursion.SvKey, excursion.Id, "Excursion"]);
          const service = this.$store.getters['basket/getReservationService']({
            serviceType: excursion.SvKey,
            code: excursion.Code.Key,
            subcode1: selectedExcursion.SubCode1.Key,
            subcode2: selectedExcursion.SubCode2.Key,
            packet: excursion.PacketId,
            partner: selectedExcursion.PartnerId,
            day: excursion.Day,
            durationInNight: excursion.DurationInNight,
            cityId: excursion.City.Key,
            countryId: excursion.Country.Key,
            templateId: excursion.Id,
            cost: selectedExcursion.Cost,
            isInvisible: excursion.IsHooded,
            isNotCalculated: excursion.IsNotCalculate,
            quotaStatus: selectedExcursion.QuotaStatus.PlacesStatus,
            beginDateTime: excursion.BeginDateTime,
            index: excursion.Index,
            isRoute: false,
            byPax: selectedExcursion.ByPax,
            endDateTime: null,
            remoteId: null,
            isRemovable: excursion.IsDeleted,
          });
          services.push(service)
        })
      }

      if (this.additionalServices.length) {
        let country = null;
        this.additionalServices.forEach(x => {
          country = x.items[0].itemSelected.allData.Country.Key || country
        });

        this.additionalServices.forEach(x => {
          if (!x.items[0].itemSelected.isChecked) return;

          const additional = x.items[0].itemSelected.allData;
          const details1 = x.selectedDetail?.allData || x.selectedDetail2?.allData;
          const details2 = x.selectedDetail2?.allData || x.selectedDetail?.allData;
          const cityKey = additional.City ? additional.City.Key : null;

          let selectedDetail = additional.Details.find(x2 => x2.SubCode1.Key === x.selectedDetail.value);
          if (x.isRoute)
            selectedDetail = additional.Details
                .find(x2 => x2.SubCode1.Key + "_" + x2.SubCode2.Key === x.selectedDetail.value);

          this.servicesSvKeyIdCategory.push([additional.SvKey, additional.Id, additional.ServiceName]);
          const service = this.$store.getters['basket/getReservationService']({
            serviceType: additional.SvKey,
            code: additional.Code.Key,
            subcode1: details1.SubCode1.Key,
            subcode2: details2.SubCode2.Key,
            packet: additional.PacketId,
            partner: selectedDetail.PartnerId,
            day: additional.Day,
            durationInNight: additional.DurationInNight,
            cityId: cityKey,
            countryId: additional.Country.Key || country,
            templateId: additional.Id,
            cost: selectedDetail.Cost,
            isInvisible: additional.IsHooded,
            isNotCalculated: additional.IsNotCalculate,
            quotaStatus: details1.QuotaStatus.PlacesStatus,
            beginDateTime: additional.BeginDateTime,
            index: additional.Index,
            isRoute: x.isRoute,
            byPax: details1.ByPax,
            endDateTime: null,
            remoteId: null,
            isRemovable: additional.IsDeleted,
          });
          services.push(service)
        })
      }
      const tourists = [];
      this.trevelerForm.forEach((x, i) => {
        let treveler = this.trevelerInfo[i];
        let trevelerEndView = [];
        treveler.forEach(x2 => {
          if (x2.length) {
            x2.forEach(x3 => trevelerEndView.push(x3))
          } else {
            trevelerEndView.push(x2)
          }
        });

        const birdDate = trevelerEndView.find(x => x.code === "birthdate")?.value;
        // let age = 18;
        let age = +x.age;
        // if(this.getSettings.ChildAgesSetting)
        // {
        //   age = this.getSettings.ChildAgesSetting.at(-1)+1;
        // }
        let month = +x.age * 12
        if (birdDate) {
          age = this.calcTouristAge(birdDate);
          month = this.calcTouristAge(birdDate, 'month');
        }
        let childMaxAge = 18;
        let maxInfantAge = this.getSettings.MaxInfantAge;
        if (this.getSettings.ChildAgesSetting) {
          childMaxAge = this.getSettings.ChildAgesSetting.at(-1);
        }
        const ageType = age >= childMaxAge ? 0 : (month >= maxInfantAge ? 1 : 2);
        let BirthDay = this.trevelerFindValueByCode(trevelerEndView, "birthdate");
        BirthDay = this.convertToISODate(BirthDay);

        let InternationalPassportDateOfIssue = this.trevelerFindValueByCode(trevelerEndView, "passportdate");
        InternationalPassportDateOfIssue = this.convertToISODate(InternationalPassportDateOfIssue);

        let InternationalPassportDateOfExpiry = this.trevelerFindValueByCode(trevelerEndView, "passportdateend");
        InternationalPassportDateOfExpiry = this.convertToISODate(InternationalPassportDateOfExpiry);

        let PassportDateOfIssue = this.trevelerFindValueByCode(trevelerEndView, "passportdaterus");
        PassportDateOfIssue = this.convertToISODate(PassportDateOfIssue);

        let tourist = this.$store.getters['basket/getTouristModel']({
          IsMain: x.isMain,
          Number: i + 1,
          AgeType: ageType,
          MaleFemaleSex: this.trevelerFindValueByCode(trevelerEndView, "sex"),
          FirstName: this.trevelerFindValueByCode(trevelerEndView, "firstname"),
          LastName: this.trevelerFindValueByCode(trevelerEndView, "lastname"),
          Patronymic: this.trevelerFindValueByCode(trevelerEndView, "patronymic"),
          FirstNameRus: this.trevelerFindValueByCode(trevelerEndView, "firstnamerus"),
          LastNameRus: this.trevelerFindValueByCode(trevelerEndView, "lastnamerus"),
          PatronymicRus: this.trevelerFindValueByCode(trevelerEndView, "patronymicrus"),
          InternationalPassportSeries: this.trevelerFindValueByCode(trevelerEndView, "passport").split("/")[0],
          InternationalPassportNumber: this.trevelerFindValueByCode(trevelerEndView, "passport") ? this.trevelerFindValueByCode(trevelerEndView, "passport").split("/")[1] : "",
          InternationalPassportDateOfIssue,
          InternationalPassportDateOfIssueString: this.trevelerFindValueByCode(trevelerEndView, "passportdate"),
          InternationalPassportDateOfExpiry,
          InternationalPassportDateOfExpiryString: this.trevelerFindValueByCode(trevelerEndView, "passportdateend"),
          internationalPassportByWhom: this.trevelerFindValueByCode(trevelerEndView, "passportbywhom"),
          PassportSeries: this.trevelerFindValueByCode(trevelerEndView, "passportrus").split("/")[0],
          PassportNumber: this.trevelerFindValueByCode(trevelerEndView, "passportrus") ? this.trevelerFindValueByCode(trevelerEndView, "passportrus").split("/")[1] : "",
          PassportDateOfIssue,
          PassportDateOfIssueString: this.trevelerFindValueByCode(trevelerEndView, "passportdaterus"),
          PassportByWhom: this.trevelerFindValueByCode(trevelerEndView, "passportbywhomrus"),
          Citizenship: this.citizenshipFindValueByCode(trevelerEndView, "citizenship"),
          Phone: this.trevelerFindValueByCode(trevelerEndView, "phone"),
          Email: this.trevelerFindValueByCode(trevelerEndView, "email"),
          BirthDay,
          BirthDayString: this.trevelerFindValueByCode(trevelerEndView, "birthdate"),
          BirthPlace: this.trevelerFindValueByCode(trevelerEndView, "birthplace"),
          CitizenID: this.trevelerFindValueByCode(trevelerEndView, "citizenid"),
          Age: age,
          HowDidYouHear: this.trevelerFindValueByCode(trevelerEndView, "howdidyouhear"),
          ResidenceRegion: this.trevelerFindValueByCode(trevelerEndView, "residenceregion"),
          EnableSmsNotifications: 0
        });
        tourist = this.SetEmptyRequiredFields(tourist);
        tourists.push(tourist)
      })
      let touristsArray = tourists.map((x, i) => i + 1)
      services = services.map(x => {
        return {
          Service: x,
          TouristNumbersList: touristsArray
        }
      })
      let serviceGroup = [];

      this.insuranceItems.forEach((x, i) => {
        x.forEach((x2, i2) => {
          x2.forEach((x3, i3) => {
            const isSelected = this.insuranceValue[i][i2] === x3.value;
            if (isSelected && x3.allData) {
              let selectedServiceData = x3.allData;
              let serviceData = x3.serviceAllData;
              const cityKey = serviceData.City ? serviceData.City.Key : null;

              this.servicesSvKeyIdCategory.push([serviceData.SvKey, serviceData.Id, "Insurance"]);
              const service = this.$store.getters["basket/getReservationService"]({
                serviceType: serviceData.SvKey,
                code: serviceData.Code.Key,
                subcode1: selectedServiceData.SubCode1.Key,
                subcode2: selectedServiceData.SubCode2.Key,
                packet: serviceData.PacketId,
                partner: selectedServiceData.PartnerId,
                day: serviceData.Day,
                durationInNight: serviceData.DurationInNight,
                cityId: cityKey,
                countryId: serviceData.Country.Key,
                templateId: serviceData.Id,
                cost: selectedServiceData.Cost,
                isInvisible: serviceData.IsHooded,
                isNotCalculated: serviceData.IsNotCalculate,
                quotaStatus: selectedServiceData.QuotaStatus.PlacesStatus,
                beginDateTime: serviceData.BeginDateTime,
                index: serviceData.Index,
                isRoute: false,
                byPax: selectedServiceData.ByPax,
                endDateTime: null,
                remoteId: null,
                isRemovable: serviceData.IsDeleted,
              });
              delete service.AppliedCostOffersIds;
              serviceGroup.push({
                index: x3.serviceAllData.SvKey + "_" + i2 + i3,
                Service: service,
                TouristNumbersList: [i + 1]
              })
            }
          })
        });
      });
      this.visaItems.forEach((x, i) => {
        x.forEach((x2, i2) => {
          x2.forEach((x3, i3) => {
            const isSelected = this.visaValue[i][i2] === x3.value;
            if (isSelected && x3.allData) {
              let selectedServiceData = x3.allData;
              let serviceData = x3.serviceAllData;
              const cityKey = serviceData.City ? serviceData.City.Key : null;

              this.servicesSvKeyIdCategory.push([serviceData.SvKey, serviceData.Id, "Visa"]);
              const service = this.$store.getters["basket/getReservationService"]({
                serviceType: serviceData.SvKey,
                code: serviceData.Code.Key,
                subcode1: selectedServiceData.SubCode1.Key,
                subcode2: selectedServiceData.SubCode2.Key,
                packet: serviceData.PacketId,
                partner: selectedServiceData.PartnerId,
                day: serviceData.Day,
                durationInNight: serviceData.DurationInNight,
                cityId: cityKey,
                countryId: serviceData.Country.Key,
                templateId: serviceData.Id,
                cost: selectedServiceData.Cost,
                isInvisible: serviceData.IsHooded,
                isNotCalculated: serviceData.IsNotCalculate,
                quotaStatus: selectedServiceData.QuotaStatus.PlacesStatus,
                beginDateTime: serviceData.BeginDateTime,
                index: serviceData.Index,
                isRoute: false,
                byPax: selectedServiceData.ByPax,
                endDateTime: null,
                remoteId: null,
                isRemovable: serviceData.IsDeleted,
              });
              delete service.AppliedCostOffersIds;
              serviceGroup.push({
                index: x3.serviceAllData.SvKey + "_" + i2 + i3,
                Service: service,
                TouristNumbersList: [i + 1]
              })
            }
          })
        });
      });

      this.hotelServices.forEach((x, i) => {
        x.forEach((x2) => {
          let selectedServiceData = x2.Details[0];
          let serviceData = x2;
          const cityKey = serviceData.City ? serviceData.City.Key : null;

          this.servicesSvKeyIdCategory.push([serviceData.SvKey, serviceData.Id, "Hotel Service"]);
          const service = this.$store.getters["basket/getReservationService"]({
            serviceType: serviceData.SvKey,
            code: serviceData.Code.Key,
            subcode1: selectedServiceData.SubCode1.Key,
            subcode2: selectedServiceData.SubCode2.Key,
            packet: serviceData.PacketId,
            partner: selectedServiceData.PartnerId,
            day: serviceData.Day,
            durationInNight: serviceData.DurationInNight,
            cityId: cityKey,
            countryId: serviceData.Country.Key,
            templateId: serviceData.Id,
            cost: selectedServiceData.Cost,
            isInvisible: serviceData.IsHooded,
            isNotCalculated: serviceData.IsNotCalculate,
            quotaStatus: selectedServiceData.QuotaStatus.PlacesStatus,
            beginDateTime: serviceData.BeginDateTime,
            index: serviceData.Index,
            isRoute: false,
            byPax: selectedServiceData.ByPax,
            endDateTime: null,
            remoteId: null,
            isRemovable: serviceData.IsDeleted,
          });
          delete service.AppliedCostOffersIds;
          serviceGroup.push({
            index: JSON.stringify(service),
            Service: service,
            TouristNumbersList: [i + 1]
          })
        });
      });

      let serviceGroupCorrect = [];
      let serviceGroupCorrectIndex = [];

      serviceGroup.forEach(x => {
        let index = serviceGroupCorrectIndex.indexOf(x.index)
        if (index !== -1) {
          serviceGroupCorrect[index].TouristNumbersList.push(x.TouristNumbersList[0])
        } else {
          serviceGroupCorrectIndex.push(x.index)
          serviceGroupCorrect.push({
            Service: x.Service,
            TouristNumbersList: x.TouristNumbersList
          })
        }
      });
      serviceGroupCorrect.forEach(x => {
        services.push(x)
      });

      // если хотя бы один из перелетов коммиссионный всем проставляем коммиссионность
      let isCommission = false;
      let baseFlightsParams = [];
      let flight = [...this.flight[this.flightData.selected]];
      if (this.flightCash[this.flightData.selected]) {
        flight = [...this.flightCash[this.flightData.selected]];
      }

      flight.forEach(x => {
        let tariff = x.flightClassSelected.allData.Tariff.Key;
        let partnerId = x.flightClassSelected.allData.PartnerId;
        let cityArrival = x.allData.ArrivalCity.Key;
        let flightCode = x.allData.Flight.Key;

        if (x.flightClassSelected.allData.IsCommission) {
          isCommission = true
        }

        let res = {
          CityArrival: cityArrival,
          FlightCode: flightCode,
          TariffKey: tariff,
          PartnerId: partnerId
        }
        baseFlightsParams.push(res)
      });


      services = services.map(x => {
        x.Service.IsCommission = isCommission;
        x.Service.BaseFlightsParams = baseFlightsParams;
        return x
      });

      services.sort((a, b) => a.Service.Index - b.Service.Index);

      this.services = services;
      this.tourists = tourists;
    },
    convertToISODate(date) {
      if (!date) return date;
      return new Date(date.split(".").reverse().join("/")).toISOString()
    },
    SetEmptyRequiredFields(tourist) {
      if (
          !tourist.FirstNameRus
          && this.touristSettings.firstnamerus.IsRequired
          && !this.touristSettings.firstnamerus.IsVisible
      ) {
        tourist.FirstNameRus = tourist.FirstName;
      }

      if (
          !tourist.LastNameRus
          && this.touristSettings.lastnamerus.IsRequired
          && !this.touristSettings.lastnamerus.IsVisible
      ) {
        tourist.LastNameRus = tourist.LastName;
      }
      return tourist;
    },
    calcTouristAge(date, by = "years") {
      const correctDate = new Date(date.split(".").reverse().join("/"));
      return moment(this.tourCardData.endDate).diff(correctDate, by)
    },
    calculateIndividualServiceCost() {
      let services = [];
      this.tour.NotRouteServices
          .filter(x => x[0].SvKey === 6 || x[0].SvKey === 5)
          .forEach(x => {
            let service;

            x.forEach(x2 => {
              x2.Details.forEach(x3 => {
                let selectedServiceData = x3;
                let serviceData = x2;
                const cityKey = serviceData.City ? serviceData.City.Key : null;

                service = this.$store.getters["basket/getReservationService"]({
                  serviceType: serviceData.SvKey,
                  code: serviceData.Code.Key,
                  subcode1: selectedServiceData.SubCode1.Key,
                  subcode2: selectedServiceData.SubCode2.Key,
                  packet: serviceData.PacketId,
                  partner: selectedServiceData.PartnerId,
                  day: serviceData.Day,
                  durationInNight: serviceData.DurationInNight,
                  cityId: cityKey,
                  countryId: serviceData.Country.Key,
                  templateId: serviceData.Id,
                  cost: selectedServiceData.Cost,
                  isInvisible: serviceData.IsHooded,
                  isNotCalculated: serviceData.IsNotCalculate,
                  quotaStatus: selectedServiceData.QuotaStatus,
                  beginDateTime: serviceData.BeginDateTime,
                  index: null, //serviceData.Index
                  isRoute: false,
                  byPax: false, //selectedServiceData.ByPax
                  endDateTime: null,
                  remoteId: null,
                  isRemovable: serviceData.IsDeleted,
                });
                delete service.AppliedCostOffersIds;
                services.push(service);
              });
            });
          });

      this.setServicesForCalculate();

      let ages = new Set();
      this.tourists.forEach(x => {
        if (x.BirthDayString) {
          ages.add(this.calcTouristAge(x.BirthDayString))
        } else {
          ages.add(x.Age)
        }
      });
      ages = Array.from(ages);

      let sendParams = {
        Ages: ages,
        Currency: this.tour.Rate,
        Services: services,
        TourDate: this.tour.StartDate,
        TourDuration: this.tour.Duration,
        TourProgramId: this.tour.Key,
      };

      return new Promise((resolve) => {
        this.$store.dispatch('basket/A_CALCULATE_INDIVIDUAL_SERVICE_COST', sendParams)
            .then((res) => {
              if (res.ValidationResult.IsValid) {
                this.notRouteServices = [...res.TouristAgeServiceCosts];
                this.createTrevelerServices(this.tour);
                resolve()
              } else {
                let errText = "";
                res.ValidationResult.Errors.forEach(x => {
                  const text = x.split("[").map(x2 => {
                    x2 = x2.split("]");

                    if (x2.length > 1) {
                      return this.localizeList[x2[0]] + x2[1]
                    } else {
                      return x2[0];
                    }
                  }).join("");
                  errText += (errText ? "\n" : "") + text
                });
                alert(errText);
                resolve()
              }
            })
      })
    },
    mapBookingAdditionalInfo(arr) {
      if (!arr) return arr;

      return arr.map(x => {
        x.Message = x.Message.replace("[notIncludedTaxesFeesUpper]", this.localizeList.notIncludedTaxesFeesUpper)
            .replaceAll("environmental_fee", this.localizeList.environmentalFeeUpper)
            .replaceAll("city_tax", this.localizeList.cityTaxUpper)
            .replaceAll("resort_fee", this.localizeList.resortFeeUpper)
            .replaceAll("luxury_tax", this.localizeList.luxuryTaxUpper)
            .replaceAll("hotel_fee", this.localizeList.hotelFeeUpper)
            .replaceAll("cleaning_fee", this.localizeList.cleaningFeeUpper)
            .replaceAll("transfer_fee", this.localizeList.transferFeeUpper)
            .replaceAll("service_fee", this.localizeList.serviceFeeUpper)
            .replaceAll("occupancy_tax", this.localizeList.occupancyTaxUpper)
            .replaceAll("electricity_fee", this.localizeList.electricityFeeUpper)
            .replaceAll("vat", this.localizeList.vatUpper)
            .replaceAll("\n", "<br />");
        return x
      })
    },
    calculateTour(sendRequest = true, isFlight = false) {
      if (!this.$route.path.includes("Basket"))
        return;

      this.setServicesForCalculate();

      const langCode = localStorage.getItem("localize");
      const sendData = {
        tourProgramId: this.tour.Key,
        beginDate: this.tour.StartDate,
        duration: this.tour.Duration,
        currency: this.tour.Rate,
        initialPrice: {
          price: this.tour.Cost,
          currency: this.tour.Rate
        },
        services: this.services,
        tourists: this.tourists,
        Day: this.localizeList.day,
        Day2: this.localizeList.day2,
        Days: this.localizeList.days,
        Night: this.localizeList.night,
        Night2: this.localizeList.night2,
        Nights: this.localizeList.nights,
        adultsCountOverServiceLimit: this.localizeList.adultsCountOverServiceLimitUpper,
        at: this.localizeList.at,
        incorrectChildrenInf: this.localizeList.incorrectChildrenInf,
        dogovorComment: this.dogovorComment,
        languageCode: langCode,
        NationalCurrencyCode: window.settings.NationalCurrencyCode,
        PromocodeId: this.promocodeId,
        DiscountCardId: this.discountCardId
      }
      if (!sendRequest) {
        return
      }
      this.universalParametrs.loader = true;
      this.universalParametrs.tariffName = "";
      return new Promise((resolve, reject) => {
        this.$store.dispatch("basket/" + typesBasket.A_CALCULATE_TOUR, sendData)
            .then(res => {
              if (!res.IsValid) {
                reject()
              }
              this.outHotelCalculateData = [];
              this.bookingAdditionalInfo = [];
              this.BookingHash = res.CalculatedReservation.ServiceTourists[0].BookHash;
              const MExtraInfo = res.CalculatedReservation.ServiceTourists[0].MetapolicyExtraInfo;
              this.MetapolicyExtraInfo = MExtraInfo ? JSON.parse(MExtraInfo) : null;
              let hotels = res.CalculatedReservation.ServiceTourists.filter(x => x.ServiceType === 3);
              let helper = false;
              hotels.forEach(x => {
                let cancellationPolicy = x.CancellationPolicy ? x.CancellationPolicy : [];
                if (cancellationPolicy.length) {
                  this.outHotelCalculateData.push([...cancellationPolicy]);
                  if (cancellationPolicy.length && !helper) {
                    helper = true;
                    this.alertShow(-1, 5000, true);
                    setTimeout(() => (this.firstTimeShowTax = false), 6000)
                  }
                } else {
                  this.outHotelCalculateData.push([]);
                }

                x.BookingAdditionalInfo = this.mapBookingAdditionalInfo(x.BookingAdditionalInfo);
                this.bookingAdditionalInfo.push(x.BookingAdditionalInfo);
              });

              this.universalParametrs.items = [];
              if (res.TariffDescription?.universalParametrsSequence) {
                const description = res.TariffDescription.universalParametrsSequence[0].universalParametrs.find(x => x.code === 'description');
                this.universalParametrs.tariffName = description.shortDescriptions[0].value;

                let free = [];
                let charge = [];
                let notAviabillity = [];
                res.TariffDescription.universalParametrsSequence[0].universalParametrs.forEach(x2 => {
                  if (x2.code !== "description") {
                    const param = {
                      status: status,
                      code: x2.code,
                      number: 0,
                      text: ""
                    };

                    if (x2.code === 'carry_on') {
                      param.number = 1;
                      param.text = this.localizeList.carryOnRestrictionUpper + ": " + x2.shortDescriptions[0].value;
                    } else if (x2.code === 'baggage') {
                      param.number = 2;
                      param.text = this.localizeList.baggageRestrictionUpper + ": " + x2.shortDescriptions[0].value;
                    } else {
                      param.number = 3;
                      param.text = x2.shortDescriptions[0].value;
                    }

                    if (x2.needToPay === 'Free') {
                      param.status = 1;
                      free.push(param)
                    } else if (x2.needToPay === 'Charge') {
                      param.status = 2;
                      charge.push(param)
                    } else {
                      param.status = 3;
                      notAviabillity.push(param)
                    }
                  }
                });
                free = this.sortInuversalParam(free);
                charge = this.sortInuversalParam(charge);
                notAviabillity = this.sortInuversalParam(notAviabillity);

                this.universalParametrs.items = [...free, ...charge, ...notAviabillity];
              } else {
                if (res.CarryOnBaggage.length) {
                  this.universalParametrs.items.push({
                    status: 1,
                    code: "carry_on",
                    text: this.localizeList.carryOnRestrictionUpper + ": " + res.CarryOnBaggage
                  })
                }
                if (res.Baggage.length) {
                  this.universalParametrs.items.push({
                    status: 1,
                    code: "baggage",
                    text: this.localizeList.baggageRestrictionUpper + ": " + res.Baggage
                  })
                }
              }
              this.universalParametrs.loader = false;

              let data = res.CalculatedReservation;
              this.tourCardData.totalPrice = data.TotalPrice;
              this.tourCardData.nationalTotalPrice = data.NationalTotalPrice.toFixed(2);
              this.tourCardData.calculatedServicesPrice = data.CalculatedServicesPrice;
              this.tourCardData.natinoalCalculatedServicesPrice = data.NatinoalCalculatedServicesPrice.toFixed(2);
              this.tourCardData.currency = data.Currency;
              this.tourCardData.nationalPrice = data.NationalPrice.toFixed(2);
              this.tourCardData.changedPrice = data.ChangedPrice;
              this.tourCardData.nationalChangedPrice = data.NationalChangedPrice.toFixed(2);
              this.tourCardData.discount = data.Discount;
              this.tourCardData.totalDiscount = data.TotalDiscount;
              this.tourCardData.nationalTotalDiscount = data.NationalTotalDiscount.toFixed(2);
              this.tourCardData.isDiscountIsPercent = data.IsDiscountIsPercent;
              this.tourCardData.price = data.Price;
              this.tourCardData.nationalCode = res.NationalCurrency;
              this.tourCardData.nationalCurrency = res.NationalRate;
              this.tourCardData.tourCurrency = res.Rate;
              this.tourCardData.tourName = res.TourName;
              this.tourCardData.endDate = res.EndDate;
              this.tourCardData.beginDate = res.CalculatedReservation.BeginDate;
              this.tourCardData.hasRealCourses = res.HasRealCourses;
              this.tourCardData.changedPrice = data.ChangedPrice;
              this.tourCardData.promoDiscount = data.PromoDiscount;
              this.tourCardData.promoIsDiscountIsPercent = data.PromoIsDiscountPercent;
              this.tourCardData.promoTotalDiscount = data.PromoTotalDiscount;
              this.tourCardData.promoNationalDiscount = data.PromoNationalDiscount.toFixed(2);
              this.tourCardData.initialized = true;

              let hotelKey = 0;
              let serviceTourists = data.ServiceTourists.map(x => {
                x.quota = x.QuotaPlaces;

                if (x.ServiceType === 1) {
                  x.type = "flight";
                  x.typeIcon = "flight";
                } else if (x.ServiceType === 12) {
                  x.type = "flightSurcharge";
                  x.typeIcon = "flight";
                } else if (x.ServiceType === 13) {
                  x.type = "trevelerData";
                  x.typeIcon = "hotel";
                } else if (x.ServiceType === 2) {
                  x.type = "transfer";
                    x.typeIcon = "taxi";
                    if (x.AppliedSpecials) {
                        const path = this.$store.getters['getPath'];
                        const origin = this.$store.getters['getApiOrigin'];
                        x.COAndSpecialInfo = [];
                        x.AppliedSpecials.forEach(x2 => {
                            const title = this.$store.getters['tour/getSpecialText'](x2, this.localizeList);
                            const src = `${origin}${path}/GetImage/GetSpecialsImage?specialType=${x2.SpecialType}&width=100&height=100`;
                            const isInclude = x.COAndSpecialInfo.map(x3 => `${x3.title}${x3.src}`).includes(`${title}${src}`);
                            if (isInclude) return;

                            x.COAndSpecialInfo.push({ title, src })
                        });
                    }
                } else if (x.ServiceType === 3) {
                  x.key = hotelKey;
                  hotelKey++;
                  x.type = "residence";
                  x.typeIcon = "hotel";
                  if (x.Name.length) {
                    const path = this.$store.getters['getPath'];
                    const origin = this.$store.getters['getApiOrigin'];
                    x.COAndSpecialInfo = [];
                    if (x.AppliedCOInfo) {
                      x.AppliedCOInfo.forEach(x2 => {
                        const title = x2.InfoText;
                        const myPath = `${origin}${path}`;
                        //console.log("Basket. Id: " + x2.IdCostOffer + " title: " + title, " Path: ", myPath);

                        const src = `${myPath}/GetImage/GetCostOfferFile?&id=${x2.IdCostOffer}&width=50&height=50&text=${!!x2.InfoText}`;
                        this.$store.dispatch('tour/A_GET_CO_IMAGE_INFO', {IdCostOffer: x2.IdCostOffer, InfoText: !!x2.InfoText, Path: myPath})
                        .then(res => {
                          if (res){
                           // console.log("A_GET_CO_IMAGE_INFO. id: " + x2.IdCostOffer + " title: " + title + " src: " + src);
                            x.COAndSpecialInfo.push({title, src})
                          }                        
                        });

                        const isInclude = x.COAndSpecialInfo.map(x3 => `${x3.title}${x3.src}`).includes(`${title}${src}`);
                        if (isInclude) return;

                      });
                    }

                    if (x.AppliedSpecials) {
                      x.AppliedSpecials.forEach(x2 => {
                        const title = this.$store.getters['tour/getSpecialText'](x2, this.localizeList);
                        const src = `${origin}${path}/GetImage/GetSpecialsImage?specialType=${x2.SpecialType}&width=100&height=100`;
                        const isInclude = x.COAndSpecialInfo.map(x3 => `${x3.title}${x3.src}`).includes(`${title}${src}`);
                        if (isInclude) return;

                        x.COAndSpecialInfo.push({title, src})
                      });
                    }
                  }
                } else if (x.ServiceType === 4) {
                  x.type = "excursion";
                  x.typeIcon = "excursion";
                } else if (x.ServiceType === 14) {
                  x.type = "bus";
                  x.typeIcon = "bus";
                } else if (x.ServiceType === 15) {
                  x.type = "railway";
                  x.typeIcon = "train";
                } else if (x.ServiceType === 6) {
                  x.type = "trevelerData";
                  x.typeIcon = "umbrella";
                } else if (x.ServiceType === 5) {
                  x.type = "trevelerData";
                  x.typeIcon = "network";
                } else {
                  x.type = null;
                  x.typeIcon = null;
                }
                return x
              });

              let requiredServices = serviceTourists.filter(x => x.Attributes === 32768);
              this.tourCardData.requiredServices = [];
              requiredServices.forEach(x => {
                this.tourCardData.requiredServices.push(x);
              });

              let additionalServices = serviceTourists.filter(x => x.Attributes === 32769);
              this.tourCardData.additionalServices = [];
              additionalServices.forEach(x => {
                this.tourCardData.additionalServices.push(x);
              });

              serviceTourists = serviceTourists.filter(x => x.Attributes !== 64 && x.Attributes !== 32768 && x.Attributes !== 32769);
              this.tourCardData.serviceTourists = [];
              serviceTourists.forEach(x => {
                this.tourCardData.serviceTourists.push(x);
              });
              setTimeout(() => {
                this.cardLoaderStatus = false;
                this.windowScroll();
              }, 500);
              resolve();
            })
            .catch(err => {
              if (isFlight) {
                bus.$emit("basket-flight", false);
                let alertText = this.localizeList.warningTechnicalProblemsMessageUpper.replace("{0}", "\n").replace("{1}", "\n");
                alert(alertText);
                bus.$emit("page-load", false);
                this.cardLoaderStatus = false;
                // reject()
                return
                //reject()
              } else {
                const hasVariable = err.includes("[");
                if (hasVariable) {
                  let variables = [];
                  let helper = err.split("[");
                  helper.forEach(x => {
                    if (!x.includes("]")) return;

                    const variable = x.split("]")[0];
                    variables.push(variable)
                  });

                  variables.forEach(x => {
                    err = err.replaceAll(x, this.localizeList[variables])
                  });
                  err = err.replaceAll("[", "")
                      .replaceAll("]", "")
                }
                alert(err)
              }
              setTimeout(() => this.cardLoaderStatus = false, 500);
            })
      });
    },
    sortInuversalParam(array) {
      return array.sort(function (a, b) {
        return a.number > b.number ? 1 : -1;
      });
    },
    trevelerFindValueByCode(trevelerEndView, code) {
      const field = trevelerEndView.find(x2 => x2.code === code);
      if (field) {
        return field.value
      } else {
        return ""
      }
    },
    citizenshipFindValueByCode(trevelerEndView, code) {
      const field = trevelerEndView.find(x2 => x2.code === code);
      if (field) {
        return this.citizenshipList.find(x => x.Key === field.value)?.Name || ""
      } else {
        return ""
      }
    },
    changeHotelService(e, key) {
      const oldVal = this.hotelServices[key];
      let oldCost = oldVal[0]?.Details?.[0]?.Cost || 0;
      this.$set(this.hotelServices, key, [...e]);
      const isNotCalculate = this.hotelServices[key]?.[0]?.IsNotCalculate || oldVal[0]?.IsNotCalculate;
      if (!isNotCalculate) oldCost = this.tourCardData.calculatedServicesPrice;
      if (this.readyForCalculate) {
        const selectedItems = e;
        const isNotSelected = !e.length;
        const currency = this.$store.getters['getAllCurrency'].find(x => x.Code === this.tour.Rate).IsoCode;

        let oldName = this.getServiceNameBySvKey(13, key) || "Hotel Service";

        this.calculateTour()
            .then(() => {
              let newCost = this.hotelServices[key]?.[0]?.Details?.[0]?.Cost || 0;
              let isAdded = oldVal.length === 0;
              if (!isNotCalculate) {
                newCost = this.tourCardData.calculatedServicesPrice;
                isAdded = false;
              }

              if (isNotSelected) {
                this.GTMRemoveHotelService(key, oldVal[0], oldCost, currency, oldName, newCost)
              } else {
                selectedItems.forEach(x => {
                  this.GTMChangeHotelService(key, x, newCost, currency, isAdded, oldName, oldCost)
                })
              }
            })
      }
    },
    GTMChangeHotelService(key, allData, cost, currency, isAdded, oldName, oldCost) {
      // Google Tag Manager
      let name = this.getServiceNameBySvKey(13, key) || "Hotel Service";
      GTM[isAdded ? 'addToCart' : 'updateCard'](allData, cost, "Hotel Service", this.tour, currency, name, "addToCart", oldName, oldCost);
      // End Google Tag Manager
    },
    GTMRemoveHotelService(key, allData, cost, currency, name, newCost) {
      // Google Tag Manager
      if (allData.IsNotCalculate) {
        GTM.removeFromCard(allData, cost, "Hotel Service", this.tour, currency, name, "changeCart");
      } else {
        GTM.updateCard(allData, newCost, "Hotel Service", this.tour, currency, name, "changeCart", name, cost);
      }
      // End Google Tag Manager
    },
    touristValid() {
      let isValid = true;
      this.trevelerInfo = this.trevelerInfo.map(x => {
        x = x.map(x2 => {
          if (x2.length) {
            x2 = x2.map(x3 => {
              if (x3.required && x3.value === "" || !x3.isValid) {
                x3.isValid = false;
                isValid = false
              }
              return x3
            })
          } else {
            if (x2.required && x2.value === "" || !x2.isValid) {
              x2.isValid = false;
              isValid = false
            }
          }
          return x2
        })
        return x
      });

      return isValid
      },
      touristValidNoRegistration() {
        let isValid = true;
        this.trevelerInfo = this.trevelerInfo.map(x => {
            x = x.map(x2 => {
                if (x2.length) {
                    x2 = x2.map(x3 => {
                        if (x3.bookingNoRegistration && x3.value === "" || !x3.isValid || x2.code == 'email' && x2.value === "" ) {
                            x3.isValid = false;
                            isValid = false
                        }
                        return x3
                    })
                } else {
                    if (x2.bookingNoRegistration && x2.value === "" || !x2.isValid || x2.code == 'email' && x2.value === "" ) {
                        x2.isValid = false;
                        isValid = false
                    }
                }
                return x2
            })
            return x
        });

        return isValid
    },
    showClientAgreePopup() {
      let rect = document.getElementById('clientAgree').getBoundingClientRect();
      let res = {
        x: rect.left + (rect.width / 2),
        y: rect.top,
        text: this.localizeList.acceptsConditionsNotifyText,
        height: rect.height
      };
      this.$store.dispatch('A_SHOW_POPOVER', res);
      setTimeout(this.hidePopover, 3000)
    },
    GTMCheckout() {
      const products = [];

      this.services.forEach((x, i) => {
        if (!x.Service.IsNotCalculated) return;

        const id = this.servicesSvKeyIdCategory.find(x2 => x2[0] === x.Service.ServiceType)[1];
        const category = this.servicesSvKeyIdCategory.find(x2 => x2[0] === x.Service.ServiceType)[2];

        const key = products.filter(x2 => x2.category === category).length;
        let name = this.getServiceNameBySvKey(x.Service.ServiceType, key) || "";

        const price = x.Service.ByPax ? x.Service.Cost / (this.adultCount + this.childCount) * x.TouristNumbersList.length : x.Service.Cost;
        products.push({
          id,
          name,
          price,
          category,
          position: i + 1,
          quantity: 1,
        });
      });
      this.GTMProducts = products;
      const actionField = {step: 1};
      const currency = this.$store.getters['getAllCurrency'].find(x => x.Code === this.tour.Rate).IsoCode;

      GTM.checkout(products, actionField, this.tourCardData.calculatedServicesPrice, currency)
    },
    GTMTransaction(code, success = true) {
      let actionField = {
        id: code,
        affiliation: this.userInfo.UserId,
        revenue: this.tourCardData.totalPrice,
        tax: this.tourCardData.totalDiscount
      };
      if (!success) actionField = {status: "Refund"};
      const currency = this.$store.getters['getAllCurrency'].find(x => x.Code === this.tour.Rate).IsoCode;

      GTM.transaction(this.GTMProducts, actionField, currency)
    },
    checkWarningAndBan() {
        return new Promise((resolve) => {
            bus.$emit('check-warning-and-ban', (resultWarningAndBan) => {
                if (resultWarningAndBan?.warningText) {
                    const confirmWarning = this.localizeList.partnerWarningConfirmText.replace("{0}", resultWarningAndBan.warningText)
                    const confirmAnswer = confirm(confirmWarning)
                    resolve(confirmAnswer)
                    return
                }
                resolve(true)
            })
        })
    },
      getCookie() {

          if (this.getSettings.SaveDataStatOnline) {
              var objectCookie = document.cookie.split('; ').reduce((prev, current) => {
                  const [name, ...value] = current.split('=');

                  if (name == '_ga' || name == '_gid' || name == '_ym_uid' || name == 'roistat_visit') {
                      prev.push({ CookieName: name, CookieValue: value.join('=') });
                  }
                  return prev;
              }, []);
              return objectCookie;
          } else {
              return [];
          }
    },
    async buyTour(iAgreeToReceive = null) {
      this.cardLoaderStatus = true;
      iAgreeToReceive = { iAgreeToReceive: this.$store.getters['basket/getAgreeToReceive'] };
      const cookie = document.cookie;
      const authenticatedNow = cookie.includes("CommonApplicationAuthCookie_.masterweblight-auth");
      if (!this.touristValid()) {
        this.cardLoaderStatus = false;
        this.scrollToBlock('trevelerData');
        this.alertType = 'validation';
        this.$store.dispatch('A_SET_ALERT', 5000);
        return
      }

      if (!this.isAuthenticated) {
        this.cardLoaderStatus = false;
        bus.$emit('open-login-form', {fromBasket: true});
        return
      }
      if (!authenticatedNow) {
        this.cardLoaderStatus = false;
        bus.$emit('logout', () => {
          this.openCard = false;
          bus.$emit('open-login-form', {fromBasket: true});
        });
        return
      }
      if (this.tourCardData.price == 0) {
        this.cardLoaderStatus = false;
        return
      }
      if (this.userInfo.UserType === 1 && !this.clientAgree) {
        this.showClientAgreePopup()
        this.cardLoaderStatus = false;
        return
      }

      // Проверяем на наличие предуприждений
      const confirmAnswer = await this.checkWarningAndBan()
      if (!confirmAnswer) {
        this.cardLoaderStatus = false;
        return
      }

      /* Если изначално состаится переход к а/п из в.с., делаем проверку на то что выбраный перелет из в.с. */
      if (this.toFlightMounted && !this.flight[this.flightData.selected][0].isGDS) {
        let confirmText = this.localizeList.warningModalFormWithRequiredFlightsUpper.replace("{0}", "\n");
        let isAgree = confirm(confirmText);
        if (!isAgree) {
          this.cardLoaderStatus = false;
          return;
        }
      }

      this.calculateTour(false);

      const beginDate = this.tourHeadline.startDate;
      let timeLimit = this.flight[this.flightData.selected]?.[0]?.timeLimit;
      timeLimit = timeLimit ? getLocalTimeLimit(timeLimit) : null;
      let cookieTour = this.getCookie();

      const basketUrl = this.$store.getters['getMwSendReservationMails'];

      const orderInfo = this.$store.getters['getOrderInfo'].split("/").reverse()[0];
      const sendReservationMails = basketUrl.split("/").reverse()[0];

      const orderInfoUrl = basketUrl.replace(sendReservationMails, orderInfo);

      const sendData = {
        TourProgramId: this.tour.Key,
        BeginDate: this.tour.Services[0]?.BeginDateTime || beginDate,
        Duration: this.tour.Duration,
        Currency: this.tour.Rate,
        Services: this.services,
        Tourists: this.tourists,
        TechnicalProblemsDuringUpdateFlights: false,
        TimeLimit: timeLimit,
        CountryKey: this.tour.CountryId,
        OwnerId: 0,
        Day: this.localizeList.day,
        Day2: this.localizeList.day2,
        Days: this.localizeList.days,
        Night: this.localizeList.night,
        Night2: this.localizeList.night2,
        Nights: this.localizeList.nights,
        adultsCountOverServiceLimit: this.localizeList.adultsCountOverServiceLimitUpper,
        incorrectChildrenInf: this.localizeList.incorrectChildrenInf,
        dogovorComment: this.dogovorComment,
        BookingHash: this.BookingHash,
        CustomerData: this.customerData,
        CookieUser: cookieTour,
        OrderInfoUrl: orderInfoUrl,
        PromocodeId: this.promocodeId,
        DiscountCardId: this.discountCardId
      }

      if(this.settings.IAgreeToReceiveMessages)
      {
        sendData.Tourists.forEach(x => {
          x.EnableSmsNotifications = iAgreeToReceive.iAgreeToReceive;
        })
      }


      if (this.branches.selected && this.branches.selected > 0) {
        sendData.BranchId = this.branches.selected;
      } else {
        this.managers.selected = this.tour.DefaultManagers[0];
      }

      sendData.OwnerId = this.managers.selected > 0 ? this.managers.selected : 0;

      // Проверка заявки на наличие дубликатов в базе. Если дубликаты есть - заявку не создаем , а выводим сообщение для подтверждения!
      const isDouble = await this.checkDoubleDogovor(sendData);
      if (isDouble) {
        this.cardLoaderStatus = false;
        return;
      }
      this.GTMCheckout();
      bus.$emit("page-load", true);
      this.$store.dispatch("basket/" + typesBasket.A_BUY_TOUR, sendData)
          .then(res => {
            bus.$emit("page-load", false);
            const code = res.Reservation?.Code;

            if (res.ValidationResultSummary.ValidationResult.Warnings!=null && res.ValidationResultSummary.ValidationResult.Warnings.length>0) {
              let warn=res.ValidationResultSummary.ValidationResult.Warnings.find(item => item.AdapterName === "Itravex" && item.Message==="InformationMessageBookingHotelOnlyMT");
              if (warn) {
                alert(this.localizeList.InformationMessageBookingHotelOnlyMT);
              }
            }
            const locationHref = res.UsedMailService ? `${orderInfoUrl}?dg_code=${code}` : `${basketUrl}?dogovorCode=${code}&ReturnUrl=${orderInfo}?dg_code=${code}`;

            if (res.ValidationResultSummary.ValidationResult.IsValid) {
              this.GTMTransaction(code);

              if(this.getSettings.CheckRedirectPersonalAccount)
              {
                this.$store.dispatch("common/A_CHECK_REDIRECT_PERSONAL_ACCOUNT", code);
              }

              location.href = locationHref
            } else {
              let errText = "";
              const errors = res.ValidationResultSummary.ValidationResult.Errors;
              const states = res.ValidationResultSummary.ValidationResult.States;

              const showLocalErrorText = errors
                  .some(x => x.includes('['));

              if (!showLocalErrorText && errors[0] && !states?.[0]?.InfoMessage) {
                const div = document.createElement("div");

                errors.forEach(x => {
                  x = x.replace("Required field is not filled ", this.localizeList.requiredFieldNotFilledUpper);
                  let text = x.replace(/(<([^>]+)>)/ig, "");

                  // Конвертируем символы
                  div.innerHTML = text;
                  text = div.innerText;

                  errText += text + "\n"
                });
                alert(errText);
                this.GTMTransaction(code, false);
              } else {
                let arr = states?.[0].InfoMessage ? [states[0].InfoMessage] : errors;
                arr.forEach(x => {
                  errText += x
                      .replace('[', '+""+localizeList.')
                      .replaceAll('[', '+" "+localizeList.')
                      .replaceAll(']', '+" "+');
                  const firstPlusIndex = errText.indexOf('+');
                  const lastPlusIndex = errText.lastIndexOf('+');
                  errText = errText.slice(0, firstPlusIndex) +
                      errText.slice(firstPlusIndex + 1, lastPlusIndex) +
                      errText.slice(lastPlusIndex + 1)
                });
                if (!errors[0]) errText = 'states[0].ServiceName+"\\n"+' + errText;
                errText += '+"\\n"';

                // eslint-disable-next-line no-unused-vars
                const localizeList = this.localizeList;
                //Itravex - сквозное бронирование. При нажатии на ОК- переходим в МВ, при отмене - делаем аннуляцию заявки
                if (res.ValidationResultSummary.ValidationResultAttributes === 32768) {
                  // errText += '+"\\n"+localizeList.passThroughBookingOKConfirmation';
                  // errText += '+"\\n"+localizeList.passThroughBookingCancelConfirmation';
                  //
                  // errText = eval(errText);
                  // errText = errText.replace(/{\d+}/g, '\n');


                  // let confirmationMessage = null;
                  // Проверяем если есть отели из в.с. то спрашиваем пользователя о брони, а если локальные то сразу делаем бронь
                  // if (this.hasRemoteHotel) {
                  //   confirmationMessage = confirm(errText)
                  // }

                  // if (confirmationMessage || !this.hasRemoteHotel) {
                  this.GTMTransaction(code);

                  if(this.getSettings.CheckRedirectPersonalAccount)
                  {
                    this.$store.dispatch("common/A_CHECK_REDIRECT_PERSONAL_ACCOUNT", code);
                  }

                  location.href = locationHref
                  // } else {
                  //   this.GTMTransaction(code, false);
                  // }
                }
                // Nemo - Выводим сообщение об ошибке и переходим в МВ
                else if (res.ValidationResultSummary.ValidationResultAttributes === 131072) {
                  errText = eval(errText);
                  errText = errText.replaceAll('{0}', '\n');
                  alert(errText);
                  this.GTMTransaction(code);

                  if(this.getSettings.CheckRedirectPersonalAccount)
                  {
                    this.$store.dispatch("common/A_CHECK_REDIRECT_PERSONAL_ACCOUNT", code);
                  }

                  location.href = locationHref
                } else {
                  this.GTMTransaction(code, false);
                  alert(errors.join('\n'));
                }
              }
              this.cardLoaderStatus = false
            }
          })
          .catch(err => {
            console.error(err)
            bus.$emit("page-load", false);
            this.cardLoaderStatus = false;
            
            if(err.status === 401){
              this.clearTokenFromCookie();
              bus.$emit('logout', () => {
              this.openCard = false;
              bus.$emit('open-login-form', {fromBasket: true});
            });
            }
          })
    },
    clearTokenFromCookie(){
      document.cookie = "CommonApplicationAuthTokenCookie_.masterweblight-auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie = "CommonApplicationAuthCookie_.masterweblight-auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    },
    async buyTourNoRegistration() {
      bus.$emit("page-load", true);
      bus.$emit('close-login-form', {fromBasket: false});
      //прорисуем заново *
      this.setTravelerFormNoRegistration(); 
      //проверим обязательные поля заполнены
      if (!this.touristValidNoRegistration()) {
        this.scrollToBlock('trevelerData');
        this.alertType = 'validation';
        this.$store.dispatch('A_SET_ALERT', 5000);
        bus.$emit("page-load", false);
        return
      }  
      if (this.tourCardData.price == 0) {
        bus.$emit("page-load", false);
        return
      }
      // Проверяем на наличие предуприждений
      const confirmAnswer = await this.checkWarningAndBan()
      if (!confirmAnswer) {
            bus.$emit("page-load", false);
            return;
      }
      /* Если изначално состаится переход к а/п из в.с., делаем проверку на то что выбраный перелет из в.с. */
      if (this.toFlightMounted && !this.flight[this.flightData.selected][0].isGDS) {
        let confirmText = this.localizeList.warningModalFormWithRequiredFlightsUpper.replace("{0}", "\n");
        let isAgree = confirm(confirmText);
        if (!isAgree) {
          this.cardLoaderStatus = false;
          bus.$emit("page-load", false);
          return;
        }
      }    
      // обновим данные по туристам
      this.setServicesForCalculate();
      const password = await this.registration();
      this.calculateTour(false);
      const beginDate = this.tourHeadline.startDate;
      let timeLimit = this.flight[this.flightData.selected]?.[0]?.timeLimit;
      timeLimit = timeLimit ? getLocalTimeLimit(timeLimit) : null;
      const sendData = {
        TourProgramId: this.tour.Key,
        BeginDate: this.tour.Services[0]?.BeginDateTime || beginDate,
        Duration: this.tour.Duration,
        Currency: this.tour.Rate,
        Services: this.services,
        Tourists: this.tourists,
        TechnicalProblemsDuringUpdateFlights: false,
        TimeLimit: timeLimit,
        CountryKey: this.tour.CountryId,
        OwnerId: 0,
        Day: this.localizeList.day,
        Day2: this.localizeList.day2,
        Days: this.localizeList.days,
        Night: this.localizeList.night,
        Night2: this.localizeList.night2,
        Nights: this.localizeList.nights,
        adultsCountOverServiceLimit: this.localizeList.adultsCountOverServiceLimitUpper,
        incorrectChildrenInf: this.localizeList.incorrectChildrenInf,
        dogovorComment: this.dogovorComment,
        IsNoRegistration: true,
        BookingHash: this.BookingHash,
        CustomerData: this.customerData,
      }
      if (this.branches.selected && this.branches.selected > 0) {
        sendData.BranchId = this.branches.selected;
      } else {
        this.managers.selected = this.tour.DefaultManagers[0];
      }
      sendData.OwnerId = this.managers.selected > 0 ? this.managers.selected : 0;

      // Проверка заявки на наличие дубликатов в базе. Если дубликаты есть - заявку не создаем , а выводим сообщение для подтверждения
      const isDouble = await this.checkDoubleDogovor(sendData);
      if (isDouble) {
        this.cardLoaderStatus = false;
        return;
      }

      this.GTMCheckout();
      this.$store.dispatch("basket/" + typesBasket.A_BUY_TOUR, sendData)
          .then(async res => {
            const basketUrl = this.$store.getters['getMwSendReservationMails'];
            const orderInfo = this.$store.getters['getOrderInfo'].split("/").reverse()[0];
            const code = res.Reservation?.Code;
            if (res.ValidationResultSummary.ValidationResult.IsValid) {
              const tourist = this.tourists.find(item => item.IsMain === true);
              const user = {
                mail: tourist.Email,
                password: password,
                dogovorCode: code,
              };
                const text = this.localizeList.applicationBooked;
              await this.sendMail(user);
              this.GTMTransaction(code);
              if (password !== '') {

                if(this.getSettings.CheckRedirectPersonalAccount)
                {
                  this.$store.dispatch("common/A_CHECK_REDIRECT_PERSONAL_ACCOUNT", code);
                }

                location.href = `${basketUrl}?dogovorCode=${code}&ReturnUrl=${orderInfo}?dg_code=${code}`
              }else{
                alert(text)
                this.cardLoaderStatus = false;
                bus.$emit("page-load", false);
              }
            } else {
            let errText = "";
            const errors = res.ValidationResultSummary.ValidationResult.Errors;
            const states = res.ValidationResultSummary.ValidationResult.States;

            const showLocalErrorText = errors
                .some(x => x.includes('['));

            if (!showLocalErrorText && errors[0] && !states?.[0]?.InfoMessage) {
            const div = document.createElement("div");

            errors.forEach(x => {
                x = x.replace("Required field is not filled ", this.localizeList.requiredFieldNotFilledUpper);
                let text = x.replace(/(<([^>]+)>)/ig, "");

                // Конвертируем символы
                div.innerHTML = text;
                text = div.innerText;

                errText += text + "\n"
            });
            alert(errText);
            this.GTMTransaction(code, false);
            } else {
            let arr = states?.[0].InfoMessage ? [states[0].InfoMessage] : errors;
            arr.forEach(x => {
                errText += x
                    .replace('[', '+""+localizeList.')
                    .replaceAll('[', '+" "+localizeList.')
                    .replaceAll(']', '+" "+');
                const firstPlusIndex = errText.indexOf('+');
                const lastPlusIndex = errText.lastIndexOf('+');
                errText = errText.slice(0, firstPlusIndex) +
                    errText.slice(firstPlusIndex + 1, lastPlusIndex) +
                    errText.slice(lastPlusIndex + 1)
            });
            if (!errors[0]) errText = 'states[0].ServiceName+"\\n"+' + errText;
            errText += '+"\\n"';

            // eslint-disable-next-line no-unused-vars
            const localizeList = this.localizeList;
            //Itravex - сквозное бронирование. При нажатии на ОК- переходим в МВ, при отмене - делаем аннуляцию заявки
            if (res.ValidationResultSummary.ValidationResultAttributes === 32768) {
                // errText += '+"\\n"+localizeList.passThroughBookingOKConfirmation';
                // errText += '+"\\n"+localizeList.passThroughBookingCancelConfirmation';
                //
                // errText = eval(errText);
                // errText = errText.replace(/{\d+}/g, '\n');


                // let confirmationMessage = null;
                // Проверяем если есть отели из в.с. то спрашиваем пользователя о брони, а если локальные то сразу делаем бронь
                // if (this.hasRemoteHotel) {
                //   confirmationMessage = confirm(errText)
                // }

                // if (confirmationMessage || !this.hasRemoteHotel) {
                this.GTMTransaction(code);

                if(this.getSettings.CheckRedirectPersonalAccount)
                {
                  this.$store.dispatch("common/A_CHECK_REDIRECT_PERSONAL_ACCOUNT", code);
                }

                location.href = `${basketUrl}?dogovorCode=${code}&ReturnUrl=${orderInfo}?dg_code=${code}`
                // } else {
                //   this.GTMTransaction(code, false);
                // }
            }
            // Nemo - Выводим сообщение об ошибке и переходим в МВ
            else if (res.ValidationResultSummary.ValidationResultAttributes === 131072) {
                errText = eval(errText);
                errText = errText.replaceAll('{0}', '\n');
                alert(errText);
                this.GTMTransaction(code);
                
                if(this.getSettings.CheckRedirectPersonalAccount)
                {
                  this.$store.dispatch("common/A_CHECK_REDIRECT_PERSONAL_ACCOUNT", code);
                }

                location.href = `${basketUrl}?dogovorCode=${code}&ReturnUrl=${orderInfo}?dg_code=${code}`
            } else {
                this.GTMTransaction(code, false);
                alert(errors.join('\n'));
            }
            }
            this.cardLoaderStatus = false
            }
          })
    },
    setTravelerFormNoRegistration() 
    {
      let inputs = [];
      let fields = this.touristSettings;
      for (let key in fields) {

        if (
            fields[key].IsVisible &&
            fields[key].Code !== "ismain" &&
            fields[key].Code !== "number"
        ) {
          let label = fields[key].HeaderText.replace(/<br \/>/, " ");
          if (fields[key].IsBookingNoRegistration && !label.includes("*")) {
            label += '<font color="red">*</font>'
          }
          if (fields[key].Code == "email" && !label.includes("*")) {
            label += '<font color="red">*</font>'
          }
          fields[key].value = "";
          fields[key].label = label;
          fields[key].isValid = true;
          fields[key].position = this.setProperty(fields[key].Code, "position");
          fields[key].type = this.setProperty(fields[key].Code, "type");
          fields[key].maxLength = this.setProperty(fields[key].Code, "max-length");
          fields[key].lengths = fields[key].Code === 'passportrus' ? [10, 10] : (fields[key].Code === 'passport' ? [5, 13] : null);
          if (
              fields[key].Code === "birthdate" ||
              fields[key].Code === "passportdate" ||
              fields[key].Code === "passportdaterus"
          ) {
            fields[key].dateFrom = "1900.01.01"
            fields[key].dateTo = moment().format("YYYY.MM.DD")
          } else {
            fields[key].dateFrom = moment().format("YYYY.MM.DD")
            fields[key].dateTo = moment().add(100, "y").format("YYYY.MM.DD")
          }

          inputs.push(fields[key])
        }
      }
      inputs = this.$store.getters['quicksort'](inputs, "position");
      //Групируем поле "пол" с предедушим
      inputs = inputs.map((x, i) => {
        if (x.Code !== "sex") {

          if (inputs[i + 1] && inputs[i + 1].Code === "sex") {
            inputs[i + 1].value = 0;
            return {
              isGroup: true,
              items: [x, inputs[i + 1]]
            }
          } else {
            return x
          }
        }
      })
      inputs = inputs.filter(x => x)
      this.trevelerForm = this.trevelerForm.map(x => {
                      x.inputs = inputs.slice();
                      return x
                    });
    },
    registration() {
      return new Promise((resolve, reject) => {
         const tourist = this.tourists.find(item => item.IsMain === true);
         this.checkMail()
            .then(res => {
                    if (!res) 
                    {
                      resolve('');
                    }else{
                      const user = {
                          name: tourist.FirstName === "" ?  tourist.FirstNameRus : tourist.FirstName,
                          surname: tourist.LastName === "" ?  tourist.LastNameRus : tourist.LastName,
                          phone: tourist.Phone,
                          login: tourist.Email,
                      };
                      user.phone = encodeURIComponent(tourist.Phone);
                      this.$store.dispatch("tour/A_GET_REGISTRATION_NO_PASSWORD", user)
                      .then(password => {
                          if(password == '')
                          {      
                            resolve('');
                          } else {
                          let formData = {
                                    login: tourist.Email,
                                    password: password
                                };
                          this.$store.dispatch("tour/A_SIGN_IN", formData)
                                            .then(() => {
                                                // End Google Tag Manager
                                                this.isAuthenticated = true;
                                                bus.$emit('isAuthenticated', true);
                                                resolve(password);
                                            })
                                            .catch(err => {
                                                bus.$emit("page-load", false);                
                                                this.cardLoaderStatus = false;
                                                reject(err);
                                            })
                            }      
                        })
                    }
            })
         })
    },   
    checkMail() {
        return new Promise((resolve) => {
            const tourist = this.tourists.find(item => item.IsMain === true);
            const mail = tourist.Email;

             this.$store.dispatch("common/A_CHECK_MAIL", mail)
                .then(res => {
                    resolve(res.data)
                })
        })
    },
    sendMail(user) {
          return new Promise((resolve) => {
              this.$store.dispatch("tour/A_GET_PERSONAL_SEND_MAIL", user)
                  .then(res => {
                      resolve(res)
                  })
          })
    },   
    settingsShowLogin(data) {
          let country = null;
          country = data.CountryId;

          return new Promise(resolve => {
              this.$store.dispatch("basket/" + typesBasket.A_GET_TOURIST_DATA, country)
                  .then(res => {
                    let isSettings = false;
                    let fields = res.TouristFieldsSettings;
                    for (let key in fields) {
                      if (fields[key].IsBookingNoRegistration) {
                        isSettings= true;
                        break;
                      }
                    }
                    if (isSettings == true) {
                      this.$store.commit("common/" + mTypesCommon.M_SET_IS_SETTINGS_NO_REGISTRATION, true);
                    } else {
                      this.$store.commit("common/" + mTypesCommon.M_SET_IS_SETTINGS_NO_REGISTRATION, false);
                    }
                    resolve();
                  })
          })
    },

    async checkDoubleDogovor(sendData) {
      if (!this.getSettings.DuplicateTouristsWarning) return false;

      const result = await this.$store.dispatch("basket/A_CHECK_DOUBLE_DOGOVOR", sendData);

      if (result.IsValid) return false;

      let errText = result.Errors[0]
          .replace('DublicateMessagePart0', this.localizeList.dublicateMessagePart0)
          .replace('DublicateMessagePart1', " " + this.localizeList.dublicateMessagePart1)
          .replace('DublicateMessagePart2', " " + this.localizeList.dublicateMessagePart2)
          .replace('DublicateMessagePart3', this.localizeList.dublicateMessagePart3)
          .replace('DublicateMessagePart4', ". " + this.localizeList.dublicateMessagePart4)
          .replace('DublicateMessagePart5', this.localizeList.dublicateMessagePart5);

      return !confirm(errText);
    },
    getTour() {
      bus.$emit("page-load", true);
      const href = window.location.href;
      this.$store.dispatch("basket/" + typesBasket.A_SET_TOUR, href)
          .then(res => {
            if (res.Result == null) {
                this.isNoTour = true;
                return;
            }
            if (res.Result[0]) {
              let hotels = res.Result[0].Services.filter(x => x.SvKey === 3);
              this.tour = res.Result[0];
              if (!this.calculatedCountry && this.tour.Services){
                this.calculatedCountry = this.tour.Services.find(x => x.SvKey == 3)?.SettingsCitizenShipKey;
              }
              this.constructHotels(hotels);
              this.createFlight(res.Result);
              this.createTransfer(res.Result);
              this.createExcursion(res.Result);
              this.createBusTransfer(res.Result);
              this.createRailwayTransfer(res.Result);
              this.createAdditionalServices(res.Result);
              this.setBasketHeadline(res.Result[0]);
              this.setTravelerForm(res.Result[0])
                  .then(() => {
                    setTimeout(() => {
                      this.setServicesForCalculate();

                      this.additionalHotelServices().finally(() => {
                        this.additionalFlightServices().finally(() => {
                          this.calculateIndividualServiceCost()
                              .then(() => {
                                this.setTouristInfo();
                                this.calculateTour().then(() => {
                                  // const fromSearch = sessionStorage.getItem("GTM_from_search");
                                  // if (!fromSearch)
                                  this.GTMSetFirstProduct();
                                  // else
                                  //     sessionStorage.removeItem("GTM_from_search")

                                });
                                this.readyForCalculate = true;
                              })
                        })
                      });
                      if (this.toFlightMounted) {
                        this.toFlight();
                        this.flightReady = true;
                      } else {
                        bus.$emit("show-learning-mode");
                      }
                    }, 1000)
                  });
              this.setBranchesMenegers(res.Result[0]);
              this.getTourImages();
              this.settingsShowLogin(res.Result[0]);
              this.selectedTourName = res.Result[0].Name;
              this.tourBookingHTML = res.Result[0].BookingConditions;
              this.cardShow = true;
              bus.$emit("page-load", false);
            } else {
              this.oldTour = true;
            }
          })
    },
    changeBranch(e) {
      if (e.value) {
        this.setBranchesMenegers(this.tour, e.value)
      } else {
        this.setBranchesMenegers(this.tour)
      }
    },
    setBranchesMenegers(data, branche = null) {
      let managers = data.DefaultManagers.slice();
      managers.push(data.Manager)
      if (managers.length) {
        this.$store.dispatch("basket/" + typesBasket.A_GET_MANAGERS, {
          data: managers,
          branche: branche
        })
            .then(res => {
              this.managers.list = [];
              this.managers.list = res.map(x => {
                return {
                  value: x.Key,
                  label: x.Value
                }
              });
              if (this.managers.list.length == 1 && this.managers.list[0].value != -1) {
                this.managers.selected = this.managers.list[0].value;
              } else {
                this.managers.list.unshift({
                  label: this.localizeList.chooseManagerUpper,
                  value: 0
                });
                this.managers.selected = 0;
              }
            })
      }

      if (branche) {
        return
      }
      let branches = data.Branches;
      if (branches.length) {
        this.$store.dispatch("basket/" + typesBasket.A_GET_BRANCHES, branches)
            .then(res => {
              this.branches.list = [];
              this.branches.list = res.map(x => {
                return {
                  value: x.Key,
                  label: x.Value
                }
              });
              this.branches.list.unshift({
                label: this.localizeList.selectBranchUpper,
                value: 0
              });
              this.branches.selected = 0;
            })
      }
    },
    setBasketHeadline(data) {
      this.tourHeadline.name = data.Name;
      this.tourHeadline.startDate = data.StartDate;
      this.tourHeadline.duration = data.Duration;
      if (data.Services.find(x => x.SvKey === 3)) {
        this.tourHeadline.to = data.Services.find(x => x.SvKey === 3).City.Value;
      } else {
        if (data.Services.find(x => x.CityTo)) {
          this.tourHeadline.to = data.Services.find(x => x.CityTo).CityTo.Value;
        }
      }
      if (data.Services.find(x => x.SvKey === 1)) {
        this.tourHeadline.from = data.Services.find(x => x.SvKey === 1).DepartureCity.Value;
      }
    }, 
    setFoodTableData(key) {
      this.setFoodTableColumns(key);

      if (this.getBrutto.length)
        this.alertShow(-1, 5000, true);
    },
    setFoodTableColumns(key) {
      const leftTd = document.querySelector(".residence-block .td.slider");
      const table = document.querySelector(".residence-block .food-table");
      if (!leftTd || !table) return;

      const leftTdWidth = leftTd.offsetWidth;
      const tableWidth = table.offsetWidth;
      const tdMinWidth = 207;
      const count = Math.floor((tableWidth - leftTdWidth) / tdMinWidth);
      this.residenceColumnCount = count;

      this.residence[key].foodHeader = this.residence[key].foodHeaderAll.filter((x, i) => i < count);
      this.residence[key].foodItems = this.residence[key].foodItemsAll.map(x => x.filter((x2, i) => i < count + 1));
    },
    updateColumns(count) {
      this.residenceColumnCount = count;
      this.residence = this.residence.map(x => {
        x.foodHeader = x.foodHeaderAll.filter((x, i) => i < count);
        x.foodItems = x.foodItemsAll.map(x => x.filter((x2, i) => i < count + 1));
        x.sliderPosition = 0;
        return x
      });
    },
    foodSlideRight(key) {
      let index = this.residence[key].sliderPosition;
      let item = this.residence[key].foodHeaderAll[index + this.residenceColumnCount];
      if (item) {
        this.residence = this.residence.map((x, i) => {
          if (i === key) {
            x.foodHeader.push(item);
            x.foodHeader.shift();
            x.foodItems = x.foodItemsAll.map(x => x.filter((x2, i) => i === 0 || i > index + 1 && i < index + this.residenceColumnCount + 2));

            x.sliderPosition++;
          }
          return x
        });
      }
    },
    foodSlideLeft(key) {
      const columnCount = this.residence[key].foodHeaderAll.length > this.residenceColumnCount
          ? this.residenceColumnCount : this.residence[key].foodHeaderAll.length;

      let index = this.residence[key].sliderPosition;
      let item = this.residence[key].foodHeaderAll[index - 1];
      if (item) {
        this.residence[key].foodHeader.unshift(item);
        this.residence[key].foodHeader.pop();
        this.residence[key].foodItems = this.residence[key].foodItemsAll.map((x) => {
          x = x.filter((x2, i2) => {
            if (i2 === 0 || i2 >= index && i2 < index + columnCount) {
              return x
            }
          })
          return x
        });

        this.residence[key].sliderPosition--;
      }
    },
    roundFoodPrice(price) {
      let res = 0;
      if (price < 0) {
        res = Math.abs(price);
        res = -Math.round(res);
      } else {
        res = Math.round(price);
      }
      return res
    },
    calcFood(key) {
      const selectedCost = this.residence[key].food[3];
      const selectedValue = this.residence[key].food[2];
      this.residence[key].foodItemsAll = this.residence[key].foodItemsAll.map(x => {
        x.map((x2, i2) => {
          if ((x2.value !== selectedValue || (x2.value === selectedValue && selectedCost != x2.cost)) && i2 !== 0) {
            if (selectedCost) {
              x2.text = ((+x2.cost * 100).toFixed() - (selectedCost * 100).toFixed()) / 100;
            } else {
              x2.text = +x2.cost
            }
          }
          return x
        });
        return x
      });
    },
    setFood(key, key1, key2, item) {
      if (key2 !== 0) {
        this.residence = this.residence.map((x, i) => {
          if (key === i) {
            x.food = [key1, key2, item.value, item.cost];
          }
          return x;
        });

        this.residence = this.residence.map((x) => {
          x.selectedFood = x.foodHeaderAll[key2 - 1]
          return x;
        });

        this.calcFood(key);
        this.$nextTick(() => {
          if (this.readyForCalculate) {
            const firstHotelDetails = this.residence[key].allData.HotelDetails
                .find((x) => `${x.HotelRoom}_${x.Pansion.Key}_${x.PartnerId}_${x.PansionAdditionalInfo || ''}_${x.CriticalInfo || ''}`.replaceAll('+', ' ') === item.value);

            GTM.updateFirstProduct(firstHotelDetails);

            const oldCost = this.tourCardData.calculatedServicesPrice;
            const oldName = this.getServiceNameBySvKey(3) || "Hotel";
            this.calculateTour()
                .then(() => {
                  const newCost = this.tourCardData.calculatedServicesPrice;
                  // Google Tag Manager
                  let name = this.getServiceNameBySvKey(3) || "Hotel";
                  const currency = this.$store.getters['getAllCurrency'].find(x => x.Code === this.tour.Rate).IsoCode;
                  GTM.updateCard(this.residence[key].allData, newCost, "Hotel", this.tour, currency, name, "changeHotel", oldName, oldCost);
                  // End Google Tag Manager
                })
          }
        })
      }
    },
    checkIsActive(key, key1, key2, value) {
      let index = this.residence[key].sliderPosition
      return this.residence[key].food[0] === key1 && this.residence[key].food[1] === key2 + index && this.residence[key].food[2] === value
    },
    changeFoodInModal(key) {
      let value = this.buyList[this.hotelInfo.key][key]?.cost;
      this.buyList[this.hotelInfo.key] = this.buyList[this.hotelInfo.key].map((x, i) => {
        if (i === key) {
          x.viewCost = 0;
          x.selected = true;
        } else {
          x.viewCost = x.cost - value;
          x.selected = false;
        }
        return x
      })
    },
    changeFoodOfModal() {
      let hotelData = this.buyList[this.hotelInfo.key].find(x => x.selected).hotelData;
      let values = hotelData.map(x => {
        return `${x.HotelRoom}_${x.Pansion.Key}_${x.PartnerId}_${x.PansionAdditionalInfo || ''}_${x.CriticalInfo || ''}`.replaceAll("+", " ");
      });
      let _break = false;

      this.residence.forEach((x, i) => {
        x.foodItemsAll.forEach((x2, i2) => {
          x2.forEach((x3, i3) => {
            if (values.includes(x3.value) && !_break) {
              this.setFood(i, i2, i3, x3);
              this.showRightModal = false;
              _break = true
            }
          })
        })
      })
    },
    checkIsActiveModal(key) {
      return this.buyList[this.hotelInfo.key][key].selected
    },
    getQuotaName(quota) {
      if (!quota) {
        return null
      }
      let res = null;
      if (quota.PlacesStatus === 2) {
        res = "not-aviailable"
      } else if (quota.PlacesStatus === 4) {
        res = "request"
      } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
        res = "less"
      } else {
        res = "aviailable"
      }
      return res
    },
    blockToggle(block) {
      if (block === 'residence') {
        this.residenceShow = !this.residenceShow
      }
      if (block === 'flight') {
        this.flightShow = !this.flightShow
      }
      if (block === 'flightSurcharge') {
        this.flightSurchargeShow = !this.flightSurchargeShow
      }
      if (block === 'transfer') {
        this.transferShow = !this.transferShow
      }
      if (block === 'excursion') {
        this.excursionShow = !this.excursionShow
      }
      if (block === 'bus') {
        this.busShow = !this.busShow
      }
      if (block === 'railway') {
        this.railwayShow = !this.railwayShow
      }
      if (block === 'additionalServices') {
        this.additionalServicesShow = !this.additionalServicesShow
      }
      if (block === 'trevelerData') {
        this.trevelerDataShow = !this.trevelerDataShow
      }

      if (block === 'dogovorComment') {
        this.dogovorCommentShow = !this.dogovorCommentShow
      }
    },
    showPopover(text, e) {
      let rect = e.target.getBoundingClientRect()
      let res = {
        x: rect.left + (rect.width / 2),
        y: rect.top,
        text: text,
        height: rect.height
      }
      this.$store.dispatch(typesGlobal.A_SHOW_POPOVER, res);
    },
    changeHotelInfoNavbar(key) {
      if (key === -1) {
        this.hotelInfo.activeItem = -1;

        this.$refs.hotelInfoContent.scrollTo({
          top: this.$refs.hotelVariants.offsetTop - this.$refs.hotelInfoContent.offsetTop + 1,
          behavior: "smooth"
        });
        return;
      }
      this.hotelInfo.activeItem = key;
      let to = key ? this.$refs.hotelInfoItem[key - 1].offsetTop - this.$refs.hotelInfoContent.offsetTop : key;

      this.$refs.hotelInfoContent.scrollTo({
        top: to + 1,
        behavior: "smooth"
      })
    },
    hotelImageSlide(to) {
      let position = this.hotelInfo.sliderPosition;
      if (to === 'right') {
        if (this.hotelInfo.images[position + 1]) {
          this.$refs.hotelInfoSlide.style.backgroundImage = `url("${this.hotelInfo.images[position + 1].replace("small160x90", "big")}")`;
          this.hotelInfo.sliderPosition++
        } else {
          this.hotelInfo.sliderPosition = 0;
          this.$refs.hotelInfoSlide.style.backgroundImage = `url("${this.hotelInfo.images[0].replace("small160x90", "big")}")`;
        }
      } else if (to === 'left') {
        if (this.hotelInfo.images[position - 1]) {
          this.$refs.hotelInfoSlide.style.backgroundImage = `url("${this.hotelInfo.images[position - 1].replace("small160x90", "big")}")`;
          this.hotelInfo.sliderPosition--
        } else {
          this.hotelInfo.sliderPosition = this.hotelInfo.images.length - 1;
          this.$refs.hotelInfoSlide.style.backgroundImage = `url("${this.hotelInfo.images[this.hotelInfo.sliderPosition - 1].replace("small160x90", "big")}")`;
        }
      } else {
        if (this.hotelInfo.images[to]) {
          this.$refs.hotelInfoSlide.style.backgroundImage = `url("${this.hotelInfo.images[to].replace("small160x90", "big")}")`;
          this.hotelInfo.sliderPosition = to;
        }
      }
      if (!this.dragSecondSlider) {
        this.$refs.secondSlider.scrollTo(this.hotelInfo.sliderPosition * 173, 0)
      }
    },
    startDragSecondSlider(e) {
      this.secondSliderX = e.x;
      this.secondSliderPosition = this.$refs.secondSlider.scrollLeft;

      this.dragSecondSlider = true;
    },
    stopDragSecondSlider() {
      setTimeout(() => this.dragSecondSlider = false, 100)
    },
    doDragSecondSlider(e) {
      e.preventDefault();
      if (this.dragSecondSlider) {
        this.$refs.secondSlider.scrollTo((this.secondSliderX - e.x) + this.secondSliderPosition, 0)
      }
    },
    toggleBuyList(key, item) {
      const href = window.location.href;
      const data = href.split("&");
      const countryTo = data.find(x => x.includes("destination")).split("=")[1].split("_")[1];
      const adultCount = data.find(x => x.includes("adultCount")).split("=")[1];
      let children = data.find(x => x.includes("childAges"));
      children = children ? children.split("=")[1].split(",") : null;
      const moreItems = {
        page: 1,
        countryTo,
        adultCount,
        children,
        currency: this.tourRate,
        citiesTo: [-1] // -1 все города
      };
      item.rateCode = this.tourRate;

      const isHotels = this.$route.fullPath.includes("Individuals/Hotels");
      const typeSearch = isHotels ? "hotels" : "tour";
      this.$store.dispatch(`${typeSearch}/` + typesTour.A_SET_HOTEL_DETAILS, {...item, ...{fromBasket: moreItems}})
          .then(res => {
            if (!res.data.Result.length) {
              return
            }
            let list = [];
            let selectedIndex = -1;
            res.data.Result[0].RouteSubVariants
                .forEach((x, i) => {
                  let hotelData = x.Services
                      .filter(x2 => x2.SvKey === 3)
                      .map(x2 => x2.HotelDetails[0]);

                  let isSelected = true;
                  hotelData.forEach(x2 => {
                    if (isSelected) {
                      isSelected = this.residence.some(x3 => {
                        return `${x2.HotelRoom}_${x2.Pansion.Key}_${x2.PartnerId}_${x2.PansionAdditionalInfo || ''}_${x2.CriticalInfo || ''}`.replaceAll("+", " ") === x3.food[2];
                      })
                    }
                  })
                  if (isSelected && selectedIndex === -1) {
                    selectedIndex = i
                  }
                  list.push({
                    adult: hotelData[0].Room.Value,
                    roomCategory: hotelData[0].RoomCategory.Value,
                    accomodationType: hotelData[0].AccomodationType.Value,
                    pansion: hotelData[0].Pansion.Value,
                    pansionAdditionalInfo: hotelData[0].PansionAdditionalInfo,
                    cost: x.Cost,
                    viewCost: x.Cost,
                    selected: isSelected,
                    quotaStatus: hotelData[0].QuotaStatus,
                    allData: res.data.Result[0],
                    hotelData: hotelData,
                    hotelScheme: x.CostServicesComposition[0]
                  });
                });
            this.$set(this.buyList, key, list);

            if (selectedIndex === -1) {
              selectedIndex = 0
            }
            this.changeFoodInModal(selectedIndex)
          })
    },
    showDetails(data) {
      let item = data[0].parent;
      this.aviaFlightInfo.services = [];
      this.rigthModalType = "aviaFlight";
      this.aviaFlightInfo.isGDS = true;
      this.aviaFlightInfo.data = item;
      this.aviaFlightInfo.data.Name = this.tour.Name;
      this.aviaFlightInfo.class = data.map(x => x.flightClassSelected.label);

      this.aviaFlightInfo.tariffsName = [];
      this.aviaFlightInfo.quotaStatus = [];
      data.forEach(x => {
        this.aviaFlightInfo.tariffsName.push(x.flightClassSelected.label);
        this.aviaFlightInfo.quotaStatus.push(x.flightClassSelected.allData.QuotaStatus)
      });

      this.aviaFlightInfo.services = [];
      data
          .forEach((x, i, arr) => {
            if (!this.aviaFlightInfo.services.length) {
              this.aviaFlightInfo.services.push([{...x.allData, ...x, TotalTimeOfFlight: x.fligthTime}]);
            } else {
              if (x.flightType === arr[i - 1].flightType) {
                this.aviaFlightInfo.services[this.aviaFlightInfo.services.length - 1].push({
                  ...x.allData, ...x,
                  TotalTimeOfFlight: x.fligthTime
                })
              } else {
                this.aviaFlightInfo.services.push([{...x.allData, ...x, TotalTimeOfFlight: x.fligthTime}])
              }
            }
          });
      this.showRightModal = true;
    },
    rightModalBusInfo(data) {
      data[0].tourName = this.tourHeadline.name;
      data = data.map(x => {
        x.code = x.BusTransfer.Key;
        return x;
      });
      this.transportInfo = [...data];
      this.rigthModalType = "bus";
      this.showRightModal = true;
    },
    rightModalRailwayInfo(data) {
      data[0].tourName = this.tourHeadline.name;
      data = data.map(x => {
        x.code = x.RailwayTransfer.Key;
        return x;
      });
      this.transportInfo = [...data];
      this.rigthModalType = "railway";
      this.showRightModal = true;
    },
    rightModalTransferInfo(data) {
      data[0].tourName = this.tourHeadline.name;
      data = data.map(x => {
        x.code = x.Code.Key;
        return x;
      });
      this.transportInfo = [...data];
      this.rigthModalType = "transfer";
      this.showRightModal = true;
    },
    rightModalAviaFlight(data) {
      let item = data[0].parent;
      this.rigthModalType = "aviaFlight";
      this.showRightModal = true;
      this.aviaFlightInfo.isGDS = false;
      this.aviaFlightInfo.data = item;
      this.aviaFlightInfo.class = data.map(x => x.flightClassSelected.label);

      this.aviaFlightInfo.tariffsName = [];
      this.aviaFlightInfo.quotaStatus = [];
      data.forEach(x => {
        this.aviaFlightInfo.tariffsName.push(x.flightClassSelected.label);
        this.aviaFlightInfo.quotaStatus.push(x.flightClassSelected.allData.QuotaStatus)
      });

      this.aviaFlightInfo.services = [];
      let index = 0;
      data.map(x => x.allData)
          .forEach((x) => {
            if (!this.aviaFlightInfo.services.length) {
              this.aviaFlightInfo.services.push([x]);
              index++
            } else {
              // if (x.FlightSetting.ServiceId === arr[i-1].FlightSetting.ServiceId) {
              if (x.FlightSetting.ServiceId === this.aviaFlightInfo.services[index - 1][0].FlightSetting.ServiceId) {
                this.aviaFlightInfo.services[index - 1].push(x)
              } else {
                this.aviaFlightInfo.services.push([x])
                index++
              }
            }
          });
    },
    rightModalHotelInfo(item, key) {
      this.getMapItems();

      setTimeout(() => {
        if (this.$refs.hotelInfoContent)
          this.$refs.hotelInfoContent.scrollTo(0, 0);
      }, 100);
      this.toggleBuyList(key, this.tour);
      this.showRightModal = true;
      this.rigthModalType = "hotelInfo";
      this.hotelInfo.data = item;
      this.hotelInfo.http = item.hotelImagesDescription.Http;
      this.hotelInfo.hasImages = item.hotelImagesDescription.HasImages;
      this.hotelInfo.data.Cost = this.tour.Cost;
      this.hotelInfo.key = key;
      this.hotelInfo.nav = [this.localizeList.photoUpper];
      this.hotelInfo.moreInfo = [];
      const img = item.hotelImagesDescription;
      if (img.Description) {
        this.hotelInfo.nav.push(this.localizeList.hotelDescriptionUpper);
        this.hotelInfo.moreInfo.push({
          title: this.localizeList.hotelDescriptionUpper,
          value: img.Description
        });
      }
      if (img.InfrastructureHotel) {
        this.hotelInfo.nav.push(this.localizeList.infrastructureHotelUpper);
        this.hotelInfo.moreInfo.push({
          title: this.localizeList.infrastructureHotelUpper,
          value: img.InfrastructureHotel
        });
      }
      if (img.RecreationSport) {
        this.hotelInfo.nav.push(this.localizeList.recreationSportUpper);
        this.hotelInfo.moreInfo.push({
          title: this.localizeList.recreationSportUpper,
          value: img.RecreationSport
        });
      }
      if (img.Beach) {
        this.hotelInfo.nav.push(this.localizeList.beachUpper);
        this.hotelInfo.moreInfo.push({
          title: this.localizeList.beachUpper,
          value: img.Beach
        });
      }
      if (img.Healing) {
        this.hotelInfo.nav.push(this.localizeList.healingUpper);
        this.hotelInfo.moreInfo.push({
          title: this.localizeList.healingUpper,
          value: img.Healing
        });
      }
      if (img.AdditionalService) {
        this.hotelInfo.nav.push(this.localizeList.additionalServicesUpper);
        this.hotelInfo.moreInfo.push({
          title: this.localizeList.additionalServicesUpper,
          value: img.AdditionalService
        });
      }
      if (img.ForChildren) {
        this.hotelInfo.nav.push(this.localizeList.forChildrensUpper);
        this.hotelInfo.moreInfo.push({
          title: this.localizeList.forChildrensUpper,
          value: img.ForChildren
        });
      }
      if (img.Excursion) {
        this.hotelInfo.nav.push(this.localizeList.excursionsUpper);
        this.hotelInfo.moreInfo.push({
          title: this.localizeList.excursionsUpper,
          value: img.Excursion
        });
      }
      if (img.AddCost) {
        this.hotelInfo.nav.push(this.localizeList.addCostUpper);
        this.hotelInfo.moreInfo.push({
          title: this.localizeList.addCostUpper,
          value: img.AddCost
        });
      }
      if (img.Address || img.Phone || img.Email) {
        this.hotelInfo.nav.push(this.localizeList.contactsUpper);
        this.hotelInfo.moreInfo.push({
          title: this.localizeList.contactsUpper,
          isContact: true,
          address: img.Address || null,
          phone: img.Phone || null,
          email: img.Email || null,
        });
      }

      setTimeout(() => {
        this.hotelInfo.images = item.hotelImages;
        this.hotelInfo.imagesTextDescription = item.hotelImagesTextDescription;
        if (item.hotelImages && this.$refs.hotelInfoSlide) {
          this.$refs.hotelInfoSlide.style.backgroundImage = `url('${item.hotelImages[0].replace("small160x90", "big")}')`;
          this.$refs.hotelInfoSlide.style.backgroundSize = "102%";
          this.hotelInfo.sliderPosition = 0;
        } else if (this.$refs.hotelInfoSlide) {
          let path = this.$store.getters['getPath'];
          this.$refs.hotelInfoSlide.style.backgroundImage = `url('${this.$store.getters['getApiOrigin']}${path}/Image/GetImage?code=639&type=big&name=null&imageType=hotels')`;
        }

        this.$nextTick(() => {
          this.focusedMapItemInHotelInfo = item
          this.focusedMapHotelInListView = item.allData;
        })
      }, 100)
    },
    changeFlight(key) {
      if (!this.flight.length || !this.flight[key] || !this.flight[key][0]) return;

      this.flightData.selected = key;
      let selectedDelta = this.flight[key][0].totalCost;
      this.flight = this.flight.map(x => {
        x[0].delta = x[0].totalCost - selectedDelta;
        return x
      });
      if (this.readyForCalculate) {

        const oldCost = this.tourCardData.calculatedServicesPrice;
        const oldName = this.getServiceNameBySvKey(1) || "Flight";
        this.calculateTour()
            .then(() => {
              const newCost = this.tourCardData.calculatedServicesPrice;
              this.GTMChangeFlight(key, newCost, oldName, 0, oldCost);
            })
      }

      const isGDS = this.flight[this.flightData.selected][0].isGDS
      if (this.toFlightMounted && !isGDS && this.flightReady) {
        this.toFlight()
      }
    },
    checkedFlightSurcharge(item, key) {
      this.$nextTick(() => {
        if (this.readyForCalculate) {

          let oldCost = item.Details[0].Cost;
          if (!item.IsNotCalculate)
            oldCost = this.tourCardData.calculatedServicesPrice;
          const oldName = this.getServiceNameBySvKey(12) || "";
          this.calculateTour()
              .then(() => {
                const newName = this.getServiceNameBySvKey(12) || "Flight Surcharge";

                let newCost = oldCost;
                let isAdded = item.isChecked;
                if (!item.IsNotCalculate) {
                  newCost = this.tourCardData.calculatedServicesPrice;
                  isAdded = false;
                }

                this.GTMChangeFlightSurcharge(item, key, item.isChecked ? newCost : oldCost, isAdded, item.isChecked ? newName : oldName, newCost)
              })
        }
      })
    },
    GTMChangeFlightSurcharge(item, key, cost, isAdded, name, newCost) {
      // Google Tag Manager
      const currency = this.$store.getters['getAllCurrency'].find(x => x.Code === this.tour.Rate).IsoCode;
      if (item.IsNotCalculate || isAdded) {
        GTM[isAdded ? 'addToCart' : 'removeFromCard'](item, cost, "Flight Surcharge", this.tour, currency, name, isAdded ? "addToCart" : "changeCart");
      } else {
        GTM.updateCard(item, newCost, "Flight Surcharge", this.tour, currency, name, "changeCart", name, cost);
      }
      // End Google Tag Manager
    },
    createFlight(data) {
      this.flight = [];
      const uniqueFlight = [];
      let selectedIndex = 0;

      data.forEach((x, i) => {
        //Определяем город откуда и куда
        if (i === 0) {
          const flightData = x.Services.find(x2 => x2.SvKey === 1);
          if (!flightData) {
            const flightData = x.Services.find(x2 => x2.SvKey === 3);
            if (flightData) {
              this.flightData.placeFrom = flightData.City.Value;
            } else {
              const flightData = x.Services.find(x2 => x2.City)
              if (flightData) {
                this.flightData.placeFrom = flightData.City.Value;
              }
            }
            this.flightData.placeTo = ""
          } else {
            this.flightData.placeFrom = flightData.DepartureCity.Value
            this.flightData.placeTo = flightData.ArrivalCity.Value
          }
        }

        const notComboTariff = this.tour.LinkingFlightsRules.notCombineDifferentTariffGroupRule.enabled;
        let selectedLabelForComboTariff = null;

        const flightCodes = [];
        const flightUrlCodes = [];
        let flight = x.Services.filter(x2 => x2.SvKey === 1);
        flight = flight.map((x2, i2) => {
          //узнаем есть ли а/п из внешней системы
          if (x2.FlightSourceMode !== 1) {
            this.showFlightEditBtn = true
          }
          if (x2.FlightSourceMode == 2) {
            this.toFlightMounted = true;
          }
          const timeFrom = x2.DepartureTime.slice(0, 5);
          const timeTo = x2.ArrivalTime.slice(0, 5);
          const timeDuration = this.correctTime(x2);
          const flightType = x2.FlightSetting.ServiceId;
          x2.FlightDetails = this.$store.getters['quicksort'](x2.FlightDetails, "Cost");
          const selectedCost = x2.FlightDetails[0].Cost;
          let allRate = this.$store.getters['getAllCurrency'];
          let rate = allRate.find(x => x.Code === this.tourRate);

          let flightClass = x2.FlightDetails.map(x3 => {
            let res = {
              label: x3.Tariff.Name,
              secondLabel: x3.Cost - selectedCost > 0 ?
                  `+${this.correctPrice(x3.Cost - selectedCost, true)} ${this.getCurrencyDisplayBySettings(rate)}` :
                  `${this.correctPrice(x3.Cost - selectedCost, true)} ${this.getCurrencyDisplayBySettings(rate)}`,
              value: x3.Cost,
              allData: x3
            };
            return res
          });
          flightClass[0].secondLabel = `0 ${this.getCurrencyDisplayBySettings(rate)}`;

          let selectedTariff = 0;
          location.href
              .replace("?gtm_debug=x", "") // временный код
              .split("?")[1].split("&").forEach(x3 => {
            if (x3.includes("serviceDescriptions")) {
              let services = x3.split("serviceDescriptions=")[1].split(",");
              services = services.filter(x4 => +(x4.split("_")[3]) === 1);
              if (!services[i2]) return;

              flightCodes.push('' + x2.Flight.Key);
              flightUrlCodes.push(services[i2].split("_")[4]);
              let tariff = services[i2].split("_")[5];
              flightClass.forEach((x4, i4) => {
                if (x4.allData.Tariff.Key == tariff) {
                  selectedTariff = i4
                }
              });
            }
          });

          if (notComboTariff && i2 === 0) {
            selectedLabelForComboTariff = flightClass[selectedTariff].label
          } else if (notComboTariff) {
            selectedTariff = flightClass
                .map(x3 => x3.label)
                .indexOf(selectedLabelForComboTariff) || 0
          }

          const construct = {
            parent: x,
            day: x2.Day,
            timeFrom,
            timeTo,
            timeDuration,
            airportFrom: x2.DepartureAirport.Key,
            airportTo: x2.ArrivalAirport.Key,
            airline: x2.Airline.Value,
            flightClassSelected: flightClass[selectedTariff],
            flightClassSelectedValue: flightClass[selectedTariff].value,
            flightClass,
            flightType,
            allData: x2,
          }
          return construct
        });

        // Убрал, т.к. ломалась когда клиент заводил несколько локальных перелетов и находились совпадения не на первом (сейчас selectedIndex всегда будет равен 0)
        // if (JSON.stringify(flightUrlCodes) === JSON.stringify(flightCodes)) selectedIndex = i;

        const flightJSON = JSON.stringify(flight);
        if (!uniqueFlight.includes(flightJSON)) {
          this.flight.push(flight);
          uniqueFlight.push(flightJSON);
        }
      });

      if (this.flight.length && this.flight[0].length) {
        let selectedDelta = this.flight[0][0].parent.Cost;
        this.flight = this.flight.map(x => {
          x[0].delta = x[0].parent.Cost - selectedDelta;
          x[0].totalCost = x[0].parent.Cost;
          // let direction = 1;
          // x = x.map((x2, i2) => {
          //     if (i2 === 0) {
          //         x2.flightType = direction;
          //     } else {
          //         if (x[i2-1].flightType !== x2.flightType)
          //             direction++;
          //
          //         x2.flightType = direction
          //     }
          //     return x2
          // });
          return x
        })
      }

      if (this.flight.length && this.flight[0].length) {
        this.originalsFlightsIndex = [this.flight[0][0].allData.Index, this.flight[0].at(-1).allData.Index]
      }

      this.changeFlight(selectedIndex)
    },
    GTMChangeFlight(key, cost, oldName, key2 = 0, oldCost) {
      // Google Tag Manager
      let name = this.getServiceNameBySvKey(1, key2) || "Flight";
      const currency = this.$store.getters['getAllCurrency'].find(x => x.Code === this.tour.Rate).IsoCode;
      GTM.updateCard(this.flight[key][0].allData, cost, "Flight", this.tour, currency, name, "changeFlight", oldName, oldCost);
      // End Google Tag Manager
    },
    changeFlightClass(key, key2, e) {
      let value = e;
      let newFlight = this.flight[key].find((x, i) => i === key2);
      let allRate = this.$store.getters['getAllCurrency'];
      let rate = allRate.find(x => x.Code === this.tourRate);
      newFlight = Object.assign({}, newFlight);

      newFlight.flightClassSelected = this.flight[key][key2].flightClass.find(x => `${x.value}_${x.label}` === `${value[0]}_${value[1]}`);
      newFlight.flightClassSelectedValue = newFlight.flightClassSelected?.value;
      if (!newFlight.flightClassSelected) {
        newFlight.flightClassSelected = this.flight[key][key2].flightClass[0];
        newFlight.flightClassSelected.label = value[1];
        value = this.flight[key][key2].flightClass[0].value;
        newFlight.flightClassSelectedValue = value[0]
      } else {
        newFlight.flightClassSelected.label = value[1];
        value = value[0]
      }
      newFlight.flightClass = this.flight[key][key2].flightClass.map(x => {
        x.secondLabel = x.value - value <= 0 ?
            `${this.correctPrice(x.value - value, true)} ${this.getCurrencyDisplayBySettings(rate)}` :
            `+${this.correctPrice(x.value - value, true)} ${this.getCurrencyDisplayBySettings(rate)}`;
        return x
      });

      this.$set(this.flight[key], key2, newFlight);

      this.flight[key][0].totalCost = this.flight[key][0].parent.Cost;
      this.flight[key].forEach(x => {
        this.flight[key][0].totalCost += x.flightClassSelected.value
      });
      let selectedDelta = this.flight[this.flightData.selected][0].totalCost;
      this.flight = this.flight.map(x => {
        x[0].delta = x[0].totalCost - selectedDelta;
        return x;
      });
      if (key === this.flightData.selected) {
        this.setServicesForCalculate();

        this.additionalFlightServices()
            .finally(() => {
              if (this.readyForCalculate) {
                const oldCost = this.tourCardData.calculatedServicesPrice;
                const oldName = this.getServiceNameBySvKey(1, key2) || "Flight";
                this.calculateTour()
                    .then(() => {
                      const newCost = this.tourCardData.calculatedServicesPrice;
                      this.GTMChangeFlight(key, newCost, oldName, key2, oldCost);
                    })
              }
            })
      }
    },
    changeBus(key) {
      this.busData.selected = key;

      let selectedDelta = this.busTransfer[key][0].totalCost;
      this.busTransfer = this.busTransfer.map(x => {
        x[0].delta = x[0].totalCost - selectedDelta;
        return x;
      });

      if (this.readyForCalculate) {
        const oldCost = this.tourCardData.calculatedServicesPrice;
        const oldName = this.getServiceNameBySvKey(14) || "Bus Transfer";
        this.calculateTour()
            .then(() => {
              const newCost = this.tourCardData.calculatedServicesPrice;
              this.GTMChangeBus(key, newCost, oldName, oldCost);
            })
      }
    },
    changeRailway(key) {
      this.railwayData.selected = key;

      let selectedDelta = this.RailwayTransfer[key][0].totalCost;
      this.RailwayTransfer = this.RailwayTransfer.map(x => {
        x[0].delta = x[0].totalCost - selectedDelta;
        return x;
      });

      if (this.readyForCalculate) {
        const oldCost = this.tourCardData.calculatedServicesPrice;
        const oldName = this.getServiceNameBySvKey(15) || "Railway Transfer";
        this.calculateTour()
            .then(() => {
              const newCost = this.tourCardData.calculatedServicesPrice;
              this.GTMChangeRailway(key, newCost, oldName, oldCost);
            })
      }
    },
    changeBusType(key, key2, e) {
      let newBus = this.busTransfer[key].find((x, i) => i === key2);
      let value = newBus.busType[e.value].allData.Cost;

      let allRate = this.$store.getters['getAllCurrency'];
      let rate = allRate.find(x => x.Code === this.tourRate);

      newBus = Object.assign({}, newBus);
      newBus.busTypeSelected = this.busTransfer[key][key2].busType.find(x => x.value === e.value)
      newBus.busType = this.busTransfer[key][key2].busType.map(x => {
        x.secondLabel = (x.allData.Cost - value < 0 || x.allData.Cost - value === 0) ?
            `${this.correctPrice(x.allData.Cost - value, true)} ${this.getCurrencyDisplayBySettings(rate)}` :
            `+${this.correctPrice(x.allData.Cost - value, true)} ${this.getCurrencyDisplayBySettings(rate)}`;
        return x
      });

      let selectedCost = newBus.busTypeSelected.allData.Cost;
      const defaultCost = this.busTransfer[key][key2].busType[0].allData.Cost;
      const costChanged = selectedCost - defaultCost;
      newBus.costChanged = (costChanged > 0 ? '+' : '') + this.correctPrice(costChanged, true) + " " + this.getCurrencyDisplayBySettings(rate);
      if (costChanged === 0) newBus.costChanged = '';

      this.$set(this.busTransfer[key], key2, newBus);

      if (this.readyForCalculate) {
        const oldCost = this.tourCardData.calculatedServicesPrice;
        const oldName = this.getServiceNameBySvKey(14) || "Bus Transfer";
        this.calculateTour()
            .then(() => {
              const newCost = this.tourCardData.calculatedServicesPrice;
              this.GTMChangeBus(key, newCost, oldName, oldCost);
            })
      }
    },
    changeRailwayType(key, key2, e) {
      let newRailway = this.railwayTransfer[key].find((x, i) => i === key2);
      let value = newRailway.railwayType[e.value].allData.Cost;

      let allRate = this.$store.getters['getAllCurrency'];
      let rate = allRate.find(x => x.Code === this.tourRate);

      newRailway = Object.assign({}, newRailway);
      newRailway.railwayTypeSelected = this.railwayTransfer[key][key2].railwayType.find(x => x.value === e.value)
      newRailway.railwayType = this.railwayTransfer[key][key2].railwayType.map(x => {
        x.secondLabel = (x.allData.Cost - value < 0 || x.allData.Cost - value === 0) ?
            `${this.correctPrice(x.allData.Cost - value, true)} ${this.getCurrencyDisplayBySettings(rate)}` :
            `+${this.correctPrice(x.allData.Cost - value, true)} ${this.getCurrencyDisplayBySettings(rate)}`;
        return x
      });

      let selectedCost = newRailway.railwayTypeSelected.allData.Cost;
      const defaultCost = this.railwayTransfer[key][key2].railwayType[0].allData.Cost;
      const costChanged = selectedCost - defaultCost;
      newRailway.costChanged = (costChanged > 0 ? '+' : '') + this.correctPrice(costChanged, true) + " " + this.getCurrencyDisplayBySettings(rate);
      if (costChanged === 0) newRailway.costChanged = '';

      this.$set(this.railwayTransfer[key], key2, newRailway);

      if (this.readyForCalculate) {
        const oldCost = this.tourCardData.calculatedServicesPrice;
        const oldName = this.getServiceNameBySvKey(15) || "Railway Transfer";
        this.calculateTour()
            .then(() => {
              const newCost = this.tourCardData.calculatedServicesPrice;
              this.GTMChangeRailway(key, newCost, oldName, oldCost);
            })
      }
    },
    GTMChangeBus(key, cost, oldName, oldCost) {
      // Google Tag Manager
      let name = this.getServiceNameBySvKey(14) || "Bus Transfer";
      const currency = this.$store.getters['getAllCurrency'].find(x => x.Code === this.tour.Rate).IsoCode;
      GTM.updateCard(this.busTransfer[key][0].allData, cost, "Bus Transfer", this.tour, currency, name, "changeBus", oldName, oldCost);
      // End Google Tag Manager
    },
    GTMChangeRailway(key, cost, oldName, oldCost) {
      // Google Tag Manager
      let name = this.getServiceNameBySvKey(15) || "Railway Transfer";
      const currency = this.$store.getters['getAllCurrency'].find(x => x.Code === this.tour.Rate).IsoCode;
      GTM.updateCard(this.railwayTransfer[key][0].allData, cost, "Railway Transfer", this.tour, currency, name, "changeRailway", oldName, oldCost);
      // End Google Tag Manager
    },
    createBusTransfer(data) {
      this.busTransfer = [];
      const uniqueBusTransfer = [];

      data.forEach((x, i) => {
        //Определяем город откуда и куда
        if (i === 0) {
          const busData = x.Services.find(x2 => x2.SvKey === 14);
          if (!busData) {
            return
          }
          this.busData.placeFrom = busData.CityFrom.Value;
          this.busData.placeTo = busData.CityTo.Value;
        }
        let busTransfer = x.Services.filter(x2 => x2.SvKey === 14);
        busTransfer = busTransfer.map(x2 => {
          const timeFrom = x2.TimeFrom.slice(0, 5);
          const timeTo = x2.TimeTo.slice(0, 5);
          const timeDuration = this.correctTime(x2);
          let allRate = this.$store.getters['getAllCurrency'];
          let rate = allRate.find(x => x.Code === this.tourRate);
          let busType = x2.BusTransferDetails.map((x3, i3) => {
            let res = {
              label: x3.Transport.Value,
              secondLabel: x3.Cost > 0 ?
                  `+${this.correctPrice(x3.Cost, true)} ${this.getCurrencyDisplayBySettings(rate)}` :
                  `${this.correctPrice(x3.Cost, true)} ${this.getCurrencyDisplayBySettings(rate)}`,
              value: i3,
              allData: x3
            }
            return res
          })
          busType[0].secondLabel = `0 ${this.getCurrencyDisplayBySettings(rate)}`;

          const construct = {
            parent: x,
            day: x2.Day,
            busTransfer: x2.BusTransfer.Value,
            timeFrom,
            timeTo,
            timeDuration,
            cityFrom: x2.CityFrom.Value,
            cityTo: x2.CityTo.Value,
            busTypeSelected: busType[0],
            busTypeSelectedValue: busType[0].value,
            busType,
            allData: x2
          }
          return construct
        });
        let busTransferKey = busTransfer.map(x => x.allData.BusTransfer.Key).join("_");

        if (!uniqueBusTransfer.includes(busTransferKey)) {
          this.busTransfer.push(busTransfer);
          uniqueBusTransfer.push(busTransferKey);
        }
      });

      if (this.busTransfer.length && this.busTransfer[0].length) {
        let selectedDelta = this.busTransfer[0][0].parent.Cost;
        this.busTransfer = this.busTransfer.map(x => {
          x[0].delta = x[0].parent.Cost - selectedDelta;
          x[0].totalCost = x[0].parent.Cost;
          return x
        })
      }
    },
    createRailwayTransfer(data) {
      this.railwayTransfer = [];
      const uniqueRailwayTransfer = [];

      data.forEach((x, i) => {
        //Определяем город откуда и куда
        if (i === 0) {
          const railwayData = x.Services.find(x2 => x2.SvKey === 15);
          if (!railwayData) {
            return
          }
          this.railwayData.placeFrom = railwayData.CityFrom.Value;
          this.railwayData.placeTo = railwayData.CityTo.Value;
        }
        let railwayTransfer = x.Services.filter(x2 => x2.SvKey === 15);
        railwayTransfer = railwayTransfer.map(x2 => {
          const timeFrom = x2.TimeFrom.slice(0, 5);
          const timeTo = x2.TimeTo.slice(0, 5);
          const timeDuration = this.correctTime(x2);
          let allRate = this.$store.getters['getAllCurrency'];
          let rate = allRate.find(x => x.Code === this.tourRate);
          let railwayType = x2.RailwayTransferDetails.map((x3, i3) => {
            let res = {
              label: x3.Transport.Value,
              secondLabel: x3.Cost > 0 ?
                  `+${this.correctPrice(x3.Cost, true)} ${this.getCurrencyDisplayBySettings(rate)}` :
                  `${this.correctPrice(x3.Cost, true)} ${this.getCurrencyDisplayBySettings(rate)}`,
              value: i3,
              allData: x3
            }
            return res
          })
          railwayType[0].secondLabel = `0 ${this.getCurrencyDisplayBySettings(rate)}`;

          const construct = {
            parent: x,
            day: x2.Day,
            railwayTransfer: x2.RailwayTransfer.Value,
            timeFrom,
            timeTo,
            timeDuration,
            cityFrom: x2.CityFrom.Value,
            cityTo: x2.CityTo.Value,
            railwayTypeSelected: railwayType[0],
            railwayTypeSelectedValue: railwayType[0].value,
            railwayType,
            allData: x2
          }
          return construct
        });
        let railwayTransferKey = railwayTransfer.map(x => x.allData.RailwayTransfer.Key).join("_");

        if (!uniqueRailwayTransfer.includes(railwayTransferKey)) {
          this.railwayTransfer.push(railwayTransfer);
          uniqueRailwayTransfer.push(railwayTransferKey);
        }
      });

      if (this.railwayTransfer.length && this.railwayTransfer[0].length) {
        let selectedDelta = this.railwayTransfer[0][0].parent.Cost;
        this.railwayTransfer = this.railwayTransfer.map(x => {
          x[0].delta = x[0].parent.Cost - selectedDelta;
          x[0].totalCost = x[0].parent.Cost;
          return x
        })
      }
    },
    changeTransfer(key, key2, e) {
      let newTransfer = this.transfer[key].find((x, i) => i === key2);
      let value = newTransfer.transfer[e.value].allData.Cost;
      let allRate = this.$store.getters['getAllCurrency'];
      let rate = allRate.find(x => x.Code === this.tourRate);
      newTransfer = Object.assign({}, newTransfer);
      let oldCost = newTransfer.transferSelected.value;
      newTransfer.transferSelected = this.transfer[key][key2].transfer.find(x => x.value === e.value);
      let newCost = newTransfer.transferSelected.value;
      newTransfer.transfer = this.transfer[key][key2].transfer.map(x => {
        x.secondLabel = (x.allData.Cost - value < 0 || x.allData.Cost - value === 0) ?
            `${this.correctPrice(x.allData.Cost - value, true)} ${this.getCurrencyDisplayBySettings(rate)}` :
            `+${this.correctPrice(x.allData.Cost - value, true)} ${this.getCurrencyDisplayBySettings(rate)}`;
        return x
      })
      this.$set(this.transfer[key], key2, newTransfer);
      if (this.readyForCalculate) {
        if (!this.transfer[key][key2].allData.IsNotCalculate) oldCost = this.tourCardData.calculatedServicesPrice;
        const oldName = this.getServiceNameBySvKey(2) || "Transfer";
        this.calculateTour()
            .then(() => {
              this.$nextTick(() => {
                if (!this.transfer[key][key2].allData.IsNotCalculate) newCost = this.tourCardData.calculatedServicesPrice;
                this.GTMChangeTransfer(key, key2, newCost, false, oldName, oldCost);
              });
            })
      }
    },
    GTMChangeTransfer(key, key2, cost, isAdded = false, oldName, oldCost) {
      // Google Tag Manager
      let name = this.getServiceNameBySvKey(2) || "Transfer";
      const currency = this.$store.getters['getAllCurrency'].find(x => x.Code === this.tour.Rate).IsoCode;
      GTM[isAdded ? 'addToCart' : 'updateCard'](this.transfer[key][key2].allData, cost, "Transfer", this.tour, currency, name, "changeTransfer", oldName, oldCost);
      // End Google Tag Manager
    },
    GTMRemoveTransfer(key, key2, cost, name, newCost) {
      // Google Tag Manager
      const currency = this.$store.getters['getAllCurrency'].find(x => x.Code === this.tour.Rate).IsoCode;
      const allData = this.transfer[key][key2].allData;
      if (allData.IsNotCalculate) {
        GTM.removeFromCard(allData, cost, "Transfer", this.tour, currency, name, "changeTransfer");
      } else {
        GTM.updateCard(allData, newCost, "Transfer", this.tour, currency, name, "changeTransfer", name, cost);
      }
      // End Google Tag Manager
    },
    checkedTransfer(key1, key2, value) {
      this.$nextTick(() => {
        if (this.readyForCalculate) {

          let oldCost = this.transfer[key1][key2].transferSelectedValue;
          if (!this.transfer[key1][key2].allData.IsNotCalculate) oldCost = this.tourCardData.calculatedServicesPrice;
          const oldName = this.getServiceNameBySvKey(2) || "Transfer";

          this.calculateTour()
              .then(() => {
                this.$nextTick(() => {
                  let newCost = this.transfer[key1][key2].transferSelectedValue;
                  let isAdded = true;
                  if (!this.transfer[key1][key2].allData.IsNotCalculate) {
                    newCost = this.tourCardData.calculatedServicesPrice;
                    isAdded = false
                  }
                  if (value)
                    this.GTMChangeTransfer(key1, key2, newCost, isAdded, oldName, oldCost);
                  else {
                    this.GTMRemoveTransfer(key1, key2, oldCost, oldName, newCost);
                  }
                });
              })
        }
      })
    },
    createTransfer(data) {
      this.transfer = [];
      // const partnersId = this.getPartnerIdByTransfer();
      const partnerBasedOnServicesId = this.getPartnerIdBySvKey(3);
      let transfers = data[0].Services.filter(x => x.SvKey === 2);

      transfers = transfers.map((x2, i2) => {
        if (x2.IsPartnerBasedOn 
            && x2.PartnerBasedOnServiceTemplateId
            && x2.PartnerBasedOnServiceTemplateId > 0) {
              x2.Details = x2.Details.filter(item => item.PartnerId === partnerBasedOnServicesId);
            }

        if (!x2.Details.length) {
          alert(this.localizeList.failedFindTransfer);
        }

        let selectedCost = 0;
        let selectedIndex = 0;
        let transferAlreadySelected = false;
        x2.Details.forEach((x3, i3) => {
          if (x3.PartnerId === partnerBasedOnServicesId && !transferAlreadySelected && x2.PartnerBasedOnServiceTemplateId) {
            selectedIndex = i3;
            selectedCost = x3.Cost;
            transferAlreadySelected = true;
          } else if (!x2.PartnerBasedOnServiceTemplateId) {
            const lowerPriceItemIndex = transfers[i2].Details.findIndex(x => x.Cost <= x3.Cost);
            if (lowerPriceItemIndex !== -1) {
              selectedIndex = lowerPriceItemIndex;
              selectedCost = x2.Details[lowerPriceItemIndex]?.Cost;
              transferAlreadySelected = true;
            }
          }
        });

        let transfer = x2.Details.map((x3, i3) => {
          let allRate = this.$store.getters['getAllCurrency'];
          let rate = allRate.find(x => x.Code === this.tourRate);
          let res = {
            label: x3.SubCode1.Value,
            secondLabel: x3.Cost - selectedCost > 0 ?
                `+${this.correctPrice(x3.Cost - selectedCost, true)} ${this.getCurrencyDisplayBySettings(rate)}` :
                `${this.correctPrice(x3.Cost - selectedCost, true)} ${this.getCurrencyDisplayBySettings(rate)}`,
            rate: this.getCurrencyDisplayBySettings(rate),
            value: i3,
            allData: x3,
            id: x2.Id
          };
          return res
        });
        const construct = {
          allData: x2,
          day: x2.Day,
          code: x2.Code.Value,
          transferSelected: transfer[selectedIndex],
          transferSelectedValue: transfer[selectedIndex].value,
          showCheckbox: !x2.IsHooded,
          isDisabled: !x2.IsDeleted,
          isChecked: !x2.IsNotCalculate || !x2.IsDeleted,
          isHooded: x2.IsHooded,
          transfer,
        };
        if (x2.IsHooded) this.hoodedServices.push(x2.SvKey);
        return construct
      });
      this.transfer.push(transfers)
    },
    changeExcursion(key, e) {
      this.excursion[key].selectedItem = e.allData;
      this.excursion[key].selectedItem2 = e.allData;

      if (this.excursion[key].isChecked) {
        if (this.readyForCalculate)
          this.calculateTour();
      }
    },
    getExcursionItems(data) {
      const partnerId = this.getPartnerIdBySvKey(4);
      let selectedIndex = 0;
      let excursionAlreadySelected = false;
      let selectedCost = data.Details
          .find(x3 => partnerId === x3.PartnerId && !excursionAlreadySelected);
      selectedCost = selectedCost ? selectedCost.Cost : 0;

      let excursion = data.Details.map((x3, i3) => {
        if (partnerId === x3.PartnerId && !excursionAlreadySelected) {
          selectedIndex = i3;
          excursionAlreadySelected = true;
        }

        let allRate = this.$store.getters['getAllCurrency'];
        let rate = allRate.find(x => x.Code === this.tourRate);

        let res = {
          label: x3.SubCode1.Value,
          secondLabel: x3.Cost - selectedCost > 0 ?
              `+ ${this.correctPrice(x3.Cost - selectedCost, true)} ${this.getCurrencyDisplayBySettings(rate)}` :
              `${this.correctPrice(x3.Cost - selectedCost, true)} ${this.getCurrencyDisplayBySettings(rate)}`,
          rate: this.getCurrencyDisplayBySettings(rate),
          value: x3.Cost,
          allData: x3,
          id: data.Id
        };
        return res
      });
      const labels = [];
      excursion = excursion.filter((x, i) => {
        if (!labels.includes(x.label) || i === selectedIndex) {
          labels.push(x.label);
          return x
        }
      });

      return {
        excursion: [...excursion],
        excursionSelected: excursion[selectedIndex],
        excursionSelectedValue: excursion[selectedIndex].value,
      }
    },
    changeExcursionValue2(key, e) {
      this.excursion[key].selectedItem2 = e.allData;

      const items = this.getExcursionItems(e.allData);

      this.excursion[key].excursion = items.excursion;
      this.excursion[key].excursionSelected = items.excursionSelected;
      this.excursion[key].excursionSelectedValue = items.excursionSelectedValue;

      if (this.excursion[key].isChecked) {
        if (this.readyForCalculate)
          this.calculateTour();
      }
    },
    changeExcursionValue(key, e) {
      let value = e.value;
      let newExcursion = JSON.parse(JSON.stringify(this.excursion[key]));
      let oldCost = newExcursion.excursionSelectedValue;
      if (!this.excursion[key].selectedItem.IsNotCalculate) oldCost = this.tourCardData.calculatedServicesPrice;
      newExcursion.excursionSelected = newExcursion.excursion.find(x => x.value === value);
      newExcursion.excursionSelectedValue = value;
      let allRate = this.$store.getters['getAllCurrency'];
      let rate = allRate.find(x => x.Code === this.tourRate);
      newExcursion.excursion = newExcursion.excursion.map(x => {
        x.secondLabel = (x.value - value < 0 || x.value - value === 0) ?
            `${this.correctPrice(x.value - value, true)} ${this.getCurrencyDisplayBySettings(rate)}` :
            `+${this.correctPrice(x.value - value, true)} ${this.getCurrencyDisplayBySettings(rate)}`;
        return x
      });
      this.excursion = this.excursion.map((x, i) => {
        if (i === key) {
          return newExcursion
        } else {
          return x
        }
      });
      let newCost = newExcursion.excursionSelectedValue;

      if (this.readyForCalculate) {
        const oldName = this.getServiceNameBySvKey(4) || "Excursion";
        this.calculateTour()
            .then(() => {
              if (!this.excursion[key].selectedItem.IsNotCalculate) newCost = this.tourCardData.calculatedServicesPrice;
              this.GTMChangeExcursion(key, newCost, false, oldName, oldCost);
            })
      }
    },
    GTMChangeExcursion(key, cost, isAdded = false, oldName, oldCost = 0) {
      // Google Tag Manager
      const data = this.excursion[key].selectedItem;
      let name = this.getServiceNameBySvKey(4) || "Excursion";
      const currency = this.$store.getters['getAllCurrency'].find(x => x.Code === this.tour.Rate).IsoCode;
      GTM[isAdded ? 'addToCart' : 'updateCard'](data, cost, "Excursion", this.tour, currency, name, "changeExcursion", oldName, oldCost);
      // End Google Tag Manager
    },
    GTMRemoveExcursion(key, cost, name, newCost) {
      // Google Tag Manager
      const data = this.excursion[key].selectedItem;
      const currency = this.$store.getters['getAllCurrency'].find(x => x.Code === this.tour.Rate).IsoCode;
      if (data.IsNotCalculate) {
        GTM.removeFromCard(data, cost, "Excursion", this.tour, currency, name, "changeExcursion");
      } else {
        GTM.updateCard(data, newCost, "Excursion", this.tour, currency, name, "changeExcursion", name, cost);
      }
      // End Google Tag Manager
    },
    getServiceNameBySvKey(svKey, key = 0) {
      return this.tourCardData.serviceTourists.filter(x => x.ServiceType === svKey)?.[key]?.Name ||
          this.tourCardData.serviceTourists.filter(x => x.ServiceType === svKey)?.[0]?.Name ||
          this.tourCardData.requiredServices.filter(x => x.ServiceType === svKey)?.[key]?.Name ||
          this.tourCardData.requiredServices.filter(x => x.ServiceType === svKey)?.[0]?.Name ||
          this.tourCardData.additionalServices.filter(x => x.ServiceType === svKey)?.[key]?.Name ||
          this.tourCardData.additionalServices.filter(x => x.ServiceType === svKey)?.[0]?.Name
    },
    checkedExcursion(key, value) {
      this.$nextTick(() => {
        if (this.readyForCalculate) {
          let oldCost = this.excursion[key].excursionSelected.value;
          if (!this.excursion[key].selectedItem.IsNotCalculate) oldCost = this.tourCardData.calculatedServicesPrice;
          const oldName = this.getServiceNameBySvKey(4) || "Excursion";
          this.calculateTour()
              .then(() => {
                let newCost = this.excursion[key].excursionSelected.value;
                let isAdded = true;
                if (!this.excursion[key].selectedItem.IsNotCalculate) {
                  newCost = this.tourCardData.calculatedServicesPrice;
                  isAdded = false
                }

                if (value) {
                  this.GTMChangeExcursion(key, newCost, isAdded, oldName, oldCost)
                } else {
                  this.GTMRemoveExcursion(key, oldCost, oldName, newCost)
                }
              })
        }
      })
    },
    createExcursion(data) {
      this.excursion = [];
      data[0].NotRouteServices.forEach(x => {
        const construct = {
          items: [],
          selectedItem: null,
          selectedValue: null,
          items2: [],
          selectedItem2: null,
          selectedValue2: null,
          excursion: [],
          excursionSelected: null,
          excursionSelectedValue: null,
          isChecked: false,
          isDisabled: false,
          isHooded: false,
        };
        x.forEach(x2 => {
          if (x2.SvKey === 4) {
            construct.isHooded = x2.IsHooded;
            if (x2.IsHooded) this.hoodedServices.push(x2.SvKey);

            x2.value = true;
            x2.isDisabled = true;
            if (!construct.items.length) {
              construct.selectedItem = x2;
              construct.selectedValue = 0;
              construct.isDisabled = !x2.IsDeleted;
              construct.isChecked = !x2.IsNotCalculate || !x2.IsDeleted;
            }
            const dataItems = {
              label: `${x2.Day} ${this.localizeList.day}`,
              value: x2.Day,
              allData: x2
            };

            const isIncludes = construct.items.map(x => `${x.label}_${x.value}`).includes(`${dataItems.label}_${dataItems.value}`);
            if (!isIncludes)
              construct.items.push(dataItems);

            // if (!construct.items2.length) {
            //   construct.selectedItem2 = x2;
            //   construct.selectedValue2 = x2.Code.Key;
            // }
            const dataItems2 = {
              label: x2.Code.Value + " " + this.getDateByFormat(x2.EndDateTime, "DD.MM.YYYY"),
              value: x2.Day,
              allData: x2
            };
            construct.items2.push(dataItems2)
          }
        });

        if (construct.items2.length) {
          construct.items2 = this.$store.getters['quicksort'](construct.items2, 'label')
          construct.selectedItem2 = construct.items2[0].allData;
          construct.selectedValue2 = construct.items2[0].allData.Day;
        }

        if (construct.selectedItem2) {
          const items = this.getExcursionItems(construct.selectedItem2);

          construct.excursion = items.excursion;
          construct.excursionSelected = items.excursionSelected;
          construct.excursionSelectedValue = items.excursionSelectedValue;
        }

        if (construct.items.length) {
          this.excursion.push(construct)
        }
        /*if (construct.items.length) {
          if (construct.items2.length) {
            construct.items2 = this.$store.getters['quicksort'](construct.items2, 'label');
            // console.log(construct, construct.selectedItem2, construct.items2, 111)
            // if (construct.items2[0]?.allData) construct.selectedItem2 = construct.items2[0].allData;


            // construct.selectedValue2 = construct.items2[0]?.allData.Code.Key;
          }

          this.excursion.push(construct)
        }*/
      });
      //Выбераем первый элемент
      this.excursion.forEach((x, i) => {
        this.excursion[i].selectedItem = x.items[0].allData;
        this.excursion[i].selectedValue = x.items[0].value;
      })
    },
    changeAdditionalServices(key, key2, prop, e, id) {
      const isDateItem = prop === "dateItems";

      const partnerId = this.getPartnerIdBySvKey(e.allData.SvKey);
      let value = e.value;
      let changeAdditionalServicesKey = 0;
      this.additionalServices.forEach((x, i) => {
        if (x.id === id) {
          changeAdditionalServicesKey = i
        }
      });
      let newService = this.additionalServices[changeAdditionalServicesKey].items[key2];
      // let newService = this.additionalServices[key].items[key2];

      let oldCost = newService.allItems.find(x => {
        return (x.value === newService.itemSelectedValue &&
            x.allData.BeginDateTime === newService.itemDateSelectedValue)
      }).allData.Details[0].Cost;
      let newCost = newService.allItems.find(x => {
        if (isDateItem) {
          return (x.value === newService.itemSelectedValue &&
              x.allData.BeginDateTime === value)
        } else {
          return (x.value === value &&
              x.allData.BeginDateTime === newService.itemDateSelectedValue)
        }
      })?.allData.Details[0].Cost;
      this.additionalServices[changeAdditionalServicesKey].selectedDetail.cost = newCost
      if (!newService.itemSelected.allData.IsNotCalculate) oldCost = this.tourCardData.calculatedServicesPrice;

      newService = JSON.parse(JSON.stringify(newService));
      newService.itemSelected = newService.allItems.find(x => {
        if (isDateItem) {
          return (x.value === newService.itemSelectedValue &&
              x.allData.BeginDateTime === value)
        } else {
          return (x.value === value &&
              x.allData.BeginDateTime === newService.itemDateSelectedValue)
        }
      });
      newService.itemSelected.isChecked = true

      let selectedCost = 0;
      const selectedDetailIndex = e.allData.Details.map(x => x.PartnerId).indexOf(partnerId);
      if (selectedDetailIndex !== -1) {
        selectedCost = e.allData.Details[selectedDetailIndex].Cost
      } else {
        selectedCost = e.allData.Details[0].Cost
      }

      newService[prop] = newService[prop].map(x => {
        let cost = 0;
        let alreadySelected = false;
        x.allData.Details.forEach(x2 => {
          if (x2.PartnerId === partnerId && !alreadySelected) {
            cost = x2.Cost;
            alreadySelected = true;
          }
        });
        if (!alreadySelected) {
          cost = x.allData.Details[0].Cost
        }
        let allRate = this.$store.getters['getAllCurrency'];
        let rate = allRate.find(x => x.Code === this.tourRate);

        const defaultCost = this.additionalServices[changeAdditionalServicesKey].items[key2][prop][0].allData.Details[0].Cost;
        const costChanged = selectedCost - defaultCost;
        newService.costChanged = (costChanged > 0 ? '+' : '') + this.correctPrice(costChanged, true) + " " + this.getCurrencyDisplayBySettings(rate);
        if (costChanged === 0) newService.costChanged = '';

        x.secondLabel = (cost - selectedCost < 0 || cost - selectedCost === 0) ?
            `${this.correctPrice(cost - selectedCost, true)} ${this.getCurrencyDisplayBySettings(rate)}` :
            `+ ${this.correctPrice(cost - selectedCost, true)} ${this.getCurrencyDisplayBySettings(rate)}`;
        return x
      });
      this.$set(this.additionalServices[changeAdditionalServicesKey].items, key2, newService);

      const details = [];
      let cost = 0;
      newService.itemSelected.allData.Details.forEach((x2, i2) => {
        let res;
        if (i2 === 0)
          cost = x2.Cost;

        let allRate = this.$store.getters['getAllCurrency'];
        let rate = allRate.find(x => x.Code === this.tourRate);

        res = {
          allData: x2,
          label: x2.SubCode1.Value,
          value: x2.SubCode1.Key,
          cost: x2.Cost,
          tourRate: this.getCurrencyDisplayBySettings(rate),
          secondLabel: (x2.Cost - cost > 0 ? "+" : "") + `${this.correctPrice(x2.Cost - cost, true)} ${this.getCurrencyDisplayBySettings(rate)}`
        };
        if (!details.map(x4 => x4.label).includes(res.label))
          details.push(res)
      });

      if (this.readyForCalculate) {
        const oldName = this.getServiceNameBySvKey(this.additionalServices[changeAdditionalServicesKey].items[0].itemSelected.allData.SvKey) ||
            this.additionalServices[changeAdditionalServicesKey].items[0].itemSelected.allData.Name ||
            this.additionalServices[changeAdditionalServicesKey].items[0].itemSelected.allData.ServiceName;
        this.calculateTour()
            .then(() => {
              const newName = this.getServiceNameBySvKey(this.additionalServices[changeAdditionalServicesKey].items[0].itemSelected.allData.SvKey) ||
                  this.additionalServices[changeAdditionalServicesKey].items[0].itemSelected.allData.Name ||
                  this.additionalServices[changeAdditionalServicesKey].items[0].itemSelected.allData.ServiceName;

              if (!newService.itemSelected.allData.IsNotCalculate) newCost = this.tourCardData.calculatedServicesPrice;
              this.GTMChangeAdditionalService(key, newCost, false, oldCost, newName, oldName);
            })
      }
    },
    GTMChangeAdditionalService(key, cost, isAdded = false, oldCost, newName, oldName) {
      // Google Tag Manager
      const currency = this.$store.getters['getAllCurrency'].find(x => x.Code === this.tour.Rate).IsoCode;
      const allData = this.additionalServices[key].items[0].items[0].allData;
      const type = allData.Name || allData.ServiceName;

      GTM[isAdded ? 'addToCart' : 'updateCard'](allData, cost, type, this.tour, currency, newName, "addToCart", oldName, oldCost);
      // End Google Tag Manager
    },
    GTMRemoveAdditionalService(key, cost, name, newCost) {
      // Google Tag Manager
      const currency = this.$store.getters['getAllCurrency'].find(x => x.Code === this.tour.Rate).IsoCode;
      const allData = this.additionalServices[key].items[0].items[0].allData;
      const type = allData.Name || allData.ServiceName;

      if (allData.IsNotCalculate) {
        GTM.removeFromCard(allData, cost, type, this.tour, currency, name, "changeCart");
      } else {
        GTM.updateCard(allData, newCost, type, this.tour, currency, name, "changeCart", name, cost);
      }
      // End Google Tag Manager
    },
    changeAddintionalDetail(key, e) {
      let value = e.value;
      let oldCost = this.additionalServices[key].selectedDetail.cost;
      if (!this.additionalServices[key].items[0].itemSelected.allData.IsNotCalculate) oldCost = this.tourCardData.calculatedServicesPrice;

      this.additionalServices = this.additionalServices.map((x, i) => {
        if (i === key) {
          let selectedValue = x.details.find(x2 => x2.value === value);
          x.selectedDetail = {...selectedValue};

          return x
        } else {
          return x
        }
      });
      let newCost = this.additionalServices[key].selectedDetail.cost;

      if (this.readyForCalculate) {
        const oldName = this.getServiceNameBySvKey(this.additionalServices[key].items[0].itemSelected.allData.SvKey) ||
            this.additionalServices[key].items[0].itemSelected.allData.Name ||
            this.additionalServices[key].items[0].itemSelected.allData.ServiceName;
        this.calculateTour()
            .then(() => {
              const newName = this.getServiceNameBySvKey(this.additionalServices[key].items[0].itemSelected.allData.SvKey) ||
                  this.additionalServices[key].items[0].itemSelected.allData.Name ||
                  this.additionalServices[key].items[0].itemSelected.allData.ServiceName;
              if (!this.additionalServices[key].items[0].itemSelected.allData.IsNotCalculate) newCost = this.tourCardData.calculatedServicesPrice;
              this.GTMChangeAdditionalService(key, newCost, false, oldCost, newName, oldName);
            })
      }
    },
    changeAddintionalDetail2(key, e, modifiedServices) {
      let value = e.value;
      let oldCost = modifiedServices[0].group[key].selectedDetail2.cost;

      if (!modifiedServices[0].group[key].items[0].itemSelected.allData.IsNotCalculate) oldCost = this.tourCardData.calculatedServicesPrice;
      this.additionalServices = modifiedServices[0].group.map((x, i) => {
        if (i === key) {
          let selectedValue = x.details2.find(x2 => x2.value === value);
          x.selectedDetail2 = {...selectedValue};

          return x
        } else {
          return x
        }
      });
      let newCost = this.additionalServices[key].selectedDetail2.cost;

      if (this.readyForCalculate) {

        const oldName = this.getServiceNameBySvKey(this.additionalServices[key].items[0].itemSelected.allData.SvKey) ||
            this.additionalServices[key].items[0].itemSelected.allData.Name ||
            this.additionalServices[key].items[0].itemSelected.allData.ServiceName;

        this.calculateTour()
            .then(() => {
              const newName = this.getServiceNameBySvKey(this.additionalServices[key].items[0].itemSelected.allData.SvKey) ||
                  this.additionalServices[key].items[0].itemSelected.allData.Name ||
                  this.additionalServices[key].items[0].itemSelected.allData.ServiceName;

              if (!this.additionalServices[key].items[0].itemSelected.allData.IsNotCalculate) newCost = this.tourCardData.calculatedServicesPrice;
              this.GTMChangeAdditionalService(key, newCost, false, oldCost, newName, oldName);
            })
      }
    },
    checkedAdditionalService(id, key2, value) {
      const currentService = this.additionalServices.find(x => x.id === id);
      let oldCost = currentService.selectedDetail?.cost ||
          currentService.items[key2].itemSelected.allData.Details[0].Cost;
      if (!currentService.items[0].itemSelected.allData.IsNotCalculate) oldCost = this.tourCardData.calculatedServicesPrice;


      this.additionalServices = this.additionalServices.map((x) => {
        if (x.id === id) {
          x.items[0].itemSelected.isChecked = value;
        }
        return x
      });
      if (this.readyForCalculate) {

        const oldName = this.getServiceNameBySvKey(currentService.items[0].itemSelected.allData.SvKey) ||
            currentService.items[0].itemSelected.allData.Name ||
            currentService.items[0].itemSelected.allData.ServiceName;
        this.calculateTour()
            .then(() => {
              const newName = this.getServiceNameBySvKey(currentService.items[0].itemSelected.allData.SvKey) ||
                  currentService.items[0].itemSelected.allData.Name ||
                  currentService.items[0].itemSelected.allData.ServiceName;

              let newCost = currentService.selectedDetail?.cost ||
                  currentService.items[key2].itemSelected.allData.Details[0].Cost;

              let isAdded = true;
              if (!currentService.items[0].itemSelected.allData.IsNotCalculate) {
                newCost = this.tourCardData.calculatedServicesPrice;
                isAdded = false;
              }

              const key = this.additionalServices.map(x => x.id).indexOf(id);
              if (value) {
                this.GTMChangeAdditionalService(key, newCost, isAdded, oldCost, newName)
              } else {
                this.GTMRemoveAdditionalService(key, oldCost, oldName, newCost)
              }
            })
      }
    },
    getPartnerIdBySvKey(svKey) {
      let res = null;
      const serviceDescriptions = this.$route.query.serviceDescriptions.split(",");
      serviceDescriptions.forEach(x => {
        const helper = x.split("_");
        const currentSvKey = +helper[3];
        if (svKey !== currentSvKey) return;

        res = +helper[helper.length - 3];
      });

      return res;
    },
    getPartnerIdByTransfer() {
      let res = [];
      let hotelPartnerId = null;

      const serviceDescriptions = this.$route.query.serviceDescriptions.split(",");
      serviceDescriptions.forEach(x => {
        const helper = x.split(",");
        helper.forEach(x => {
          const currentSvKey = +x.split("_")[3];
          if (currentSvKey === 3) {
            hotelPartnerId = +x.split("_").at(-3);
            return;
          }
          if (currentSvKey === 2) {
            res.push(+x.split("_").at(-3));
          }
        })
      })

      if (!res.length) {
        res = [hotelPartnerId];
      }

      return res
    },
    createAdditionalServices(res) {
      const mainServiceKeys = [1, 2, 3, 4, 14, 15];
      let routedService = res[0].Services
          .filter(x => !mainServiceKeys.includes(x.SvKey))
          .map(x => {
            x.isRoute = true;
            return [x]
          });

      let data = res[0].NotRouteServices;
      const specialServicesKey = [4, 5, 6];
      data = data.filter(x => !specialServicesKey.includes(x[0].SvKey));
      data = [...data, ...routedService];

      let additionalServices = [];
      data.forEach(x => {
        const partnerId = this.getPartnerIdBySvKey(x[0].SvKey);
        const minPriceItem = x.reduce((min, item) => item.Details[0].Cost < min.Details[0].Cost ? item : min);

        let selectedCost = 0;
        let selectedItemDate = x[0].BeginDateTime;

        let alreadySelected = x.every(x2 => x2.IsPartnerBasedOn);
        if (alreadySelected) selectedCost = x[0].Details[0].Cost;

        x.forEach((x2) => {
          x2.Details.forEach(x3 => {
            if (x3.PartnerId === partnerId && !alreadySelected) {
              selectedItemDate = x2.BeginDateTime;
              selectedCost = x3.Cost;
              alreadySelected = true;
            }
          })
        });

        if (!alreadySelected) {
          selectedCost = x[0].Details[0].Cost;
        }

        const allItems = [];
        let items = [];
        const dateItems = [];
        x.forEach((x2, idx2) => {
          let cost = x[idx2].Details[0].Cost;
          selectedCost = minPriceItem.Details[0].Cost;

          let allRate = this.$store.getters['getAllCurrency'];
          let rate = allRate.find(x => x.Code === this.tourRate);

          let res = {
            label: x2.Code.Value,
            costChanged: '',
            secondLabel: cost - selectedCost > 0 ?
                `+${this.correctPrice(cost - selectedCost, true)} ${this.getCurrencyDisplayBySettings(rate)}` :
                `${this.correctPrice(cost - selectedCost, true)} ${this.getCurrencyDisplayBySettings(rate)}`,
            value: x2.Code.Key,
            allData: x2,
            isChecked: true,
            showCheckbox: x2.IsDeleted
          }
          if (x2.IsNotCalculate && x2.IsDeleted) {
            res.isChecked = false;
          }

          allItems.push(fullCopy(res));

          const hasItem = items.some(x3 => x3.value === x2.Code.Key);
          const hasDateItem = dateItems.some(x3 => x3.value === x2.BeginDateTime);
          if (!hasItem) {
            items.push(fullCopy(res))
          }
          if (!hasDateItem) {
            res.label = this.getDateByFormat(x2.BeginDateTime, "DD.MM.YYYY");
            res.secondLabel = "";
            res.value = x2.BeginDateTime;
            dateItems.push(fullCopy(res))
          }

        });

        // Сортировка доп.услуг по цене и алфавиту
        items.sort((a, b) => {
          const costDifference = a.allData.Details[0].Cost - b.allData.Details[0].Cost;
          if (costDifference === 0) {
            return a.label.localeCompare(b.label);
          }
          return costDifference;
        });

        const service = {
          itemSelected: allItems.find(x3 => x3.value === items[0].value && x3.allData.BeginDateTime === selectedItemDate),
          itemSelectedValue: items[0].value,
          itemDateSelectedValue: selectedItemDate,
          allItems,
          items,
          dateItems
        };

        const details = [];
        let value = service.itemSelected.allData.Details
            .find(x2 => partnerId === x2.PartnerId);
        value = value ? value.Cost : 0;
        let selectedIndex = 0;
        let detailsAlreadySelected = x.every(x2 => !x2.IsPartnerBasedOn);
        service.itemSelected.allData.Details.forEach((x2, i2) => {
          let res;
          if (partnerId === x2.PartnerId && !detailsAlreadySelected) {
            selectedIndex = i2;
            detailsAlreadySelected = true;
          }

          let allRate = this.$store.getters['getAllCurrency'];
          let rate = allRate.find(x => x.Code === this.tourRate);

          res = {
            allData: x2,
            label: x2.SubCode1.Value,
            value: x2.SubCode1.Key,
            cost: x2.Cost,
            tourRate: this.getCurrencyDisplayBySettings(rate),
            secondLabel: (x2.Cost - value > 0 ? "+" : "") + `${this.correctPrice(x2.Cost - value, true)} ${this.getCurrencyDisplayBySettings(rate)}`
          };

          if (x[0].isRoute) {
            res.label = x2.SubCode1.Value + ", " + x2.SubCode2.Value;
            res.value = x2.SubCode1.Key + "_" + x2.SubCode2.Key;
          }

          if (!details.map(x4 => x4.label).includes(res.label))
            details.push(res);

          const index = details.map(x4 => x4.label).indexOf(res.label);
          if (detailsAlreadySelected && index !== -1) {
            details[index] = res
          }
        });

        const details2 = [];
        let value2 = service.itemSelected.allData.Details
            .find(x2 => partnerId === x2.PartnerId);
        value2 = value2 ? value2.Cost : 0;
        let selectedIndex2 = 0;
        let detailsAlreadySelected2 = x.every(x2 => !x2.IsPartnerBasedOn);
        service.itemSelected.allData.Details.forEach((x2, i2) => {
          if (x[0].isRoute) return;

          let res;
          if (partnerId === x2.PartnerId && !detailsAlreadySelected2) {
            selectedIndex2 = i2;
            detailsAlreadySelected2 = true;
          }

          let allRate = this.$store.getters['getAllCurrency'];
          let rate = allRate.find(x => x.Code === this.tourRate);

          res = {
            allData: x2,
            label: x2.SubCode2.Value,
            value: x2.SubCode2.Key,
            cost: x2.Cost,
            tourRate: this.getCurrencyDisplayBySettings(rate),
            secondLabel: (x2.Cost - value2 > 0 ? "+" : "") + `${this.correctPrice(x2.Cost - value2, true)} ${this.getCurrencyDisplayBySettings(rate)}`
          };
          if (!details2.map(x4 => x4.label).includes(res.label) && res.label)
            details2.push(res)
        });


        if (!additionalServices.length) {
          additionalServices.push({
            title: x[0].ServiceName,
            svKey: x[0].SvKey,
            items: [service],
            details: details,
            selectedDetail: details[selectedIndex] || details[0],
            selectedDetailValue: details[selectedIndex]?.value || details[0]?.value,
            details2: details2,
            selectedDetail2: details2[selectedIndex2] || details2[0],
            selectedDetailValue2: details2[selectedIndex2]?.value || details2[0]?.value,
            isShow: !service.itemSelected.allData.IsHooded,
            isRoute: x[0].isRoute || false
          })
        } else {
          additionalServices.push({
            title: x[0].ServiceName,
            svKey: x[0].SvKey,
            items: [service],
            details: details,
            selectedDetail: details[selectedIndex],
            selectedDetailValue: details[selectedIndex]?.value,
            details2: details2,
            selectedDetail2: details2[selectedIndex2],
            selectedDetailValue2: details2[selectedIndex2]?.value,
            isShow: !service.itemSelected.allData.IsHooded,
            isRoute: x[0].isRoute || false
          })
        }
      });

      // additionalServices = additionalServices.sort((a, b) => {
      //   if (a.isRoute && !b.isRoute) {
      //     // Сортировка по маршрутным услугам
      //     return -1
      //   } else if (a.svKey === 8 && b.svKey !== 8) {
      //     // Сортировка по ссылочним услугам
      //     return -1
      //   } else {
      //     return 1
      //   }
      // });

      let arr = [];
      additionalServices.forEach(x => {
        if (!arr.length) {
          arr.push(x)
        } else {
          const count = arr.length;
          let helper = false;
          for (let i = 0; i < count; i++) {
            // Сортировка по маршрутным услугам
            // Сортировка по ссылочним услугам
            if (
                !arr[i].isRoute && x.isRoute
            ) {
              arr = [...arr.slice(0, i), x, ...arr.slice(i)];
              helper = true;
              break;
            }
          }
          if (!helper) {
            arr.push(x)
          }
        }
      });

      additionalServices = arr;

      // Делаем групировку по svKey
      let svKeyWithPosition = [];
      additionalServices.forEach((x, i) => {
        x.id = new Date().getTime() + i;
        const index = svKeyWithPosition.map(x2 => x2.svKey).indexOf(x.svKey);
        if (index === -1) {
          svKeyWithPosition.push({svKey: x.svKey, position: i, count: 1})
        } else {
          svKeyWithPosition[index].count++
        }
        const item = svKeyWithPosition.find(x2 => x2.svKey === x.svKey);
        const pos = item.position;
        const count = item.count;
        if (i > pos + count) {
          this.additionalServices =
              [...this.additionalServices.slice(0, pos + count), x, ...this.additionalServices.slice(pos + count)]
        } else {
          this.additionalServices.push(x)
        }
      })
    },
    additionalFlightServices() {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          const flight = this.tour.Services.find(x => x.SvKey === 1);
          if (!flight) {
            resolve();
            return
          }
          const sendData = {
            BeginDate: flight.BeginDateTime,
            Currency: this.tour.Rate,
            Duration: this.tour.Duration,
            Services: this.services,
            TourProgramId: this.tour.Key,
            Tourists: this.tourists
          }
          this.$store.dispatch("basket/" + typesBasket.A_ADDITIONAL_FLIGHT_SERVICES, sendData)
              .then((res) => {
                this.$nextTick(() => {
                  this.flightSurcharge = [...res].map(x => {
                    x.isHooded = x.IsHooded;
                    if (x.IsHooded) this.hoodedServices.push(x.SvKey);
                    x.isChecked = false;
                    if (!x.IsDeleted) {
                      x.isDisabled = true;
                      x.isChecked = true
                    }

                    return x
                  });
                  resolve()
                })
              })
              .catch(err => {
                console.log(err);
                reject(err)
              })
        })
      })
    },
    setListByCode(code) {
      if (code === "citizenship") {
        this.getCitizenship()
      }
    },
    loadMoreItemsByCode(code) {
      if (code === "citizenship") {
        this.loadCitizenshipItems = false;
        this.getCitizenship(true)
      }
    },
    getLoadItemsByCode(code) {
      if (code === "citizenship") {
        return this.loadCitizenshipItems
      } else {
        return false
      }
    },
    setProperty(code, prop) {
      let res = prop === "position" ? 100 : "input";

      switch (code) {
        case "lastname":
          res = prop === "position" ? 1 : (prop === "type" ? "input" : 35);
          break;
        case "firstname":
          res = prop === "position" ? 2 : (prop === "type" ? "input" : 35);
          break;
        case "patronymic":
          res = prop === "position" ? 3 : (prop === "type" ? "input" : 35);
          break;
        case "lastnamerus":
          res = prop === "position" ? 4 : (prop === "type" ? "input" : 35);
          break;
        case "firstnamerus":
          res = prop === "position" ? 5 : (prop === "type" ? "input" : 35);
          break;
        case "patronymicrus":
          res = prop === "position" ? 6 : (prop === "type" ? "input" : 35);
          break;
        case "birthdate":
          res = prop === "position" ? 7 : (prop === "type" ? "input" : null);
          break;
        case "sex":
          res = prop === "position" ? 8 : (prop === "type" ? "select" : null);
          break;
        case "birthplace":
          res = prop === "position" ? 9 : (prop === "type" ? "input" : 35);
          break;
        case "passport":
          res = prop === "position" ? 10 : (prop === "type" ? "series-number" : null);
          break;
        case "passportdate":
          res = prop === "position" ? 11 : (prop === "type" ? "input" : null);
          break;
        case "passportdateend":
          res = prop === "position" ? 12 : (prop === "type" ? "input" : null);
          break;
        case "passportbywhom":
          res = prop === "position" ? 13 : (prop === "type" ? "input" : 254);
          break;
        case "passportrus":
          res = prop === "position" ? 14 : (prop === "type" ? "series-number" : 35);
          break;
        case "passportdaterus":
          res = prop === "position" ? 15 : (prop === "type" ? "input" : null);
          break;
        case "passportbywhomrus":
          res = prop === "position" ? 16 : (prop === "type" ? "input" : 254);
          break;
        case "citizenship":
          res = prop === "position" ? 17 : (prop === "type" ? "select" : null);
          break;
        case "phone":
          res = prop === "position" ? 18 : (prop === "type" ? "input" : 60);
          break;
        case "email":
          res = prop === "position" ? 19 : (prop === "type" ? "input" : 50);
          break;
        case "citizenid":
          res = prop === "position" ? 20 : (prop === "type" ? "input" : 14);
          break;
        case "residenceregion":
          res = prop === "position" ? 21 : (prop === "type" ? "input" : 35);
          break;
        case "howdidyouhear":
          res = prop === "position" ? 22 : (prop === "type" ? "input" : 100);
          break;
      }
      return res
    },
    createTrevelerModel(fields) {
      let res = [];
      fields.forEach((x) => {
        if (x.isGroup) {
          let items = [];
          x.items.forEach(x2 => {
            items.push({
              code: x2.Code,
              value: x2.value,
              required: x2.IsRequired,
              bookingNoRegistration: x2.IsBookingNoRegistration,
              isValid: true
            })
          });
          res.push(items)
        } else {
          res.push({
            code: x.Code,
            value: x.value,
            required: x.IsRequired,
            bookingNoRegistration: x.IsBookingNoRegistration,
            isValid: true
          })
        }
      });
      return res
    },
    setTravelerForm(data) {
      let country = null;
      country = data.CountryId;

      return new Promise(resolve => {
        this.$store.dispatch("basket/" + typesBasket.A_GET_TOURIST_DATA, country)
            .then(res => {
              let inputs = [];
              let fields = res.TouristFieldsSettings;

              this.touristSettings = res.TouristFieldsSettings;

              for (let key in fields) {

                if (fields[key].IsBookingNoRegistration) {
                  this.$store.commit("common/" + mTypesCommon.M_SET_IS_BOOKING_NO_REGISTRATION, true);
                  }//проверям на возможность бронирования без авторизации

                if (
                    fields[key].IsVisible &&
                    fields[key].Code !== "ismain" &&
                    fields[key].Code !== "number"
                ) {
                  let label = fields[key].HeaderText.replace(/<br \/>/, " ");
                  if (fields[key].IsRequired && !label.includes("*")) {
                    label += '<font color="red">*</font>'
                  }
                  fields[key].value = "";
                  fields[key].label = label;
                  fields[key].isValid = true;
                  fields[key].position = this.setProperty(fields[key].Code, "position");
                  fields[key].type = this.setProperty(fields[key].Code, "type");
                  fields[key].maxLength = this.setProperty(fields[key].Code, "max-length");
                  fields[key].lengths = fields[key].Code === 'passportrus' ? [10, 10] : (fields[key].Code === 'passport' ? [5, 13] : null);
                  if (
                      fields[key].Code === "birthdate" ||
                      fields[key].Code === "passportdate" ||
                      fields[key].Code === "passportdaterus"
                  ) {
                    fields[key].dateFrom = "1900.01.01"
                    fields[key].dateTo = moment().format("YYYY.MM.DD")
                  } else {
                    fields[key].dateFrom = moment().format("YYYY.MM.DD")
                    fields[key].dateTo = moment().add(100, "y").format("YYYY.MM.DD")
                  }

                  inputs.push(fields[key])
                }
              }
              inputs = this.$store.getters['quicksort'](inputs, "position");
              //Групируем поле "пол" с предедушим
              inputs = inputs.map((x, i) => {
                if (x.Code !== "sex") {

                  if (inputs[i + 1] && inputs[i + 1].Code === "sex") {
                    inputs[i + 1].value = 0;
                    return {
                      isGroup: true,
                      items: [x, inputs[i + 1]]
                    }
                  } else {
                    return x
                  }
                }
              })
              inputs = inputs.filter(x => x)

              const href = window.location.href;
              let adultCount = href.split("&").find(x => x.includes("adultCount")).split("=")[1];
              adultCount = +adultCount
              let childAges = href.split("&").find(x => x.includes("childAges"))
              childAges = childAges ? childAges.split("=")[1].split(",") : [];
              this.adultCount = adultCount;
              this.childCount = childAges.length;

              this.trevelerForm = [];
              let numb = 0;
              let touristType = "adult";
              for (let i = 0; i < (adultCount + childAges.length); i++) {
                numb++;
                if (numb > adultCount && touristType === "adult") {
                  numb = 1;
                  touristType = "child"
                }
                let age = 18;
                if (this.getSettings.ChildAgesSetting) {
                  age = this.getSettings.ChildAgesSetting.at(-1);
                  // Берем максимальный возраст ребенка из настроек и добавляем 1 для взрослых
                  if (touristType === "adult") {
                    age = age + 1
                  }
                }
                if (touristType === "child") {
                  age = childAges[numb - 1];
                }
                let title = this.localizeList[touristType];
                title = title[0].toUpperCase() + title.slice(1);
                this.trevelerForm.push({
                  title: `${i + 1}. ${title}`,
                  isMain: i === 0,
                  age: age,
                  type: touristType === "adult" ? 0 : 1,
                  inputs: inputs.slice()
                });
                this.$set(this.trevelerInfo, i, this.createTrevelerModel(inputs));
                this.$set(this.trevelerGender, i, [
                  {
                    value: 0,
                    text: this.localizeList.sexMaleUpper,
                    isShow: true
                  },
                  {
                    value: 1,
                    text: this.localizeList.sexFemaleUpper,
                    isShow: true
                  }
                ]);
              }
              this.createTrevelerServices(data);
              resolve()
            })
      })
    },
    checkNameValid(text) {
      return text.match(/(name|test|тест|qwer|asdf|zxcv|йцук|фыва|¤чсм)/)
          || !text.match(/^[a-zA-Z\u0430-\u044F\u0410-\u042F\u0456\u0491\u0454\u0457\u0401\u0027'][a-zA-Z\u0430-\u044F\u0410-\u042F\u0456\u0491\u0454\u0457\u0401\u0020\u0027'-]+[a-zA-Z\u0430-\u044F\u0410-\u042F\u0456\u0491\u0454\u0457\u0401\u0027']?$/)
          || !text.match(/^([^aieouy\u0443\u0435\u044B\u0430\u043E\u044D\u044F\u0438\u044E\u0452\u0454\u0457\u0401]*[aieouy\u0443\u0435\u044B\u0430\u043E\u044D\u044F\u0438\u044E\u0452\u0456\u0454\u0457\u0401]){1,}[^aieouy\u0443\u0435\u044B\u0430\u043E\u044D\u044F\u0438\u044E\u0452\u0456\u0454\u0457\u0401]*$/)
          || text.match(/(\u0020)\1/) // не должно быть двух дефисов ипробелов подряд
          || text.match(/([a-zа-я])\1\1/) //не должно быть трех одинаковых букв подряд
    },
    isEmpty(value) {
      return (value == null || (typeof value === "string" && value.trim().length === 0));
    },
    trevelerValidation(item, key1, key2, key3 = null) {
      if(item.Code=="citizenship" && this.trevelerForm[key1].isMain){
        if (this.tour.Services){
            if (this.calculatedCountry != this.trevelerInfo[key1][key2].value){
              this.calculatedCountry = this.trevelerInfo[key1][key2].value
              this.calculateTour()
            }
        }
      }
      const onlyLat = item.Translit === 2;
      let oldValue = this.trevelerForm[key1].inputs[key2].value;
      let value = this.trevelerInfo[key1][key2].value;
      if (key3 != null) {
        value = this.trevelerInfo[key1][key2][key3].value;
        oldValue = this.trevelerForm[key1].inputs[key2].items[key3].value;
      }
      //customerCountry
      if (this.isEmpty(value)) {
        if (item.IsRequired) {
          if (key3 !== null) {
            this.trevelerInfo[key1][key2][key3].isValid = false;
          } else {
            this.trevelerInfo[key1][key2].isValid = false;
          }
        } else {
          if (key3 !== null) {
            this.trevelerInfo[key1][key2][key3].isValid = true;
          } else {
            this.trevelerInfo[key1][key2].isValid = true;
          }
        }
      } else {
        if (item.maxLength !== null) {
          value = value.slice(0, item.maxLength);
        }

        if (
            item.Code === "lastname" || item.Code === "firstname" ||
            item.Code === "lastnamerus" || item.Code === "firstnamerus"
        ) {
          this.$nextTick(() => {
            value = value.split("");
            value = value.filter(x => {
              if (x === " ") {
                return x
              } else if (
                  (x.match(/\w/) || x.match(/[а-яА-я]/) || x.match(/-/))
                  && !x.match(/_/)
                  && !x.match(/\d/)
              ) {
                if (onlyLat) {
                  if (!x.match(/[А-Яа-я]/)) return x
                } else {
                  return x
                }
              }
            });

            this.trevelerInfo[key1][key2].value = value.join("");
            this.trevelerForm[key1].inputs[key2].value = value.join("");

            if (this.getSettings.CheckTouristDataInBasket) {
              let validText = this.checkNameValid(value.join("").toLowerCase());

              this.trevelerInfo[key1][key2].isValid = !validText;
            } else {
              this.trevelerInfo[key1][key2].isValid = true;
            }
          })
        } else if (
            item.Code === "patronymic" || item.Code === "patronymicrus"
        ) {
          value = value.split("");
          value = value.filter(x => {
            if (x === " ") {
              return x
            } else if (
                (x.match(/\w/) || x.match(/[а-яА-я]/) || x.match(/-/))
                && !x.match(/_/)
                && !x.match(/\d/)
            ) {
              if (onlyLat) {
                if (!x.match(/[А-Яа-я]/)) return x
              } else {
                return x
              }
            }
          });

          this.$nextTick(() => {
            this.trevelerInfo[key1][key2].value = value.join("");
            this.trevelerForm[key1].inputs[key2].value = value.join("");

            if (this.getSettings.CheckTouristDataInBasket) {
              let validText = this.checkNameValid(value.join("").toLowerCase());

              this.trevelerInfo[key1][key2].isValid = !validText;
            } else {
              this.trevelerInfo[key1][key2].isValid = true;
            }
          })
        } else if (item.Code === "passport" || item.Code === "passportrus")
          {
          this.$nextTick(() => {
            const series = value
                .split("/")[0]
                .split("")
                .filter(x => {
                  //должны быть только латинские и кириллические буквы и цифры дефис и пробел
                  if (
                      x.match(/([a-zA-Z\u0020\u0430-\u044F\u0410-\u042F\u0456\u0491\u0454\u0457\u0401\u0027\-\d])/i)
                  ) {
                    return x
                  }
                });

            const passport = value
                .split("/")[1]
                .split("")
                .filter((x, i) => {

                  if (
                      i === 0 && x.match(/[a-zA-Z]|#|\u2116|\d/) ||
                      i !== 0 && x.match(/(\d)/)
                  ) {
                    return x
                  }
                });
            value = [...series, "/", ...passport];
            if (item.Code === "passport") {
              if (value.length > oldValue.length) {
                if (!value.includes("/") && value.length === 5) {
                  value.push("/")
                }
                if (!value.includes("/") && value.length > 5) {
                  value = value.slice(0, 5).concat("/").concat(value.slice(5))
                }
              }
              if (value.join("").split("/")[1]) {
                value = value.join("").split("/");
                if (value[1] && value[1].length > 13) {
                  value = `${value[0]}/${value[1].slice(0, 13)}`.split("")
                } else {
                  value = value.join("/").split("")
                }
              }
            } else {
              if (value.length > oldValue.length) {
                if (!value.includes("/") && value.length === 10) {
                  value.push("/")
                }
                if (!value.includes("/") && value.length > 10) {
                  value = value.slice(0, 10).concat("/").concat(value.slice(10))
                }
              }
              if (value.join("").split("/")[1]) {
                value = value.join("").split("/");
                if (value[1] && value[1].length > 10) {
                  value = `${value[0]}/${value[1].slice(0, 10)}`.split("")
                } else {
                  value = value.join("/").split("")
                }
              }
            }

            this.trevelerInfo[key1][key2].value = value.join("");
            this.trevelerForm[key1].inputs[key2].value = value.join("");
            this.trevelerInfo[key1][key2].isValid = !!(series.length && passport.length);
          })
        } else if (
            item.Code === "passportdate" ||
            item.Code === "passportdateend" ||
            item.Code === "passportdaterus" ||
            item.Code === "birthdate"
        ) {
          this.$nextTick(() => {
            value = value.split("");
            value = value.filter((x, i) => {
              if (i < 10) {
                if (x === ".") {
                  return x
                } else if (x.match(/\d/)) {
                  return x
                }
              }
            });
            if (value.length > oldValue.length) {
              if (value.length === 2 || value.length === 5) {
                value.push(".")
              }
            }

            if (value.length === 3 && value[2] !== ".") {
              value = [...value.slice(0, 2), ".", value[2]]
            }
            if (value.length === 6 && value[5] !== ".") {
              value = [...value.slice(0, 5), ".", value[5]]
            }

            if (key3 != null) {
              this.trevelerInfo[key1][key2][key3].value = value.join("");
              this.trevelerForm[key1].inputs[key2].items[key3].value = value.join("");
            } else {
              this.trevelerInfo[key1][key2].value = value.join("");
              this.trevelerForm[key1].inputs[key2].value = value.join("");
            }
          })
        } else if (item.Code === "phone") 
        {
          this.$nextTick(() => {
            value = value.split("");
            value = value.filter((x, i) => {
              if (i === 0 && x === "+") {
                return x
              }
              if (x.match(/\d/) || x.match(/-/) || x.match(/\(/) || x.match(/\)/) || x.match(/ /)) {
                return x
              }
            });

            value = value.join("");
            const isValid = !!value.match(/^([+]?[0-9]{1,3})?(\([0-9]{3,5}\))?([0-9-/_]{5,15})$/);

            if (key3 != null) {
              this.trevelerInfo[key1][key2][key3].value = value;
              this.trevelerForm[key1].inputs[key2].items[key3].value = value;
            } else {
              this.trevelerInfo[key1][key2].value = value;
              this.trevelerForm[key1].inputs[key2].value = value;
              this.trevelerInfo[key1][key2].isValid = isValid;
            }
          })
        } else if (item.Code === "email") {
          this.$nextTick(() => {
            value = value.split("");
            value = value.filter(x => {
              if (onlyLat) {
                if (!x.match(/[А-Яа-я]/)) return x
              } else {
                return x
              }
            });
            value = value.join("");
            if (!value.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,9})+$/)) {
              this.trevelerInfo[key1][key2].isValid = false;
            } else {
              this.trevelerInfo[key1][key2].isValid = true;
            }
            if (key3 != null) {
              this.trevelerInfo[key1][key2][key3].value = value;
              this.trevelerForm[key1].inputs[key2].items[key3].value = value;
            } else {
              this.trevelerInfo[key1][key2].value = value;
              this.trevelerForm[key1].inputs[key2].value = value;
            }
          })
        } else if (item.Code === "citizenship")
        {
          if (this.isEmpty(value)) return false;

          this.$nextTick(() => {
            this.trevelerInfo[key1][key2].value = value;
            this.trevelerForm[key1].inputs[key2].value = value;

            this.trevelerInfo[key1][key2].isValid = true;
          })
        } else {
          this.$nextTick(() => {
            if (key3 !== null) {
              this.trevelerInfo[key1][key2][key3].value = value;
              this.trevelerForm[key1].inputs[key2].items[key3].value = value;
            } else {
              this.trevelerInfo[key1][key2].value = value;
              this.trevelerForm[key1].inputs[key2].value = value;
            }
            this.trevelerInfo[key1][key2].isValid = true;
          })
        }
      }
    },
    createTrevelerServices(res) {
      let allRate = this.$store.getters['getAllCurrency'];
      let rate = allRate.find(x => x.Code === this.tourRate);

      let data = res.NotRouteServices;
      data = data.filter(x => x[0].SvKey === 6 || x[0].SvKey === 5);
      let insuranceItems = [];
      let visaItems = [];

      let insuranceKey = 0;
      let visaKey = 0;
      const services = data.map((x) => {
        if (x[0].SvKey === 6) {
          insuranceItems.push([]);
        }
        if (x[0].SvKey === 5) {
          visaItems.push([]);
        }

        let items = [];
        let index = 1;
        x.forEach((x2) => {
          x2.Details.forEach((x3) => {
            let label = "";
            if (x2.SvKey === 5) {
              label = x2.Code.Value;
            } else {
              label = x3.SubCode1.Value + " " + x3.SubCode2.Value;
            }

            let res = {
              tourRate: this.getCurrencyDisplayBySettings(rate),
              index: index,
              label: label,
              secondLabel: x3.Cost > 0 ?
                  `+${this.correctPrice(x3.Cost, true)} ${this.getCurrencyDisplayBySettings(rate)}` :
                  `${this.correctPrice(x3.Cost, true)} ${this.getCurrencyDisplayBySettings(rate)}`,
              value: index,
              cost: x3.Cost,
              allData: Object.assign({}, x3),
              serviceAllData: Object.assign({}, x2),
              title: x2.Code.Value,
              isHooded: x2.IsHooded
            };
            index++;
            items.push(res);
            if (x2.SvKey === 6) {
              insuranceItems[insuranceKey].push({...res})
            }
            if (x2.SvKey === 5) {
              visaItems[visaKey].push({...res})
            }
          })
        });

        if (x[0].SvKey === 6) {
          insuranceKey++;
        }
        if (x[0].SvKey === 5) {
          visaKey++;
        }

        let selectedItem = x[0].SvKey === 6 ? items[0] : items.find(x => x.cost === 0) || items[0];
        let selectedIndex = 0;
        if (x[0].SvKey !== 6) {
          items.forEach((x, i) => {
            if (x.value === 0) {
              selectedIndex = i + 1
            }
          })
        } else {
          selectedIndex = 1
        }

        return {
          selectedIndex: selectedIndex,
          svKey: x[0].SvKey,
          title: x[0].Code.Value,
          selectedItem: selectedItem,
          value: selectedItem.value,
          items: items.slice()
        }
      });

      insuranceItems = insuranceItems.map(x => {
        x = this.$store.getters['quicksort'](JSON.parse(JSON.stringify(x)), "cost");

        const isNotCalculate = x
            .filter(x2 => x2.serviceAllData)
            .some(x2 => (x2.serviceAllData.IsNotCalculate || x2.serviceAllData.IsDeleted) && x2.serviceAllData.IsDeleted);

        if (isNotCalculate) {
          x.unshift({
            index: 0,
            label: this.localizeList.notRequiredUpper,
            value: 0,
            cost: 0
          });
        }

        return x
      });

      visaItems = visaItems.map(x => {
        x = this.$store.getters['quicksort'](JSON.parse(JSON.stringify(x)), "cost");

        const isNotCalculate = x
            .filter(x2 => x2.serviceAllData)
            .some(x2 => (x2.serviceAllData.IsNotCalculate || x2.serviceAllData.IsDeleted) && x2.serviceAllData.IsDeleted);

        if (isNotCalculate) {
          x.unshift({
            index: 0,
            label: this.localizeList.notRequiredUpper,
            value: 0,
            cost: 0
          });
        }

        return x
      });

      this.trevelerForm = this.trevelerForm.map((x, i) => {
        if (this.notRouteServices.length) {
          insuranceItems = this.setIndividualServiceItems(JSON.parse(JSON.stringify(insuranceItems)), i, 6);
          visaItems = this.setIndividualServiceItems(JSON.parse(JSON.stringify(visaItems)), i, 5)
        }

        this.$set(this.insuranceItems, i, insuranceItems.slice());
        if (insuranceItems.length) {
          const values = [];
          insuranceItems.forEach((x2) => {
            values.push(x2[0].value);
          });
          this.$set(this.insuranceValue, i, values);
        }

        this.$set(this.visaItems, i, visaItems.slice());
        if (visaItems.length) {
          const values = [];
          visaItems.forEach((x2) => {
            values.push(x2[0].value);
          });
          this.$set(this.visaValue, i, values)
        }

        if (x.services) {
          const index = x.services.map(x2 => x2.svKey).indexOf(13);
          if (index !== -1 && !services.map(x2 => x2.svKey).includes(13)) {
            services.push(x.services[index])
          }
        }
        x.services = services.slice();
        return x
      });
    },
    setIndividualServiceItems(items, key, svKey) {
      let allRate = this.$store.getters['getAllCurrency'];
      let rate = allRate.find(x => x.Code === this.tourRate);

      const age = this.tourists[key].Age;
      const service = this.notRouteServices.filter(x => x.Service.ServiceType === svKey && x.Age === age);

      items = items.map((x, idx) => {
        x.map((x2) => {
          if (!x2.allData) return x2;

          const [item] = service;
          service.shift()

          if (!item) return x2;

          x2.cost = x2.Cost = item.SimpleServiceCost.Brutto;

          //  x2.secondLabel = x2.cost > 0 ?
          //      `+${this.correctPrice(x2.cost, true)} ${this.getCurrencyDisplayBySettings(rate)}` :
          //      `${this.correctPrice(x2.cost, true)} ${this.getCurrencyDisplayBySettings(rate)}`;
          if (items[0].length > 1 && idx === 0) { 
            x2.secondLabel = x2.cost > 0 ?
            `+${this.correctPrice(x2.cost - x[0].cost, true)} ${this.getCurrencyDisplayBySettings(rate)}` :
            `${this.correctPrice(x2.cost, true)} ${this.getCurrencyDisplayBySettings(rate)}`;
          } else {
             x2.secondLabel = x2.cost > 0 ?
            `+${this.correctPrice(x2.cost, true)} ${this.getCurrencyDisplayBySettings(rate)}` :
            `${this.correctPrice(x2.cost, true)} ${this.getCurrencyDisplayBySettings(rate)}`;
          }
          return x2
        });

        return x
      });

      return items
    },
    GTMChangeInsurance(key, allData, cost, currency, isAdded, oldName, oldCost) {
      // Google Tag Manager
      let name = this.getServiceNameBySvKey(6, key) || "Insurance";
      GTM[isAdded ? 'addToCart' : 'updateCard'](allData, cost, "Insurance", this.tour, currency, name, "changeInsurance", oldName, oldCost);
      // End Google Tag Manager
    },
    GTMRemoveInsurance(key, allData, cost, currency, name, newCost) {
      // Google Tag Manager
      if (allData.IsNotCalculate) {
        GTM.removeFromCard(allData, cost, "Insurance", this.tour, currency, name, "changeInsurance");
      } else {
        GTM.updateCard(allData, newCost, "Insurance", this.tour, currency, name, "changeInsurance", name, cost);
      }
      // End Google Tag Manager
    },
    changeTrevelerService(key, e, key2) {
      const oldVal = this.insuranceValue[key][key2];
      this.$set(this.insuranceValue, key, e);

      if (this.readyForCalculate) {
        const isNotCalculate = !this.insuranceItems[key][key2][0].allData;
        const oldIndex = !isNotCalculate ? oldVal - 1 : oldVal;
        const oldSelectedItem = this.insuranceItems[key][key2][oldIndex];
        let oldCost = oldSelectedItem.cost;
        if (!isNotCalculate) oldCost = this.tourCardData.calculatedServicesPrice;
        const index = !isNotCalculate ? e[key2] - 1 : e[key2];
        const selectedItem = this.insuranceItems[key][key2][index];
        const isNotSelected = !selectedItem?.serviceAllData;
        const allData = this.insuranceItems[key][key2][index]?.serviceAllData ||
            this.insuranceItems[key][key2].find(x => x.serviceAllData)?.serviceAllData || {Id: null};
        const currency = this.$store.getters['getAllCurrency'].find(x => x.Code === this.tour.Rate).IsoCode;
        let newCost = selectedItem.cost;

        const oldName = this.getServiceNameBySvKey(6, key) || "Insurance";
        this.calculateTour()
            .then(() => {
              let isAdded = oldVal === 0;
              if (!isNotCalculate) {
                newCost = this.tourCardData.calculatedServicesPrice;
                isAdded = false
              }

              if (isNotSelected) {
                this.GTMRemoveInsurance(key, allData, oldCost, currency, oldName, newCost)
              } else {
                this.GTMChangeInsurance(key, allData, newCost, currency, isAdded, oldName, oldCost)
              }
            })
      }
    },
    GTMChangeVisa(key, allData, cost, currency, isAdded, oldName, oldCost) {
      // Google Tag Manager
      let name = this.getServiceNameBySvKey(5, key) || 'Visa';
      GTM[isAdded ? 'addToCart' : 'updateCard'](allData, cost, "Visa", this.tour, currency, name, "changeVisa", oldName, oldCost);
      // End Google Tag Manager
    },
    GTMRemoveVisa(key, allData, cost, currency, name, newCost) {
      // Google Tag Manager
      if (allData.IsNotCalculate) {
        GTM.removeFromCard(allData, cost, "Visa", this.tour, currency, name, "changeVisa");
      } else {
        GTM.updateCard(allData, newCost, "Visa", this.tour, currency, name, "changeVisa", name, cost);
      }
      // End Google Tag Manager
    },
    changeTrevelerVisa(key, e, key2) {
      const oldVal = this.visaValue[key][key2];
      this.$set(this.visaValue, key, e);

      if (this.readyForCalculate) {
        const isNotCalculate = !this.visaItems[key][key2][0].allData;
        const oldIndex = !isNotCalculate ? oldVal - 1 : oldVal;
        const oldSelectedItem = this.visaItems[key][key2][oldIndex];
        let oldCost = oldSelectedItem.cost;
        if (!isNotCalculate) oldCost = this.tourCardData.calculatedServicesPrice;
        const index = !isNotCalculate ? e[key2] - 1 : e[key2];
        const selectedItem = this.visaItems[key][key2][index];
        const isNotSelected = e.length === 1 && !selectedItem?.serviceAllData;
        const allData = this.visaItems[key][key2][index]?.serviceAllData ||
            this.visaItems[key][key2].find(x => x.serviceAllData)?.serviceAllData || {Id: null};
        const currency = this.$store.getters['getAllCurrency'].find(x => x.Code === this.tour.Rate).IsoCode;
        let newCost = selectedItem.cost;

        const oldName = this.getServiceNameBySvKey(5, key) || 'Visa';

        this.calculateTour()
            .then(() => {
              let isAdded = oldVal === 0;
              if (!isNotCalculate) {
                newCost = this.tourCardData.calculatedServicesPrice;
                isAdded = false
              }

              if (isNotSelected) {
                this.GTMRemoveVisa(key, allData, oldCost, currency, oldName, newCost)
              } else {
                this.GTMChangeVisa(key, allData, newCost, currency, isAdded, oldName, oldCost)
              }
            })
      }
    },
    rightModalBooking() {
      this.showRightModal = true;
      this.rigthModalType = "tourBooking";
    },
    scrollToBlock(block) {
      this[`${block}Show`] = true;
      let scrollBlock = this.$refs[block];
      if (!scrollBlock) return;

      this.$nextTick(() => {
        window.scrollTo({
          top: scrollBlock.offsetTop,
          behavior: "smooth"
        })
      })
    },
    additionalHotelServices() {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          const hotel = this.tour.Services.find(x => x.SvKey === 3);
          if (!hotel) {
            resolve();
            return
          }
          let services = this.services
              .filter(x => x.Service.ServiceType === 3)
              .map(x => {
                delete x.Service.IsCommission;
                delete x.Service.BaseFlightsParams;
                return x
              });

          const sendData = {
            BeginDate: this.tour.StartDate,
            Currency: this.tour.Rate,
            Duration: this.tour.Duration,
            Services: services,
            TourProgramId: this.tour.Key,
            Tourists: this.tourists
          }
          this.$store.dispatch("basket/" + typesBasket.A_ADDITIONAL_HOTEL_SERVICES, sendData)
              .then((res) => {
                this.$nextTick(() => {
                  let additionalServicesAndAges = res.map(x => {
                    return {
                      age: x.Age,
                      services: x.AdditionalServices
                    }
                  });
                  if (!additionalServicesAndAges.length) {
                    this.trevelerForm = this.trevelerForm.map((x, i) => {
                      this.$set(this.hotelServices, i, []);
                      x.services = x.services.filter(x2 => x2.svKey !== 13);
                      return x
                    });
                    resolve();
                    return
                  }

                  const title = additionalServicesAndAges[0].services[0].ServiceName;

                  this.trevelerForm = this.trevelerForm.map((x, i) => {
                    const service = {
                      items: [],
                      selectedIndexes: [],
                      svKey: 13,
                      title: title,
                    };

                    const ages = additionalServicesAndAges.map(x2 => x2.age);
                    const touristAge = this.tourists[i].Age;
                    if (ages.includes(touristAge)) {
                      this.$set(this.hotelServices, i, []);

                      const hasHotelService = x.services.map(x2 => x2.svKey).includes(13);
                      service.items = [additionalServicesAndAges.find(x3 => x3.age === touristAge).services];

                      if (hasHotelService) {
                        this.readyForCalculate = false;
                        x.services = x.services.map(x2 => {
                          if (x2.svKey === 13) {
                            return service
                          } else {
                            return x2
                          }
                        })
                      } else {
                        x.services.push(service);
                      }
                    } else {
                      this.$set(this.hotelServices, i, []);
                      x.services = x.services.filter(x2 => x2.svKey !== 13);
                    }

                    return x
                  });
                  resolve()
                })
              })
              .catch(e => {
                alert(e.data.Message);
                reject(e);
              })
        })
      })
    },
    toFlight() {
      const tour = {
        tour: this.tour,
        services: this.services,
        tourists: this.tourists
      }

      this.$store.dispatch("basket/" + typesBasket.A_SET_TOUR_INFO, tour)
      this.$nextTick(() => {
        this.routeFlight = true;
      })
    },
    correctTime(data) {
      const min = data.TotalTimeOfFlight || data.fligthTime;
      if (!min) return [0, 0];

      const h = Math.floor(min / 60);
      const m = min % 60;

      return [h, m]
    },
      dateValidation(item, key1, key2, key3 = null) {
        this.readyForCalculate = false;

      let start = new Date(item.dateFrom.replace(/\./g, "/"));
      let end = new Date(item.dateTo.replace(/\./g, "/"));
      let value = "";

      if (key3 !== null) {
        value = this.trevelerInfo[key1][key2][key3].value
      } else {
        value = this.trevelerInfo[key1][key2].value
      }
      value = value.split(".").reverse().join(".");
      let inputValue = value;
      value = new Date(value.replace(/\./g, "/"));
      if (key3 !== null) {
        // Получаем все объекты полей и фильтруем на получение дней рождений - из них высчитаем возрасты
        const birthdates = this.trevelerInfo.flat(3).filter(item => item.code === "birthdate").map(el => el.value)
        const formatted = birthdates.map(el =>{
          if(!el) return el;

          const [day, month, year] = el.split('.')
          return [year, month, day]
        })
        const maxAge = this.getSettings.ChildAgesSetting.at(-1);
        let maxInfantAge = this.getSettings.MaxInfantAge / 12;
        let ages = formatted.map(x => moment().diff(x, 'years')).map((x, index) => {return isNaN(x) ? this.oldAges[index] : (x == 0 ? 1 : x)});
        // Валидация возраста        
        this.hasAdultTourist = ages.some(age => age >= maxAge);

        if ((!this.hasAdultTourist && this.adultTouristsRequired) || value < start || value > end || value == "Invalid Date") {
          this.trevelerInfo[key1][key2][key3].isValid = false;
          this.readyForCalculate = true;
        } else {
          this.trevelerInfo[key1][key2][key3].isValid = true;
          if (item.Code !== "birthdate") {
            this.readyForCalculate = true;
            return;
          }
        }
        this.setTouristTitle();
        
        // Проверка разницы возрастов
        let needUpadte = false;
            for (let i = 0; i < this.trevelerForm.length; i++) {
              needUpadte = false;
              if ((ages[i] < maxAge && (this.oldAges[i] >= maxAge || ages[i] <= maxInfantAge || ages[i] != this.oldAges[i])) ||
                  (ages[i] >= maxAge && this.oldAges[i] < maxAge)) { 
                this.trevelerForm[i].age = ages[i]; 
                this.oldAges[i] = ages[i];
                needUpadte = true;
                break;
              }
            }
          // сделаем пересчет
          if (needUpadte) {
            this.calculateTour().then(() => this.readyForCalculate = true)
          }
          else
              this.readyForCalculate = true;
      ///
      if (!item.IsRequired && !inputValue.length) {
        this.trevelerInfo[key1][key2][key3].isValid = true;
        if (item.Code !== "birthdate") {
          this.readyForCalculate = true;
          return;
        }
          this.setTouristTitleAndCalculate();
        }
      } else {
        if (value < start || value > end || value == "Invalid Date") {
          this.trevelerInfo[key1][key2].isValid = false;
          this.readyForCalculate = true;
        } else {
          this.trevelerInfo[key1][key2].isValid = true;
          if (item.Code !== "birthdate") {
            this.readyForCalculate = true;
            return;
          }
          this.setTouristTitleAndCalculate();
        }
        if (!item.IsRequired && !inputValue.length) {
          this.trevelerInfo[key1][key2].isValid = true;
          if (item.Code !== "birthdate") {
            this.readyForCalculate = true;
            return;
          }

          this.setTouristTitleAndCalculate();
        }
      }
    },

    setTouristTitleAndCalculate() {
      this.setTouristTitle();
      this.calculateIndividualServiceCost()
          .then(() => {
            this.additionalHotelServices().finally(() => {

              // Если отел из в.с. и не все поля по дням рожд. заполнени,
              // то тогда делаем return и тем самым не визываем calculateTour
              if (this.residence.length > 0) {
                const allTouristsDateExist = this.trevelerInfo.every(x => this.getBirthDate(x));
                const remoteId = this.residence[0].allData.RemoteId;
                if (remoteId && !allTouristsDateExist) {
                  this.cardLoaderStatus = false;
                  return
                }

                }
              this.calculateTour().then(() => this.readyForCalculate = true)
            })
          })
    },

    getBirthDate(arr) {
      return arr.flat(1).find(x => x.code === "birthdate").value;
    },
    setTouristTitle() {
      this.trevelerForm = this.trevelerForm.map((x, i) => {
        let treveler = this.trevelerInfo[i];
        let trevelerEndView = [];
        treveler.forEach(x2 => {
          if (x2.length) {
            x2.forEach(x3 => trevelerEndView.push(x3))
          } else {
            trevelerEndView.push(x2)
          }
        });

        const birdDate = trevelerEndView.find(x => x.code === "birthdate").value;
        let age = +x.age;
        let month = +x.age * 12;
        let childMaxAge = 18;
        if (this.getSettings.ChildAgesSetting) {
          childMaxAge = this.getSettings.ChildAgesSetting.at(-1);
        }
        let maxInfantAge = this.getSettings.MaxInfantAge / 12;
        if (birdDate) {
          age = this.calcTouristAge(birdDate);
          month = this.calcTouristAge(birdDate, 'month');
          const ageType = age >= childMaxAge ? 0 : (month >= maxInfantAge ? 1 : 2);
          let touristType = ageType === 0 ? this.localizeList.adult : (ageType === 1 ? this.localizeList.child : this.localizeList.infant);
          touristType = touristType[0].toUpperCase() + touristType.slice(1);
          x.title = `${x.title.split('.')[0]}. ${touristType}`;
        }

        return x
      })
    },
    getErrorText(item) {
      return `${this.localizeList.wrongValue} "${item.HeaderText.split('<')[0]}"`
    },
    translit(item, key1, key2, key3 = null) {
      if (key3 !== null) {
        if (item.items[key3].Code.includes("date")) {
          this.dateValidation(item.items[key3], key1, key2, key3);
        }
      } else {
        if (item.Code.includes("date")) {
          this.dateValidation(item, key1, key2);
        }
      }

      if (key3 !== null) {
        return;
      }

      if (
          item.Code === "lastnamerus" ||
          item.Code === "firstnamerus" ||
          item.Code === "lastname" ||
          item.Code === "firstname" ||
          item.Code === "patronymic" ||
          item.Code === "patronymicrus" ||
          item.Code === "email" ||
          item.Code === "citizenid"
      ) {
        this.trevelerInfo[key1][key2].value = this.setCase(this.trevelerInfo[key1][key2].value, item.LetterCase);

        if (item.Translit) {
          const str = this.trevelerInfo[key1][key2].value;
          let translit = str;
          translit = this.$store.getters['translit'](str, 5);
          this.trevelerInfo[key1][key2].value = translit;
        }
      }
    },
    setCase(value, caseType) {
      if (!value) return value;

      if (caseType === 1) return value[0]?.toUpperCase() + value?.slice(1).toLowerCase();
      if (caseType === 2) return value.toUpperCase();
      if (caseType === 3) return value.toLowerCase();
      return value;
    },
    hotelInfoContentScroll(e) {
      const hotelInfoItems = Array.from(document.querySelectorAll(".hotel-info-content-item"));
      const hotelInfoItemsTop = hotelInfoItems.map(x => x.offsetTop);

      const scrollTop = e.target.scrollTop + e.target.offsetTop;
      this.hotelInfo.activeItem = hotelInfoItemsTop.findIndex(x => x > scrollTop);
    }
  },
  watch: {
    isAuthenticated(val){
      if (!val){
            this.calculatedCountry = null;
      }
    },
    async rigthModalType(val) {
      await this.$nextTick();

      if (val !== "hotelInfo") return;

      this.$refs.hotelInfoContent.addEventListener('scroll', this.hotelInfoContentScroll)
    },
    localizeList() {
      this.setBreadCrumbs()
    },
    "branches.list"(val) {
      if (val.length === 2 && this.branches.selected === 0) {
        this.setBranchesMenegers(this.tour, val[1].value);
        this.branches.selected = val[1].value
      }
    },
    showRightModal(val) {
      if (!val) {
        this.focusHotelVariantBtn = null;
        this.focusHotelDoneBtn = false;
        this.hotelInfo.activeItem = 0;
      }
    },
    getCurrency(val) {
      if (val && this.$route.path.includes("Basket")) {
        this.getTour();
        let isoCode = this.$route.fullPath.split('currency=')[1];
        isoCode = isoCode ? isoCode.split('&')[0] : isoCode;
        isoCode = isoCode ? isoCode.split('?')[0] : isoCode;
        this.tourRate = this.getCurrency.find(x => x.IsoCode === decodeURIComponent(isoCode)).Code
      }
    },
    touristValidStatus(val) {
      if (val) {
        this.openCard = true;     
      }
      if (!this.oldAges || !this.oldAges.length){
          this.oldAges = this.trevelerForm.map(x => x.age);
        }   
    },    //isAuthenticated
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.windowResize);
    window.removeEventListener("scroll", this.windowScroll);
    window.removeEventListener("mouseup", this.stopDragSecondSlider);
    window.removeEventListener("keydown", this.keydown)
  }
}
</script>

<style scoped>
.qui-quo-actions {
  margin-left: 16px;
  margin-bottom: 4px;
}
.basket .basket-headline {
  background-color: var(--white-color);
  padding: 28px 60px;
}

.basket .basket-headline h2 {
  font-weight: 500;
  font-size: 22px;
  line-height: 24px;
  color: var(--dark-1-color);
}

.basket .basket-headline h2 span:not(.tour-name) {
  color: #727272;
}

.basket .basket-content-wrap {
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 20px;
  padding: 20px 60px 60px;
}

.ie .basket .basket-content-wrap {
  display: flex;
}

.basket .basket-content-wrap.small {
  display: block;
}

.ie .basket .basket-content {
  width: 80%;
  margin-right: 20px;
}

.ie .basket .small .basket-content {
  width: 100%;
  margin-right: 0;
}

.basket .basket-content .block {
  background: var(--white-color);
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.11);
  border-radius: 4px;
  margin-bottom: 12px;
  transition: all .3s;
}

.basket .basket-content .block .block-toggle-bar {
  border-radius: 4px;
  background: var(--primary-color);
  padding: 12px 16px;
  cursor: pointer;
}

.basket .basket-content .block.show .block-toggle-bar {
  border-radius: 4px 4px 0 0;
}

.basket .basket-content .block .block-toggle-bar .block-name span {
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  color: var(--white-color);
}

.basket .basket-content .block .block-toggle-bar .angle-icon {
  transform: rotate(-90deg);
  transition: all .2s;
}

.basket .basket-content .block.show .block-toggle-bar .angle-icon {
  transform: rotate(90deg);
  transition: all .2s;
}

.basket .basket-content .block .change-btn {
  background: var(--primary-2-color);
  border: 1px solid #B2DBF8;
  box-sizing: border-box;
  border-radius: 20px;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #0094E9;
  padding: 10px 16px;
  transition: all .2s;
  outline: none;
}

.basket .basket-content .block .change-btn:hover {
  background: var(--primary-color);
  color: var(--white-color);
}

.basket .delta {
  color: #1C88D6;
  font-size: 13px;
  font-weight: bold;
  white-space: nowrap;
  position: absolute;
  top: -16px;
  left: 11px;
}

.basket .delta.plus {
  left: 8px;
}

.basket /deep/ .base-select2 .select {
  background-color: var(--white-color);
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 26px;
}

.basket .tour-booking {
  width: 840px;
}

.basket .tour-booking .tour-booking-name {
  font-weight: 500;
  font-size: 26px;
  line-height: 30px;
  color: #1D1D1D;
}

.basket .tour-booking .tour-booking-headline {
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: var(--lighten-5-color);
  margin-bottom: 32px;
}

/***MODAL HOTEL INFO***/
.basket .tour-hotel-info {
  padding: 38px 0;
  min-width: 678px;
  height: 100%;
}

.basket .tour-hotel-info .hotel-info-content {
  overflow-y: auto;
  height: calc(100vh - 170px);
  overflow-x: hidden;
  padding: 0 72px 60px;
}

.basket .hotel-info-header,
.basket .hotel-info-navbar {
  padding: 0 72px;
}

.basket .hotel-info-header {
  display: flex;
  gap: 24px;
}
.basket .hotel-info-header .hotel-info-header-block {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.basket .hotel-info-header .hotel-info-header-title {
  flex-grow: 1;
}
.basket .hotel-info-header .hotel-info-header-price {
  align-items: flex-end;
}

.basket .hotel-info-navbar {
  flex-wrap: wrap;
  max-width: 824px;
}

.basket .hotel-info-header .hotel-name {
  font-weight: 500;
  font-size: 26px;
  line-height: 30px;
  color: #1D1D1D;
}
.basket .hotel-info-header .hotel-name a {
  color: var(--primary-color);
}

.basket .hotel-info-header .hotel-price {
  font-weight: bold;
  font-size: 26px;
  line-height: 30px;
  color: var(--primary-color);
}

.basket .hotel-info-header .place {
  flex-wrap: wrap;
}

.basket .hotel-info-header .place .hotel-time-info {
  width: 100%;
  margin-left: 26px;
}

.basket .hotel-info-navbar .nav-item {
  position: relative;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: var(--dark-1-color);
}

.basket .hotel-info-navbar .nav-item:hover,
.basket .hotel-info-navbar .nav-item.active {
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #E56B13;
  cursor: pointer;
  transition: all .2s;
}

.basket .hotel-info-navbar .nav-item:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 2px;
  background-color: #FF711D;
  opacity: 0;
  transition: all .2s;
}

.basket .hotel-info-navbar .nav-item:hover:before,
.basket .hotel-info-navbar .nav-item.active:before {
  opacity: 1;
}

/**SLIDER**/
.basket .hotel-info-slider {
  width: 680px;
}

.basket .hotel-info-slider .present-slider {
  position: relative;
}

.basket .hotel-info-slider .present-slider .slide {
  width: 680px;
  height: 380px;
  border-radius: 6px;
  background-size: 102%;
  background-repeat: no-repeat;
  background-position: 50%;
  transition: all .2s;
}

.basket .hotel-info-slider .present-slider .slider-right-btn,
.basket .hotel-info-slider .present-slider .slider-left-btn {
  position: absolute;
  top: 50%;
}

.basket .hotel-info-slider .present-slider .slider-left-btn {
  left: -30px;
  transform: translateY(-50%);
}

.basket .hotel-info-slider .present-slider .slider-right-btn {
  right: -30px;
  transform: translateY(-50%) rotate(-180deg);
}

.basket .hotel-info-slider .second-slider {
  display: flex;
  overflow: hidden;
  width: 680px;
}

.basket .hotel-info-slider .second-slider .second-slide {
  position: relative;
  border-radius: 6px;
  min-width: 161px;
  height: 105px;
  background-color: #ededed;
  background-size: 102%;
  background-position: 50%;
  cursor: pointer;
}

.basket .hotel-info-slider .second-slider .second-slide:not(:last-child) {
  margin-right: 12px;
}

.basket .hotel-info-slider .second-slider .second-slide:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0);
  transition: all .2s;
}

.basket .hotel-info-slider .second-slider .active.second-slide:before,
.basket .hotel-info-slider .second-slider .second-slide:hover:before {
  background-color: rgba(0, 0, 0, .3);
}

.basket .hotel-features {
  display: flex;
  flex-wrap: wrap;
  width: 680px;
  margin-top: 26px;
  margin-bottom: 28px;
}

.basket .hotel-features .hotel-features-item {
  margin-right: 40px;
  margin-bottom: 6px;
}

.basket .hotel-info-content .hotel-info-content-item {
  width: 680px;
  margin-bottom: 28px;
}

.basket .hotel-info-content .hotel-info-content-item .active {
  color: #E56B13;
}

.basket .hotel-info-content .hotel-info-content-item /deep/ .hover.radio-btn:before {
  border: 2px solid var(--primary-color);
}

.basket .hotel-info-content .hotel-info-content-item .applay-btn {
  margin-left: auto;
  margin-top: 10px;
}

.basket .hotel-info-content .hotel-info-content-item .tour-program-item {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-top: 1px dashed var(--lighten-5-color);
}

.basket .hotel-info-content .hotel-info-content-item .tour-program-qui-quo-item {
  display: grid;
  grid-template-columns: 1fr 1fr 80px;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-top: 1px dashed var(--lighten-5-color);
}

.basket .hotel-info-content .hotel-info-content-item .tour-program-item:last-child {
  border-bottom: 1px dashed var(--lighten-5-color);
}

.basket .hotel-info-content .hotel-info-content-item .tour-program-item .tour-program-list-btn {
  justify-content: space-between;
}

.basket .hotel-info-content .hotel-info-content-item .tour-program-item .radio-btn {
  min-width: 106px;
  text-align: end;
  margin-left: 10px;
}

.basket .hotel-info-content .hotel-info-content-item .tour-program-item .radio-btn .include {
  color: var(--primary-color);
}

.basket .hotel-info-content .hotel-info-map-wrap {
  margin-bottom: 28px;
}

.basket .tour-booking {
  height: 100%;
  overflow: auto;
  padding: 40px 72px;
}

.basket .old-tour-error {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100000;
  background: #f1f2f6;
  align-items: flex-start;
}

.error-wrap {
  padding-top: 28px;
  display: flex;
  justify-content: center;
}

.server-off {
  width: 90vw;
  min-width: 970px;
  max-width: 1210px;
  background-color: #eee;
  border-radius: 6px;
  padding: 48px 60px;
}

.server-off .error-text {
  font-size: 24px;
  color: #333;
  margin: 20px 0 10px;
  font-family: Helvetica, Arial, sans-serif;
  font-weight: 500;
}

.basket .to-search {
  color: #428bca;
  font-size: 14px;
  cursor: pointer;
}

.tourist-validation-alert,
.alert-wrap {
  padding: 14px 20px;
}

.tourist-validation-alert p,
.alert-wrap p {
  color: var(--white-color);
}

/deep/ .base-alert {
    padding: 0;
}

/deep/ .right-modal.booking {
    max-width: 50%;
}

@media (max-width: 1246px) {
  .basket .railway-info .railway-group .railway-coontent,
  .basket .bus-info .bus-group .bus-coontent {
    grid-template-columns: minmax(190px, auto) 220px minmax(100px, auto) minmax(180px, auto);
  }

  .basket .excursion-info .excursion-group .excursion-coontent {
    grid-template-columns: 100px minmax(260px, 280px) 1fr auto;
    padding: 12px 16px 12px 12px;
  }
}
</style>